function onYouTubeIframeAPIReady () {
  theme.SlideshowVideo.loadVideos (), theme.ProductVideo.loadVideos (
    theme.ProductVideo.hosts.youtube
  );
}
(window.theme = window.theme || {}), (theme.Sections = function () {
  (this.constructors = {}), (this.instances = []), $ (document)
    .on ('shopify:section:load', this._onSectionLoad.bind (this))
    .on ('shopify:section:unload', this._onSectionUnload.bind (this))
    .on ('shopify:section:select', this._onSelect.bind (this))
    .on ('shopify:section:deselect', this._onDeselect.bind (this))
    .on ('shopify:block:select', this._onBlockSelect.bind (this))
    .on ('shopify:block:deselect', this._onBlockDeselect.bind (this));
}), (theme.Sections.prototype = _.assignIn ({}, theme.Sections.prototype, {
  _createInstance: function (e, t) {
    var i,
      s = $ (e),
      o = s.attr ('data-section-id'),
      a = s.attr ('data-section-type');
    (t = t || this.constructors[a]), _.isUndefined (t) ||
      ((i = _.assignIn (new t (e), {
        id: o,
        type: a,
        container: e,
      })), this.instances.push (i));
  },
  _onSectionLoad: function (t) {
    var e, i = $ ('[data-section-id]', t.target)[0];
    i &&
      (this._createInstance (i), (e = _.find (this.instances, function (e) {
        return e.id === t.detail.sectionId;
      })), !_.isUndefined (e) && _.isFunction (e.onLoad) && e.onLoad (t));
  },
  _onSectionUnload: function (i) {
    this.instances = _.filter (this.instances, function (e) {
      var t = e.id === i.detail.sectionId;
      return t && _.isFunction (e.onUnload) && e.onUnload (i), !t;
    });
  },
  _onSelect: function (t) {
    var e = _.find (this.instances, function (e) {
      return e.id === t.detail.sectionId;
    });
    !_.isUndefined (e) && _.isFunction (e.onSelect) && e.onSelect (t);
  },
  _onDeselect: function (t) {
    var e = _.find (this.instances, function (e) {
      return e.id === t.detail.sectionId;
    });
    !_.isUndefined (e) && _.isFunction (e.onDeselect) && e.onDeselect (t);
  },
  _onBlockSelect: function (t) {
    var e = _.find (this.instances, function (e) {
      return e.id === t.detail.sectionId;
    });
    !_.isUndefined (e) && _.isFunction (e.onBlockSelect) && e.onBlockSelect (t);
  },
  _onBlockDeselect: function (t) {
    var e = _.find (this.instances, function (e) {
      return e.id === t.detail.sectionId;
    });
    !_.isUndefined (e) &&
      _.isFunction (e.onBlockDeselect) &&
      e.onBlockDeselect (t);
  },
  register: function (e, i) {
    (this.constructors[e] = i), $ ('[data-section-type=' + e + ']').each (
      function (e, t) {
        this._createInstance (t, i);
      }.bind (this)
    );
  },
})), (window.slate = window.slate || {}), (slate.rte = {
  wrapTable: function (e) {
    e.$tables.wrap ('<div class="' + e.tableWrapperClass + '"></div>');
  },
  wrapIframe: function (e) {
    e.$iframes.each (function () {
      $ (this).wrap (
        '<div class="' + e.iframeWrapperClass + '"></div>'
      ), this.src;
    });
  },
}), (window.slate = window.slate || {}), (slate.a11y = {
  pageLinkFocus: function (e) {
    var t = 'js-focus-hidden';
    e
      .first ()
      .attr ('tabIndex', '-1')
      .focus ()
      .addClass (t)
      .one ('blur', function () {
        e.first ().removeClass (t).removeAttr ('tabindex');
      });
  },
  focusHash: function () {
    var e = window.location.hash;
    e && document.getElementById (e.slice (1)) && this.pageLinkFocus ($ (e));
  },
  bindInPageLinks: function () {
    $ ('a[href*=#]').on (
      'click',
      function (e) {
        this.pageLinkFocus ($ (e.currentTarget.hash));
      }.bind (this)
    );
  },
  trapFocus: function (t) {
    var e = t.namespace ? 'focusin.' + t.namespace : 'focusin';
    t.$elementToFocus || (t.$elementToFocus = t.$container), t.$container.attr (
      'tabindex',
      '-1'
    ), t.$elementToFocus.focus (), $ (document).off ('focusin'), $ (
      document
    ).on (e, function (e) {
      t.$container[0] === e.target ||
        t.$container.has (e.target).length ||
        t.$container.focus ();
    });
  },
  removeTrapFocus: function (e) {
    var t = e.namespace ? 'focusin.' + e.namespace : 'focusin';
    e.$container &&
      e.$container.length &&
      e.$container.removeAttr ('tabindex'), $ (document).off (t);
  },
}), (theme.Images = {
  preload: function (e, t) {
    'string' == typeof e && (e = [e]);
    for (var i = 0; i < e.length; i++) {
      var s = e[i];
      this.loadImage (this.getSizedImageUrl (s, t));
    }
  },
  loadImage: function (e) {
    new Image ().src = e;
  },
  switchImage: function (e, t, i) {
    var s = this.imageSize (t.src), o = this.getSizedImageUrl (e.src, s);
    i ? i (o, e, t) : (t.src = o);
  },
  imageSize: function (e) {
    var t = e.match (
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/
    );
    return null !== t ? (void 0 !== t[2] ? t[1] + t[2] : t[1]) : null;
  },
  getSizedImageUrl: function (e, t) {
    if (null === t) return e;
    if ('master' === t) return this.removeProtocol (e);
    var i = e.match (/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
    if (null === i) return null;
    var s = e.split (i[0]), o = i[0];
    return this.removeProtocol (s[0] + '_' + t + o);
  },
  removeProtocol: function (e) {
    return e.replace (/http(s)?:/, '');
  },
}), (theme.Currency = {
  formatMoney: function (e, t) {
    'string' == typeof e && (e = e.replace ('.', ''));
    var i = '', s = /\{\{\s*(\w+)\s*\}\}/, o = t || '${{amount}}';
    function a (e, t, i, s) {
      if (((i = i || ','), (s = s || '.'), isNaN (e) || null === e)) return 0;
      var o = (e = (e / 100).toFixed (t)).split ('.');
      return (
        o[0].replace (/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + i) +
        (o[1] ? s + o[1] : '')
      );
    }
    switch (o.match (s)[1]) {
      case 'amount':
        i = a (e, 2);
        break;
      case 'amount_no_decimals':
        i = a (e, 0);
        break;
      case 'amount_with_comma_separator':
        i = a (e, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        i = a (e, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        i = a (e, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        i = a (e, 2, "'");
    }
    return o.replace (s, i);
  },
}), (slate.Variants = (function () {
  function e (e) {
    (this.$container = e.$container), (this.product =
      e.product), (this.singleOptionSelector =
      e.singleOptionSelector), (this.originalSelectorId =
      e.originalSelectorId), (this.enableHistoryState =
      e.enableHistoryState), (this.currentVariant = this._getVariantFromOptions ()), $ (
      this.singleOptionSelector,
      this.$container
    ).on ('change', this._onSelectChange.bind (this));
  }
  return (e.prototype = _.assignIn ({}, e.prototype, {
    _getCurrentOptions: function () {
      var e = _.map ($ (this.singleOptionSelector, this.$container), function (
        e
      ) {
        var t = $ (e), i = t.attr ('type'), s = {};
        return (
          (('radio' !== i && 'checkbox' !== i) || !!t[0].checked) &&
          ((s.value = t.val ()), (s.index = t.data ('index')), s)
        );
      });
      return (e = _.compact (e));
    },
    _getVariantFromOptions: function () {
      var e = this._getCurrentOptions (), t = this.product.variants;
      return _.find (t, function (t) {
        return e.every (function (e) {
          return _.isEqual (t[e.index], e.value);
        });
      });
    },
    _onSelectChange: function () {
      var e = this._getVariantFromOptions ();
      this.$container.trigger ({type: 'variantChange', variant: e}), e &&
        (this._updateMasterSelect (e), this._updateImages (
          e
        ), this._updatePrice (e), this._updateSKU (
          e
        ), (this.currentVariant = e), this.enableHistoryState &&
          this._updateHistoryState (e));
    },
    _updateImages: function (e) {
      var t = e.featured_image || {},
        i = this.currentVariant.featured_image || {};
      e.featured_image &&
        t.src !== i.src &&
        this.$container.trigger ({type: 'variantImageChange', variant: e});
    },
    _updatePrice: function (e) {
      (e.price === this.currentVariant.price &&
        e.compare_at_price === this.currentVariant.compare_at_price) ||
        this.$container.trigger ({type: 'variantPriceChange', variant: e});
    },
    _updateSKU: function (e) {
      e.sku !== this.currentVariant.sku &&
        this.$container.trigger ({type: 'variantSKUChange', variant: e});
    },
    _updateHistoryState: function (e) {
      var t;
      history.replaceState &&
        e &&
        ((t =
          window.location.protocol +
          '//' +
          window.location.host +
          window.location.pathname +
          '?variant=' +
          e.id), window.history.replaceState ({path: t}, '', t));
    },
    _updateMasterSelect: function (e) {
      $ (this.originalSelectorId, this.$container).val (e.id);
    },
  })), e;
}) ()), (theme.Drawers = (function () {
  function e (e, t, i) {
    var s = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + t,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + t,
    };
    if (
      ((this.nodes = {
        $parent: $ ('html').add ('body'),
        $page: $ ('#PageContainer'),
      }), (this.config = $.extend (
        s,
        i
      )), (this.position = t), (this.$drawer = $ ('#' + e)), !this.$drawer
        .length)
    )
      return !1;
    (this.drawerIsOpen = !1), this.init ();
  }
  return (e.prototype.init = function () {
    $ (this.config.open).on (
      'click',
      $.proxy (this.open, this)
    ), this.$drawer.on ('click', this.config.close, $.proxy (this.close, this));
  }), (e.prototype.open = function (e) {
    var t = !1;
    return e ? e.preventDefault () : (t = !0), e &&
      e.stopPropagation &&
      (e.stopPropagation (), (this.$activeSource = $ (e.currentTarget))), this
      .drawerIsOpen && !t
      ? this.close ()
      : (this.$drawer.prepareTransition (), this.nodes.$parent.addClass (
          this.config.openClass + ' ' + this.config.dirOpenClass
        ), (this.drawerIsOpen = !0), slate.a11y.trapFocus ({
          $container: this.$drawer,
          namespace: 'drawer_focus',
        }), this.config.onDrawerOpen &&
          'function' == typeof this.config.onDrawerOpen &&
          (t || this.config.onDrawerOpen ()), this.$activeSource &&
          this.$activeSource.attr ('aria-expanded') &&
          this.$activeSource.attr (
            'aria-expanded',
            'true'
          ), this.bindEvents (), this);
  }), (e.prototype.close = function () {
    this.drawerIsOpen &&
      ($ (document.activeElement).trigger (
        'blur'
      ), this.$drawer.prepareTransition (), this.nodes.$parent.removeClass (
        this.config.dirOpenClass + ' ' + this.config.openClass
      ), (this.drawerIsOpen = !1), slate.a11y.removeTrapFocus ({
        $container: this.$drawer,
        namespace: 'drawer_focus',
      }), this.unbindEvents ());
  }), (e.prototype.bindEvents = function () {
    this.nodes.$parent.on (
      'keyup.drawer',
      $.proxy (function (e) {
        return 27 !== e.keyCode || (this.close (), !1);
      }, this)
    ), this.nodes.$page.on ('touchmove.drawer', function () {
      return !1;
    }), this.nodes.$page.on (
      'click.drawer',
      $.proxy (function () {
        return this.close (), !1;
      }, this)
    );
  }), (e.prototype.unbindEvents = function () {
    this.nodes.$page.off ('.drawer'), this.nodes.$parent.off ('.drawer');
  }), e;
}) ()), (theme.Helpers = (function () {
  var e = !1;
  return {
    setTouch: function () {
      e = !0;
    },
    isTouch: function () {
      return e;
    },
  };
}) ()), (theme.LibraryLoader = (function () {
  var u = 'link',
    h = 'script',
    p = {requested: 'requested', loaded: 'loaded'},
    e = 'https://cdn.shopify.com/shopifycloud/',
    m = {
      youtubeSdk: {
        tagId: 'youtube-sdk',
        src: 'https://www.youtube.com/iframe_api',
        type: h,
      },
      plyrShopifyStyles: {
        tagId: 'plyr-shopify-styles',
        src: e + 'shopify-plyr/v1.0/shopify-plyr.css',
        type: u,
      },
      modelViewerUiStyles: {
        tagId: 'shopify-model-viewer-ui-styles',
        src: e + 'model-viewer-ui/assets/v1.0/model-viewer-ui.css',
        type: u,
      },
    };
  return {
    load: function (e, t) {
      var i, s, o, a, n, r, c, l = m[e];
      if (l && l.status !== p.requested)
        if (((t = t || function () {}), l.status !== p.loaded)) {
          switch (((l.status = p.requested), l.type)) {
            case h:
              (n = l), (r = t), ((c = document.createElement ('script')).src =
                n.src), c.addEventListener ('load', function () {
                (n.status = p.loaded), r ();
              }), (i = c);
              break;
            case u:
              (s = l), (o = t), ((a = document.createElement ('link')).href =
                s.src), (a.rel = 'stylesheet'), (a.type =
                'text/css'), a.addEventListener ('load', function () {
                (s.status = p.loaded), o ();
              }), (i = a);
          }
          (i.id = l.tagId), (l.element = i);
          var d = document.getElementsByTagName (l.type)[0];
          d.parentNode.insertBefore (i, d);
        } else t ();
    },
  };
}) ()), (theme.Search = (function () {
  var c = {
    search: '.header__search, .mobile-header__search',
    searchInput: '.search__input',
    searchToggle: '.search__toggle',
    searchScreen: '.search__fullscreen',
    searchAjax: '.search__ajax.no-js',
    searchResults: '.search__results',
  },
    l = {};
  function e () {
    $ (document).off ('click', c.searchToggle), $ (
      document
    ).on ('click', c.searchToggle, function (e) {
      e.preventDefault ();
      var t,
        i,
        s,
        o = $ ('body'),
        a = $ (this).closest ('.header__search'),
        n = $ ('.search__label-text', a);
      a.hasClass ('opened')
        ? (o.removeClass ('search-opened'), a.removeClass ('opened'))
        : (o.addClass ('search-opened'), a.addClass ('opened'), $ (
            c.searchInput,
            a
          ).val (''), $ (c.searchResults, a).empty (), $ (
            c.searchInput,
            a
          ).focus ()), n.length &&
        '0' == n.attr ('data-first_time') &&
        (n.attr ('data-first_time', '1'), (t = a), void 0 !== $.fn.typed &&
          ((i =
            '^800 ' + $ ('.search__label-text', t).data ('typedtext')), (s = $ (
            '.search__label-text',
            t
          ).data ('typedtext_2')), $ ('.search__label-text', t).typed ({
            strings: [i, s],
            typeSpeed: 30,
            backSpeed: 20,
          }), $ ('.search__label', t).on ('click', function () {
            $ (this).fadeOut (200, function () {
              $ (this).addClass ('hide');
            }), $ (c.searchInput, t).focus ();
          })));
    }), $ (document).keyup (function (e) {
      var t;
      27 != e.keyCode ||
        ((t = $ (c.search)).hasClass ('opened') &&
          ($ ('body').removeClass ('search-opened'), t.removeClass ('opened')));
    }), $ (document).mouseup (function (e) {
      var t, i = $ (c.searchToggle), s = $ (c.searchScreen);
      i.is (e.target) ||
        0 !== i.has (e.target).length ||
        s.is (e.target) ||
        0 !== s.has (e.target).length ||
        ((t = $ (c.search)).hasClass ('opened') &&
          ($ ('body').removeClass ('search-opened'), t.removeClass ('opened')));
    });
  }
  return {
    init: function () {
      $ (c.search).length &&
        ($ (c.searchAjax).each (function () {
          var s = $ (this),
            o = s.find (c.searchInput),
            e = null,
            a = s.data ('limit'),
            n = s.data ('featured'),
            r = s.data ('featured_limit');
          o.off ('keyup'), o.on ('keyup', function () {
            clearTimeout (e), (e = setTimeout (function () {
              var e, t, i = o.val ();
              1 < i.length
                ? i in l
                    ? ((e = l[i]), $ (c.searchResults).html (e.html), $ (
                        e.html
                      ).find ('.not__found').length &&
                        !$ (e.html).find ('.featured_title').length
                        ? s.closest (c.searchScreen).removeClass ('searching')
                        : s.closest (c.searchScreen).addClass ('searching'))
                    : ($ (c.searchResults).empty (), (t = {
                        view: 'search',
                        type: 'product',
                        searched_limit: a,
                        featured: n,
                        featured_limit: r,
                        q: '*' + i + '*',
                        cache: !1,
                      }), $.ajax ({
                        url: '/search',
                        data: t,
                        dataType: 'html',
                        type: 'GET',
                        beforeSend: function () {
                          s.addClass ('loading').addClass ('searching');
                        },
                        complete: function () {
                          s.removeClass ('loading');
                        },
                        success: function (e) {
                          setTimeout (function () {
                            $ (c.searchResults).html (
                              e
                            ), $ (e).find ('.not__found').length && !$ (e).find ('.featured_title').length ? s.closest (c.searchScreen).removeClass ('searching') : s.closest (c.searchScreen).addClass ('searching'), (l[i] = {found: !0, html: e});
                          }, 650);
                        },
                      }))
                : $ (c.searchResults).empty ();
            }, 500));
          }), s.removeClass ('no-js');
        }), e ());
    },
  };
}) ()), (theme.CurrencyPicker = (function () {
  var e = '.currency__picker',
    t = '.currency__picker .ml__switcher .currency:not(.active)';
  return {
    init: function () {
      $ (e).length &&
        ($ (t).off ('click'), $ (t).on ('click', function (e) {
          e.preventDefault ();
          var t = $ (this).data ('iso_code'), i = $ (this).closest ('form');
          i.find ('[data-iso_code-input]').val (t), i.submit ();
        }));
    },
    formatMoney: function (e) {
      var t = (t = theme.Currency.formatMoney (
        e,
        theme.settings.moneyFormat
      )).replace (theme.settings.currencySymbol, '');
      return (
        '<span class="money"><span class="currency_symbol">' +
        theme.settings.currencySymbol +
        '</span>' +
        t +
        '</span>'
      );
    },
  };
}) ()), (theme.LanguagePicker = (function () {
  var e = '.language__picker',
    t = '.language__picker .ml__switcher .locale:not(.active)';
  return {
    init: function () {
      $ (e).length &&
        ($ (t).off ('click'), $ (t).on ('click', function (e) {
          e.preventDefault ();
          var t = $ (this).data ('iso_code'), i = $ (this).closest ('form');
          i.find ('[data-iso_code-input]').val (t), i.submit ();
        }));
    },
  };
}) ()), (theme.MiniCart = (function () {
  var a = {
    headerSticky: '.header-sticky__placeholder',
    headerCart: '.header__cart .cart__link',
    miniCart: '.minicart',
    miniCartAgree: '.minicart .cart__agree',
    miniCartCheckout: '.minicart .btn-checkout',
    miniCartRemove: '.minicart .item__remove',
    miniCartClose: '.minicart .cart__close, .minicart__overlay',
    miniCartQty: '.minicart .item__qty',
  };
  function o (e) {
    return void 0 === e && (e = 0), $ (a.miniCart).addClass (
      'loading'
    ), $.get ('/search', function (o) {
      $ (a.miniCart).each (function () {
        var e = $ (this), t = '';
        e.hasClass ('minicart-frame')
          ? (t = '.minicart-frame')
          : e.hasClass ('minicart-sidebar') && (t = '.minicart-sidebar');
        var i = $ (o).find (a.miniCart + t);
        e.removeClass ('loading').html (i.html ());
        var s = e.prev ();
        s.html (
          i.prev ().html ()
        ), s.addClass ('anim'), setTimeout (function () {
          s.removeClass ('anim');
        }, 2e3);
      }), 0 < e && $ ('.product__' + e + ' .addcart_btn').removeClass ('added');
    });
  }
  function e () {
    $ (document).off ('click', a.miniCartQty + ' .plus'), $ (
      document
    ).on ('click', a.miniCartQty + ' .plus', function () {
      var e = $ (this).parent ().find ('.qty'), t = parseInt (e.val ());
      (t += 1), e.val (t).trigger ('change');
    }), $ (document).off ('click', a.miniCartQty + ' .minus'), $ (
      document
    ).on ('click', a.miniCartQty + ' .minus', function () {
      var e = $ (this).parent ().find ('.qty'), t = parseInt (e.val ());
      1 < t && (--t, e.val (t).trigger ('change'));
    }), $ (document).off ('change', a.miniCartQty + ' .qty'), $ (
      document
    ).on ('change', a.miniCartQty + ' .qty', function () {
      var e,
        t,
        i = $ (this).closest ('form'),
        s = $ (this).closest ('.minicart');
      (e = s), (t = i), $.ajax ({
        type: 'POST',
        url: '/cart/update.js',
        async: !0,
        cache: !1,
        data: t.serialize (),
        dataType: 'json',
        beforeSend: function () {
          e.addClass ('loading');
        },
        success: function (e) {
          o ();
        },
      });
    });
  }
  return {
    init: function () {
      $ (document).off ('click', a.headerCart), $ (
        document
      ).on ('click', a.headerCart, function (e) {
        var t = $ (this).parent ().find (a.miniCart);
        t.length &&
          t.hasClass ('minicart-sidebar') &&
          ($ (a.miniCart).each (function () {
            t.attr ('id') != $ (this).attr ('id') &&
              $ (this).removeClass ('opened');
          }), t.hasClass ('opened')
            ? t.removeClass ('opened')
            : (t.addClass ('opened'), $ ('body').addClass (
                'cart-opened'
              ), theme.MiniCart.anim ()), e.preventDefault ());
      }), $ (document).off ('change', a.miniCartAgree), $ (
        document
      ).on ('change', a.miniCartAgree, function (e) {
        $ (this).is (':checked')
          ? ($ (a.miniCartAgree).prop ('checked', !0), $ (
              a.miniCartCheckout
            ).removeClass ('btn-disabled'))
          : ($ (a.miniCartAgree).prop ('checked', !1), $ (
              a.miniCartCheckout
            ).addClass ('btn-disabled'));
      }), $ (document).off ('click', a.miniCartCheckout), $ (
        document
      ).on ('click', a.miniCartCheckout, function (e) {
        var t, i;
        $ (a.miniCartAgree).length &&
          ((t = $ (a.miniCartAgree)).is (':checked') ||
            ((i = t.data ('message')), alert (i), e.preventDefault ()));
      }), $ (document).off ('click', a.miniCartRemove), $ (
        document
      ).on ('click', a.miniCartRemove, function (e) {
        e.preventDefault ();
        var t = $ (this), i = t.attr ('href'), s = t.data ('product_id');
        $ (a.miniCart).addClass ('loading'), $.post (i, function () {
          o (s);
        });
      }), $ (document).off ('click', a.miniCartClose), $ (
        document
      ).on ('click', a.miniCartClose, function () {
        $ (a.miniCart)
          .removeClass ('loading')
          .removeClass ('opened'), $ ('body').removeClass ('cart-opened');
      }), e ();
    },
    update: o,
    open: function () {
      if ($ (a.miniCart).length) {
        if (
          $ (a.headerSticky).length &&
          $ (a.headerSticky).hasClass ('stick')
        ) {
          var e = $ (a.headerSticky).find (a.headerCart);
          if (e.length) {
            var t = e.closest ('.header__cart').find (a.miniCart);
            if (
              t.length &&
              t.hasClass ('minicart-sidebar') &&
              !t.hasClass ('opened')
            )
              return e.trigger ('click'), !1;
          }
        }
        $ (a.headerCart).each (function () {
          var e = $ (this);
          if (e.is (':visible')) {
            var t = e.closest ('.header__cart').find (a.miniCart);
            if (
              t.length &&
              t.hasClass ('minicart-sidebar') &&
              !t.hasClass ('opened')
            )
              return e.trigger ('click'), !1;
          }
        });
      }
    },
    anim: function () {
      var e = new TimelineLite (),
        t = $ ('.minicart .cart__content'),
        i = $ ('.minicart .cart__item'),
        s = $ ('.minicart .cart__total'),
        o = $ ('.minicart .cart__free-shipping'),
        a = $ ('.minicart .cart__actions'),
        n = $ ('.minicart .cart__empty'),
        r = $ ('.minicart .cart__return');
      theme.settings.rtl
        ? (e.fromTo (
            t,
            0.5,
            {autoAlpha: 0},
            {autoAlpha: 1, ease: Power4.easeIn},
            0.1
          ), e.staggerFromTo (
            i,
            0.5,
            {opacity: 0, skewX: -20, x: -60},
            {opacity: 1, skewX: 0, x: 0},
            0.1,
            0.2
          ), e.fromTo (
            s,
            0.8,
            {opacity: 0, x: -80},
            {opacity: 1, x: 0},
            0.2
          ), e.fromTo (
            o,
            0.8,
            {opacity: 0, x: -80},
            {opacity: 1, x: 0},
            0.3
          ), e.fromTo (
            a,
            0.8,
            {opacity: 0, x: -80},
            {opacity: 1, x: 0},
            0.4
          ), e.fromTo (
            n,
            0.8,
            {opacity: 0, x: -80},
            {opacity: 1, x: 0},
            0.2
          ), e.fromTo (r, 0.8, {opacity: 0, x: -80}, {opacity: 1, x: 0}, 0.3))
        : (e.fromTo (
            t,
            0.5,
            {autoAlpha: 0},
            {autoAlpha: 1, ease: Power4.easeIn},
            0.1
          ), e.staggerFromTo (
            i,
            0.5,
            {opacity: 0, skewX: 20, x: 60},
            {opacity: 1, skewX: 0, x: 0},
            0.1,
            0.2
          ), e.fromTo (
            s,
            0.8,
            {opacity: 0, x: 80},
            {opacity: 1, x: 0},
            0.2
          ), e.fromTo (
            o,
            0.8,
            {opacity: 0, x: 80},
            {opacity: 1, x: 0},
            0.3
          ), e.fromTo (
            a,
            0.8,
            {opacity: 0, x: 80},
            {opacity: 1, x: 0},
            0.4
          ), e.fromTo (
            n,
            0.8,
            {opacity: 0, x: 80},
            {opacity: 1, x: 0},
            0.2
          ), e.fromTo (r, 0.8, {opacity: 0, x: 80}, {opacity: 1, x: 0}, 0.3));
    },
  };
}) ()), (function () {
  var e = $ ('.return-link');
  function i (e) {
    var t = document.createElement ('a');
    return (t.ref = e), t.hostname;
  }
  document.referrer &&
    e.length &&
    window.history.length &&
    e.one ('click', function (e) {
      e.preventDefault ();
      var t = i (document.referrer);
      return i (window.location.href) === t && history.back (), !1;
    });
}) (), (theme.SlideshowSection = (function () {
  function e (e) {
    var t = (this.$container = $ (e)),
      i = (this.sectionId = t.attr ('data-section-id')),
      s = (this.slideshow = '#Slideshow-' + i);
    $ ('.slideshow__video', s).each (function () {
      var e = $ (this);
      theme.SlideshowVideo.init (
        e
      ), theme.SlideshowVideo.loadVideo (e.attr ('id'));
    }), this.beforeInit (s), this.init ();
  }
  return (e.prototype = _.assignIn ({}, e.prototype, {
    beforeInit: function (i) {
      var e = 0.01 * window.innerHeight;
      document.documentElement.style.setProperty (
        '--vh',
        e + 'px'
      ), window.addEventListener ('resize', function () {
        var e, t = 0.01 * window.innerHeight;
        document.documentElement.style.setProperty (
          '--vh',
          t + 'px'
        ), $ (i).hasClass ('slideshow--auto') && 0 < $ (i).find ('.slideshow__slide.is-selected .slideshow__image_tag').length && ((e = $ (i).find ('.slideshow__slide.is-selected .slideshow__image_tag').height ()), $ (i).find ('.flickity-viewport').css ('height', e + 'px'));
      });
    },
    init: function () {
      var n = $ (this.slideshow),
        e = n.data ('autoplay'),
        t = n.data ('speed'),
        o = n.find ('.slideshow__image'),
        a = new Flickity (this.slideshow, {
          rightToLeft: theme.settings.rtl,
          bgLazyLoad: 1,
          imagesLoaded: !0,
          accessibility: !0,
          prevNextButtons: !0,
          pageDots: !0,
          contain: !0,
          wrapAround: !0,
          setGallerySize: !1,
          autoPlay: !!e && t,
          arrowShape: {x0: 10, x1: 60, y1: 50, x2: 60, y2: 45, x3: 15},
          on: {
            ready: function () {
              var e, t, i, s, o, a;
              n.hasClass ('slideshow--auto') &&
                0 <
                  n.find ('.slideshow__slide.is-selected .slideshow__image_tag')
                    .length &&
                ((e = n
                  .find ('.slideshow__slide.is-selected .slideshow__image_tag')
                  .height ()), n
                  .find ('.flickity-viewport')
                  .css ('height', e + 'px')), theme.settings.animation &&
                ((t = new TimelineLite ()), (i = n.find (
                  '.flickity-slider'
                )), (s = n.find ('.slider-content-wrapper')), (o = n.find (
                  '.flickity-button svg'
                )), (a = n.find ('.flickity-page-dots')), t.fromTo (
                  i,
                  2,
                  {scale: 1.2},
                  {ease: Power4.easeInOut, scale: 1},
                  0
                ), t.fromTo (
                  s,
                  2.4,
                  {opacity: 0},
                  {ease: Power4.easeInOut, opacity: 1},
                  1
                ), t.fromTo (
                  [o, a],
                  2,
                  {opacity: 0},
                  {ease: Power4.easeInOut, opacity: 1},
                  1.3
                ));
            },
            change: function (e) {
              var t, i;
              0 < $ (n.find ('.slideshow__slide')[e]).length &&
                ((t = $ (n.find ('.slideshow__slide')[e])
                  .find ('.slideshow__image_tag')
                  .height ()), n
                  .find ('.flickity-viewport')
                  .css ('height', t + 'px')), $ (
                n.find ('.slideshow__slide')[e]
              ).hasClass ('slideshow__video_background')
                ? ((i =
                    'SlideshowVideo-' +
                    $ (n.find ('.slideshow__slide')[e]).data ('block_id')), 0 <
                    $ ('#' + i).length && theme.SlideshowVideo.playVideo (i))
                : 0 < n.find ('.slideshow__video_item').length &&
                    n.find ('.slideshow__video_item').each (function (e) {
                      var t = 'SlideshowVideo-' + $ (this).data ('block_id');
                      0 < $ ('#' + t).length &&
                        theme.SlideshowVideo.pauseVideo (t);
                    });
            },
          },
        });
      a.on ('scroll', function () {
        a.slides.forEach (function (e, t) {
          var i = o[t], s = 0;
          i &&
            ((s = 0 === t
              ? Math.abs (a.x) > a.slidesWidth
                  ? a.slidesWidth +
                      a.x +
                      a.slides[a.slides.length - 1].outerWidth +
                      e.target
                  : e.target + a.x
              : t === a.slides.length - 1 &&
                  Math.abs (a.x) + a.slides[t].outerWidth < a.slidesWidth
                  ? e.target - a.slidesWidth + a.x - a.slides[t].outerWidth
                  : e.target + a.x), void 0 === window.mobileCheck ||
              window.mobileCheck () ||
              theme.settings.rtl ||
              (i.style.transform = 'translateX(' + -0.5 * s + 'px)'));
        });
      });
    },
    onSelect: function () {
      void 0 !== theme.roarAdminJs && theme.roarAdminJs.refresh ();
    },
  })), e;
}) ()), (theme.Slideshow = (function () {
  this.$slideshow = null;
  var h = {
    wrapper: 'slideshow-wrapper',
    slideshow: 'slideshow',
    currentSlide: 'slick-current',
    video: 'slideshow__video',
    videoBackground: 'slideshow__video--background',
    closeVideoBtn: 'slideshow__video-control--close',
    pauseButton: 'slideshow__pause',
    isPaused: 'is-paused',
  };
  function e (e) {
    (this.$slideshow = $ (e)), (this.$wrapper = this.$slideshow.closest (
      '.' + h.wrapper
    )), (this.$pause = this.$wrapper.find ('.' + h.pauseButton));
    var t = this.$slideshow.data ('arrows') || !1,
      i = this.$slideshow.data ('dots') || !1,
      s = this.$slideshow.data ('autoplay') || !1,
      o = parseInt (this.$slideshow.data ('speed')) || 7e3,
      a = parseInt (this.$slideshow.data ('per_view')) || 1;
    (this.settings = {
      mediaQueryMediumUp: 'screen and (min-width: 768px)',
      mediaQuerySmall: 'screen and (max-width: 767px)',
      arrows: t,
      dots: i,
      autoplay: s,
      speed: o,
      per_view: a,
      sliderImagesActive: !1,
    }), this.initBreakpoints ();
  }
  function p (e) {
    return e.find ('.' + h.video).length;
  }
  return (e.prototype = _.assignIn ({}, e.prototype, {
    initBreakpoints: function () {
      var e = this;
      enquire.register (e.settings.mediaQuerySmall, {
        match: function () {
          e.settings.sliderImagesActive &&
            e.destroyImageSlider (), e.initImageSlider ();
        },
      }), enquire.register (e.settings.mediaQueryMediumUp, {
        match: function () {
          e.settings.sliderImagesActive &&
            e.destroyImageSlider (), e.initImageSlider (!1);
        },
      });
    },
    destroyImageSlider: function () {
      $ (this.$slideshow).slick (
        'unslick'
      ), (this.settings.sliderImagesActive = !1);
    },
    initImageSlider: function (e) {
      void 0 === e && (e = !0);
      var t = {
        rtl: theme.settings.rtl,
        accessibility: !0,
        arrows: this.settings.arrows,
        dots: this.settings.dots,
        fade: !this.settings.per_view,
        speed: 1e3,
        delay: 1600,
        draggable: !0,
        autoplay: this.settings.autoplay,
        autoplaySpeed: this.settings.speed,
        slidesToShow: this.settings.per_view,
        slidesToScroll: 1,
        prevArrow: '<button class="slick-prev" type="button"><svg class="svg-icon"><use xlink:href="#global__symbols-prev"></use></svg></button>',
        nextArrow: '<button class="slick-next" type="button"><svg class="svg-icon"><use xlink:href="#global__symbols-next"></use></svg></button>',
      };
      1 == e &&
        ((t.fade = !1), (t.draggable = !0), (t.slidesToShow = 1), (t.arrows = !1), (t.dots = !0)), this.$slideshow.on (
        'beforeChange',
        function (e, t, i, s, o) {
          var a = t.$slider,
            n = a.find ('.' + h.currentSlide),
            r = a.find ('.slick-slide[data-slick-index="' + s + '"]');
          {
            var c, l;
            p (n) &&
              ((c = n.find ('.' + h.video)), (l = c.attr (
                'id'
              )), theme.SlideshowVideo.pauseVideo (l), c.attr (
                'tabindex',
                '-1'
              ));
          }
          {
            var d, u;
            p (r) &&
              ((d = r.find ('.' + h.video)), (u = d.attr ('id')), d.hasClass (
                h.videoBackground
              )
                ? theme.SlideshowVideo.playVideo (u)
                : d.attr ('tabindex', '0'));
          }
          n.removeClass ('slick-anim'), a
            .find ('.slick-slide[data-slick-index="' + o + '"]')
            .addClass ('slick-anim'), a
            .find ('.slick-arrow')
            .addClass ('disabled');
        }.bind (this)
      ), this.$slideshow.on (
        'afterChange',
        function (e, t, i) {
          t.$slider.find ('.slick-arrow').removeClass ('disabled');
        }.bind (this)
      ), this.$slideshow.on (
        'init',
        function (e, t) {
          var i = t.$slider,
            s = t.$list,
            o = this.$wrapper,
            a = this.settings.autoplay;
          s.removeAttr ('aria-live'), o.on ('focusin', function (e) {
            o.has (e.target).length &&
              (s.attr ('aria-live', 'polite'), a && i.slick ('slickPause'));
          }), o.on ('focusout', function (e) {
            if (o.has (e.target).length && (s.removeAttr ('aria-live'), a)) {
              if ($ (e.target).hasClass (h.closeVideoBtn)) return;
              i.slick ('slickPlay');
            }
          }), t.$dots &&
            t.$dots.on ('keydown', function (e) {
              37 === e.which &&
                i.slick (
                  'slickPrev'
                ), 39 === e.which && i.slick ('slickNext'), (37 !== e.which && 39 !== e.which) || t.$dots.find ('.slick-active button').focus ();
            });
          i.find ('.' + h.currentSlide).addClass ('slick-anim');
          var n = new TimelineLite (),
            r = i,
            c = i.find ('.slideshow__text-text'),
            l = i.find ('.slick-arrow svg'),
            d = i.find ('.slick-dots');
          n.fromTo (
            r,
            2,
            {scale: 1.2},
            {ease: Power4.easeInOut, scale: 1},
            0
          ), n.fromTo (
            c,
            2.4,
            {opacity: 0},
            {ease: Power4.easeInOut, opacity: 1},
            1
          ), n.fromTo (
            [l, d],
            2,
            {opacity: 0},
            {ease: Power4.easeInOut, opacity: 1},
            1.3
          );
        }.bind (this)
      ), this.$slideshow.slick (t), this.$pause.on (
        'click',
        this.togglePause.bind (this)
      ), (this.settings.sliderImagesActive = !0);
    },
    togglePause: function () {
      var e = '#Slideshow-' + this.$pause.data ('id');
      this.$pause.hasClass (h.isPaused)
        ? (this.$pause.removeClass (h.isPaused), $ (e).slick ('slickPlay'))
        : (this.$pause.addClass (h.isPaused), $ (e).slick ('slickPause'));
    },
  })), e;
}) ()), (theme.SlideshowVideo = (function () {
  var r = !1,
    c = !1,
    i = !1,
    l = !1,
    s = !1,
    d = {},
    u = [],
    a = {
      ratio: 16 / 9,
      playerVars: {
        iv_load_policy: 3,
        modestbranding: 1,
        autoplay: 0,
        controls: 0,
        showinfo: 0,
        wmode: 'opaque',
        branding: 0,
        autohide: 0,
        rel: 0,
      },
      events: {
        onReady: function (e) {
          e.target.setPlaybackQuality ('hd1080');
          var t = g (e);
          switch (((function () {
            if (i) return;
            ($ (window).width () < 750 ||
              (void 0 !== window.mobileCheck && window.mobileCheck ())) &&
              (l = !0);
            l && p (!1);
            i = !0;
          }) (), $ ('#' + t.id).attr ('tabindex', '-1'), v (), t.type)) {
            case 'background-chrome':
            case 'background':
              e.target.mute (), t.$parentSlide
                .closest ('.' + h.slickSlide)
                .hasClass (h.currentSlide) && o (t.id);
          }
          t.$parentSlide.addClass (h.loaded);
        },
        onStateChange: function (e) {
          var t = g (e);
          switch (e.data) {
            case 0:
              !(function (e) {
                switch (e.type) {
                  case 'background':
                    u[e.id].seekTo (0);
                    break;
                  case 'background-chrome':
                    u[e.id].seekTo (0), n (e.id);
                    break;
                  case 'chrome':
                    n (e.id);
                }
              }) (t);
              break;
            case 1:
              m (t);
              break;
            case 2:
              f (t);
          }
        },
      },
    },
    h = {
      playing: 'video-is-playing',
      paused: 'video-is-paused',
      loading: 'video-is-loading',
      loaded: 'video-is-loaded',
      slideshowWrapper: 'slideshow-wrapper',
      slide: 'slideshow__slide',
      slideBackgroundVideo: 'slideshow__slide--background-video',
      slideDots: 'slick-dots',
      videoChrome: 'slideshow__video--chrome',
      videoBackground: 'slideshow__video--background',
      playVideoBtn: 'slideshow__video-control--play',
      closeVideoBtn: 'slideshow__video-control--close',
      currentSlide: 'slick-current',
      slickSlide: 'slick-slide',
      slickClone: 'slick-cloned',
      supportsAutoplay: 'autoplay',
      supportsNoAutoplay: 'no-autoplay',
    };
  function o (e, t) {
    var i, s, o = d[e], a = u[e], n = d[e].$parentSlide;
    if (l) m (o);
    else if (t || (r && c))
      return n.removeClass (h.loading), m (o), void a.playVideo ();
    r ||
      ((s = n), (i = a).playVideo (), (function (e) {
        var t, i, s = $.Deferred ();
        return (t = setInterval (function () {
          e.getCurrentTime () <= 0 ||
            ((c = !0), clearInterval (t), clearTimeout (i), s.resolve ());
        }, 500)), (i = setTimeout (function () {
          clearInterval (t), s.reject ();
        }, 4e3)), s;
      }) (i)
        .then (function () {
          p (!0);
        })
        .fail (function () {
          p (!1), i.stopVideo ();
        })
        .always (function () {
          (r = !0), s.removeClass (h.loading);
        }));
  }
  function p (e) {
    var t = e ? h.supportsAutoplay : h.supportsNoAutoplay;
    $ (document.documentElement).addClass (t), e || (l = !0), (r = !0);
  }
  function m (e) {
    var t = e.$parentSlideshowWrapper, i = e.$parentSlide;
    if ((i.removeClass (h.loading), 'background' !== e.status)) {
      switch (($ ('#' + e.id).attr ('tabindex', '0'), e.type)) {
        case 'chrome':
        case 'background-chrome':
          t.removeClass (h.paused).addClass (h.playing), i
            .removeClass (h.paused)
            .addClass (h.playing);
      }
      i.find ('.' + h.closeVideoBtn).focus ();
    }
  }
  function f (e) {
    var t = e.$parentSlideshowWrapper, i = e.$parentSlide;
    'background-chrome' !== e.type
      ? ('closed' !== e.status &&
          'background' !== e.type &&
          (t.addClass (h.paused), i.addClass (h.paused)), 'chrome' === e.type &&
          'closed' === e.status &&
          (t.removeClass (h.paused), i.removeClass (h.paused)), t.removeClass (
          h.playing
        ), i.removeClass (h.playing))
      : n (e.id);
  }
  function n (e) {
    var t,
      i,
      s = d[e],
      o = s.$parentSlideshowWrapper,
      a = s.$parentSlide,
      n = [h.pause, h.playing].join (' ');
    switch (($ ('#' + s.id).attr ('tabindex', '-1'), (s.status =
      'closed'), s.type)) {
      case 'background-chrome':
        u[e].mute (), (t = e), (i = $ ('#' + t)
          .addClass (h.videoBackground)
          .removeClass (h.videoChrome)), d[t].$parentSlide.addClass (
          h.slideBackgroundVideo
        ), (d[t].status = 'background'), _ (i);
        break;
      case 'chrome':
        u[e].stopVideo (), f (s);
    }
    o.removeClass (n), a.removeClass (n);
  }
  function g (e) {
    var t = e.target.getIframe ().id;
    return d[t];
  }
  function t (t) {
    var e, i = d[t];
    switch ((i.$parentSlide.addClass (h.loading), (i.status =
      'open'), i.type)) {
      case 'background-chrome':
        (e = t), $ ('#' + e)
          .removeAttr ('style')
          .removeClass (h.videoBackground)
          .addClass (h.videoChrome), d[e].$parentSlideshowWrapper
          .removeClass (h.slideBackgroundVideo)
          .addClass (h.playing), d[e].$parentSlide
          .removeClass (h.slideBackgroundVideo)
          .addClass (h.playing), (d[e].status = 'open'), u[t].unMute (), o (
          t,
          !0
        );
        break;
      case 'chrome':
        o (t, !0);
    }
    $ (document).on ('keydown.videoPlayer', function (e) {
      27 === e.keyCode && n (t);
    });
  }
  function v () {
    $ ('.' + h.videoBackground).each (function (e, t) {
      _ ($ (t));
    });
  }
  function _ (e) {
    var t, i, s, o = e.closest ('.' + h.slide);
    o.hasClass (h.slickClone) ||
      ((t = o.width ()), (i = e.width ()), (s = e.height ()), t / a.ratio < s
        ? ((i = Math.ceil (s * a.ratio)), e
            .width (i)
            .height (s)
            .css ({left: (t - i) / 2, top: 0}))
        : ((s = Math.ceil (t / a.ratio)), e
            .width (t)
            .height (s)
            .css ({
              left: 0,
              top: (s - s) / 2,
            })), e.prepareTransition ().addClass (h.loaded));
  }
  function y () {
    $ (document).on ('click.videoPlayer', '.' + h.playVideoBtn, function (e) {
      t ($ (e.currentTarget).data ('controls'));
    }), $ (document).on ('click.videoPlayer', '.' + h.closeVideoBtn, function (
      e
    ) {
      n ($ (e.currentTarget).data ('controls'));
    }), $ (window).on (
      'resize.videoPlayer',
      $.debounce (250, function () {
        s && v ();
      })
    );
  }
  return {
    init: function (e) {
      var t, i;
      e.length &&
        ((d[e.attr ('id')] = {
          id: e.attr ('id'),
          videoId: e.data ('id'),
          type: e.data ('type'),
          status: 'chrome' === e.data ('type') ? 'closed' : 'background',
          videoSelector: e.attr ('id'),
          $parentSlide: e.closest ('.' + h.slide),
          $parentSlideshowWrapper: e.closest ('.' + h.slideshowWrapper),
          controls: 'background' === e.data ('type') ? 0 : 1,
          slideshow: e.data ('slideshow'),
        }), s ||
          (((t = document.createElement ('script')).src =
            'https://www.youtube.com/iframe_api'), (i = document.getElementsByTagName (
            'script'
          )[0]).parentNode.insertBefore (t, i)));
    },
    loadVideos: function () {
      for (var e in d) {
        var t;
        d.hasOwnProperty (e) &&
          (((t = $.extend ({}, a, d[e])).playerVars.controls = t.controls), (u[
            e
          ] = new YT.Player (e, t)));
      }
      y (), (s = !0);
    },
    loadVideo: function (e) {
      var t;
      s &&
        (((t = $.extend ({}, a, d[e])).playerVars.controls = t.controls), (u[
          e
        ] = new YT.Player (e, t)), y ());
    },
    playVideo: function (e) {
      (i || l) && e && 'function' == typeof u[e].playVideo && o (e);
    },
    pauseVideo: function (e) {
      u[e] && 'function' == typeof u[e].pauseVideo && u[e].pauseVideo ();
    },
    removeEvents: function () {
      $ (document).off ('.videoPlayer'), $ (window).off ('.videoPlayer');
    },
  };
}) ()), (function () {
  var e = $ ('#BlogTagFilter');
  e.length &&
    e.on ('change', function () {
      location.href = $ (this).val ();
    });
}) (), (window.theme = theme || {}), (theme.customerTemplates = (function () {
  function t () {
    $ ('#RecoverPasswordForm').toggleClass ('hide'), $ (
      '#CustomerLoginForm'
    ).toggleClass ('hide');
  }
  return {
    init: function () {
      var e;
      '#recover' === window.location.hash && t (), $ (document).off (
        'click',
        '#RecoverPassword'
      ), $ (document).on ('click', '#RecoverPassword', function (e) {
        e.preventDefault (), t ();
      }), $ (document).off ('click', '#HideRecoverPasswordLink'), $ (
        document
      ).on ('click', '#HideRecoverPasswordLink', function (e) {
        e.preventDefault (), t ();
      }), $ ('.reset-password-success').length &&
        $ ('#ResetSuccess').removeClass ('hide'), (e = $ ('#AddressNewForm'))
        .length &&
        (Shopify &&
          new Shopify.CountryProvinceSelector (
            'AddressCountryNew',
            'AddressProvinceNew',
            {hideElement: 'AddressProvinceContainerNew'}
          ), $ ('.address-country-option').each (function () {
          var e = $ (this).data ('form-id'),
            t = 'AddressCountry_' + e,
            i = 'AddressProvince_' + e,
            s = 'AddressProvinceContainer_' + e;
          new Shopify.CountryProvinceSelector (t, i, {hideElement: s});
        }), $ ('.address-new-toggle').on ('click', function () {
          e.toggleClass ('hide');
        }), $ ('.address-edit-toggle').on ('click', function () {
          var e = $ (this).data ('form-id');
          $ ('#EditAddress_' + e).toggleClass ('hide');
        }), $ ('.address-delete').on ('click', function () {
          var e = $ (this),
            t = e.data ('form-id'),
            i = e.data ('confirm-message');
          confirm (i || 'Are you sure you wish to delete this address?') &&
            Shopify.postLink ('/account/addresses/' + t, {
              parameters: {_method: 'delete'},
            });
        }));
    },
  };
}) ()), (theme.Cart = (function () {
  function e (e) {
    var t = (this.$container = $ (e)).attr ('data-section-id');
    (this.settings = {
      namespace: '#CartSection-' + t,
      sectionId: t,
    }), (this.selectors = {
      quantity: '.item__qty-' + t,
      agree: '#cart__agree-' + t,
      checkout: '.cart__checkout-' +
        t +
        ' [name="checkout"], .cart__checkout-' +
        t +
        ' [name="goto_pp"], .cart__checkout-' +
        t +
        ' [name="goto_gc"]',
      remove: '.item__remove-' + t,
      update: '.cart__update-' + t,
    }), this._qtyCart (), this._checkoutCart (), this._removeCart (), this._updateCart (), this._productsSlider ();
  }
  return (e.prototype = _.assignIn ({}, e.prototype, {
    _removeCart: function () {
      var s = this;
      $ (document).off ('click', s.selectors.remove), $ (
        document
      ).on ('click', s.selectors.remove, function (e) {
        e.preventDefault ();
        var t = $ (this).attr ('href'), i = $ (s.settings.namespace);
        i.addClass ('loading'), $.post (t, function () {
          $.get ('/cart?view=popup', function (e) {
            i.html (
              $ (e).find (s.settings.namespace).html ()
            ), setTimeout (function () {
              i.removeClass ('loading'), theme.MiniCart.update ();
              var e = new theme.Sections ();
              e.register (
                'cart-gift-popup',
                theme.CartGift
              ), e.register ('shipping-calculator-popup', theme.ShippingCalculator);
            }, 100);
          });
        });
      });
    },
    _updateCart: function () {
      var s = this;
      $ (document).off ('click', s.selectors.update), $ (
        document
      ).on ('click', s.selectors.update, function (e) {
        e.preventDefault ();
        var t = $ (this).closest ('form'), i = $ (s.settings.namespace);
        return $.ajax ({
          type: 'POST',
          url: '/cart/update.js',
          async: !0,
          cache: !1,
          data: t.serialize (),
          dataType: 'json',
          beforeSend: function () {
            i.addClass ('loading');
          },
          success: function (e) {
            $.get ('/cart?view=popup', function (e) {
              i.html (
                $ (e).find (s.settings.namespace).html ()
              ), setTimeout (function () {
                i.removeClass ('loading'), theme.MiniCart.update ();
                var e = new theme.Sections ();
                e.register (
                  'cart-gift-popup',
                  theme.CartGift
                ), e.register ('shipping-calculator-popup', theme.ShippingCalculator);
              }, 100);
            });
          },
        }), !1;
      });
    },
    _qtyCart: function () {
      $ (document).off ('click', this.selectors.quantity + ' .plus'), $ (
        document
      ).on ('click', this.selectors.quantity + ' .plus', function () {
        var e = $ (this).parent ().find ('.qty'), t = parseInt (e.val ());
        (t += 1), e.val (t);
      }), $ (document).off ('click', this.selectors.quantity + ' .minus'), $ (
        document
      ).on ('click', this.selectors.quantity + ' .minus', function () {
        var e = $ (this).parent ().find ('.qty'), t = parseInt (e.val ());
        0 < t && (--t, e.val (t));
      });
    },
    _checkoutCart: function () {
      var s = this;
      $ (s.selectors.agree).length &&
        ($ (document).off ('click', s.selectors.checkout), $ (
          document
        ).on ('click', s.selectors.checkout, function () {
          if ($ (s.selectors.agree).length) {
            var e = $ (this), t = $ (s.selectors.agree);
            if (!t.is (':checked')) {
              var i = t.data ('message');
              return alert (i), !1;
            }
            e.submit ();
          }
        }), $ (document).on ('change', s.selectors.agree, function (e) {
          $ (this).is (':checked')
            ? $ (s.selectors.checkout).removeClass ('btn-disabled')
            : $ (s.selectors.checkout).addClass ('btn-disabled');
        }));
    },
    _productsSlider: function () {
      new theme.Sections ().register (
        'products-slider-sub',
        theme.ProductsSlider
      );
    },
    _lineItem: function () {
      theme.roarJs.initReviews (), theme.roarJs.fixtooltipHover ();
      var e = new theme.Sections ();
      e.register ('line_item', theme.LineItem), e.register (
        'countdown-timer',
        theme.CountdownTimer
      );
    },
    onLoad: function () {
      this._lineItem ();
    },
    onUnload: function () {
      this.$container.off (this.settings.namespace);
    },
  })), e;
}) ()), (theme.ShippingCalculator = (function () {
  function ShippingCalculator (e) {
    var t = (this.$container = $ (e)).attr ('data-section-id');
    (this.selectors = {
      shipping_btn: '#cart__shipping-btn-' + t,
      shipping_calculator: '#shipping__calculator-' + t,
      get_rates: '#shipping__calculator-btn-' + t,
      response: '#shipping__calculator-response-' + t,
      template: '<p id ="shipping-rates-feedback-' +
        t +
        '" class="shipping-rates-feedback"></p>',
      address_country: 'address_country-' + t,
      address_province: 'address_province-' + t,
      address_zip: 'address_zip-' + t,
      address_province_label: 'address_province_label-' + t,
      address_province_container: 'address_province_container-' + t,
    }), (this.strings = {
      submitButton: theme.strings.shippingButton,
      submitButtonDisabled: theme.strings.shippingButtonDisabled,
      customerIsLoggedIn: theme.settings.customerIsLoggedIn,
      moneyFormat: theme.settings.moneyFormat,
    }), this._init ();
  }
  return (ShippingCalculator.prototype = _.assignIn (
    {},
    ShippingCalculator.prototype,
    {
      _disableButtons: function () {
        var e = this.selectors, t = this.strings;
        $ (e.get_rates)
          .text (t.submitButtonDisabled)
          .attr ('disabled', 'disabled')
          .addClass ('disabled');
      },
      _enableButtons: function () {
        var e = this.selectors, t = this.strings;
        $ (e.get_rates)
          .removeAttr ('disabled')
          .removeClass ('disabled')
          .text (t.submitButton);
      },
      _render: function (e) {
        var t,
          i,
          s = this.selectors,
          o = (this.strings, $ (s.template)),
          a = $ (s.response);
        a.length &&
          (e.success
            ? (o.addClass ('success'), e.rates
                ? (o.append (e.rates), (t = e.rates)[0] &&
                    ((i = t[0]), o.append (
                      'Versandkosten ab <span class="money">' +
                        i.price +
                        '</span>.'
                    )))
                : o.append ('We do not ship to this destination.'))
            : (o.addClass ('error'), o.append (e.errorFeedback)), o.appendTo (
            a
          ));
      },
      _formatRate: function (e) {
        this.selectors;
        var t = this.strings;
        if ('function' == typeof Shopify.formatMoney)
          return Shopify.formatMoney (e, t.moneyFormat);
        'string' == typeof e && (e = e.replace ('.', ''));
        var i = '', s = /\{\{\s*(\w+)\s*\}\}/, o = t.moneyFormat;
        function a (e, t) {
          return void 0 === e ? t : e;
        }
        function n (e, t, i, s) {
          if (
            ((t = a (t, 2)), (i = a (i, ',')), (s = a (s, '.')), isNaN (e) ||
              null == e)
          )
            return 0;
          var o = (e = (e / 100).toFixed (t)).split ('.');
          return (
            o[0].replace (/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + i) +
            (o[1] ? s + o[1] : '')
          );
        }
        switch (o.match (s)[1]) {
          case 'amount':
            i = n (e, 2);
            break;
          case 'amount_no_decimals':
            i = n (e, 0);
            break;
          case 'amount_with_comma_separator':
            i = n (e, 2, '.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            i = n (e, 0, '.', ',');
        }
        return o.replace (s, i);
      },
      _onCartShippingRatesUpdate: function (e, t) {
        var i = this.selectors;
        this.strings;
        this._enableButtons ();
        var s = '';
        if (
          (t.zip && (s += t.zip + ', '), t.province &&
            (s += t.province + ', '), (s += t.country), e.length)
        )
          for (var o = 0; o < e.length; o++)
            e[o].price = this._formatRate (e[o].price);
        this._render ({rates: e, address: s, success: !0}), $ (
          i.response
        ).fadeIn ();
      },
      _pollForCartShippingRatesForDestination: function (s) {
        var o = this,
          a = (this.selectors, this.strings, function () {
            $.ajax ('/cart/async_shipping_rates', {
              dataType: 'json',
              success: function (e, t, i) {
                200 === i.status
                  ? o._onCartShippingRatesUpdate (e.shipping_rates, s)
                  : setTimeout (a, 500);
              },
              error: function (e, t) {
                o._onError (e, t, o);
              },
            });
          });
        return a;
      },
      _fullMessagesFromErrors: function (e) {
        this.selectors, this.strings;
        var s = [];
        return $.each (e, function (i, e) {
          $.each (e, function (e, t) {
            s.push (i + ' ' + t);
          });
        }), s;
      },
      _onError: function (XMLHttpRequest, textStatus, self) {
        var selectors = self.selectors, strings = self.strings;
        self._enableButtons ();
        var feedback = '',
          data = eval ('(' + XMLHttpRequest.responseText + ')'),
          feedback = data.message
            ? data.message + '(' + data.status + '): ' + data.description
            : 'Error : ' +
                self._fullMessagesFromErrors (data).join ('; ') +
                '.';
        'Error : country is not supported.' === feedback &&
          (feedback = 'We do not ship to this destination.'), self._render ({
          rates: [],
          errorFeedback: feedback,
          success: !1,
        }), $ (selectors.response).show ();
      },
      _getCartShippingRatesForDestination: function (e) {
        var i = this;
        this.selectors, this.strings;
        $.ajax ({
          type: 'POST',
          url: '/cart/prepare_shipping_rates',
          data: $.param ({shipping_address: e}),
          success: i._pollForCartShippingRatesForDestination (e),
          error: function (e, t) {
            i._onError (e, t, i);
          },
        });
      },
      _init: function () {
        var e, t, i = this, s = this.selectors, o = this.strings;
        $ (s.shipping_calculator).length &&
          (new Shopify.CountryProvinceSelector (
            s.address_country,
            s.address_province,
            {hideElement: s.address_province_container}
          ), (e = $ ('#' + s.address_country)), (t = $ (
            '#' + s.address_province_label
          ).get (0)), 'undefined' != typeof Countries &&
            (Countries.updateProvinceLabel (
              e.val (),
              t
            ), e.change (function () {
              Countries.updateProvinceLabel (e.val (), t);
            })), $ (s.get_rates).off ('click'), $ (
            s.get_rates
          ).click (function () {
            i._disableButtons (), $ (s.response).empty ().hide ();
            var e = {};
            (e.zip =
              $ ('#' + s.address_zip).val () ||
              ''), (e.country = $ ('#' + s.address_country).val () || ''), (e.province = $ ('#' + s.address_province).val () || ''), i._getCartShippingRatesForDestination (e);
          }), o.customerIsLoggedIn &&
            $ (s.get_rates + ':eq(0)').trigger ('click'), $ (
            s.shipping_btn
          ).off ('click'), $ (s.shipping_btn).click (function () {
            $ (s.shipping_calculator).slideToggle ();
          }));
      },
    }
  )), ShippingCalculator;
}) ()), (theme.CartGift = (function () {
  function e (e) {
    var t = (this.$container = $ (e)).attr ('data-section-id');
    (this.selectors = {
      gift: '#gift__wrapping-' + t,
      namespace: '#CartSection-' + t,
      redirect: !0,
    }), this.init ();
  }
  return (e.prototype = _.assignIn ({}, e.prototype, {
    check: function () {
      var e = this.selectors;
      if ($ (e.gift).length)
        switch ($ (e.gift).data ('gift_case')) {
          case 1:
            this.remove ();
            break;
          case 2:
          case 3:
          case 3:
            this.set ();
        }
    },
    set: function () {
      var e, t, i, s, o = this.selectors;
      $ (o.gift).length &&
        ((e = $ (o.gift).data ('product_id')), ((t = new Object ())[
          e
        ] = 1), ((i = new Object ())[
          'gift-wrapping'
        ] = !0), ((s = new Object ()).updates = t), (s.attributes = i), $.ajax (
          {
            type: 'POST',
            url: '/cart/update.js',
            data: s,
            dataType: 'json',
            beforeSend: function () {
              o.redirect || $ (o.namespace).addClass ('loading');
            },
            success: function () {
              var t;
              o.redirect
                ? (location.href = '/cart')
                : ((t = $ (o.namespace)), $.get ('/cart?view=popup', function (
                    e
                  ) {
                    t.html (
                      $ (e).find (o.namespace).html ()
                    ), setTimeout (function () {
                      t.removeClass (
                        'loading'
                      ), theme.MiniCart.update (), new theme.Sections ().register ('shipping-calculator-popup', theme.ShippingCalculator);
                    }, 100);
                  }));
            },
          }
        ));
    },
    remove: function () {
      var e, t, i, s, o = this.selectors;
      $ (o.gift).length &&
        ((e = $ (o.gift).data ('product_id')), ((t = new Object ())[
          e
        ] = 0), ((i = new Object ())['gift-wrapping'] =
          ''), ((s = new Object ()).updates = t), (s.attributes = i), $.ajax ({
          type: 'POST',
          url: '/cart/update.js',
          data: s,
          dataType: 'json',
          beforeSend: function () {
            o.redirect || $ (o.namespace).addClass ('loading');
          },
          success: function () {
            var t;
            o.redirect
              ? (location.href = '/cart')
              : ((t = $ (o.namespace)), $.get ('/cart?view=popup', function (
                  e
                ) {
                  t.html (
                    $ (e).find (o.namespace).html ()
                  ), setTimeout (function () {
                    t.removeClass (
                      'loading'
                    ), theme.MiniCart.update (), new theme.Sections ().register ('shipping-calculator-popup', theme.ShippingCalculator);
                  }, 100);
                }));
          },
        }));
    },
    init: function () {
      var e = this, t = this.selectors;
      $ (t.gift).length &&
        (0 == $ (t.gift).data ('redirect') &&
          (this.selectors.redirect = !1), e.check (), $ (document).off (
          'change',
          t.gift
        ), $ (document).on ('change', t.gift, function () {
          $ (this).is (':checked') ? e.set () : e.remove ();
        }));
    },
  })), e;
}) ()), (theme.Filters = (function () {
  var i = 'sort_by',
    s = 'limit',
    o = 'view',
    d = 'constraint',
    a = '#PerPage',
    e = '#DefaultPerPage',
    n = '#SortBy',
    t = '#DefaultSortBy',
    r = '.shop__view',
    c = '#site-pagination a.btn',
    l = '#site-pagination .loadmore',
    u = '.advanced-filter .filter',
    h = '.site-widget.filtering .clear';
  function p (e) {
    var t = (this.$container = $ (e));
    (this.$limitSelect = $ (a, t)), (this.$sortSelect = $ (
      n,
      t
    )), (this.$selects = $ (a, t).add (
      $ (n, t)
    )), (this.defaultLimit = this._getDefaultLimitValue ()), (this.defaultSort = this._getDefaultSortValue ()), this._resizeSelect (
      this.$selects
    ), this.$selects.removeClass ('hidden'), this.$limitSelect.on (
      'change',
      this._onLimitChange.bind (this)
    ), this.$sortSelect.on ('change', this._onSortChange.bind (this)), $ (
      document
    ).on ('change', u, this._onFilterChange.bind (this)), $ (document).on (
      'click',
      h,
      this._onFilterClear.bind (this)
    ), $ (document).on ('click', c, this._onPageClick.bind (this)), $ (
      document
    ).on ('click', l, this._onLoadMoreClick.bind (this)), $ (document).on (
      'click',
      r,
      this._onViewClick.bind (this)
    ), this._onLoadMoreInfinite (
      l
    ), this._initFiltersHtml (), this._initFiltersActive (), this._filterClearAll ();
  }
  return (p.prototype = _.assignIn ({}, p.prototype, {
    _initFiltersHtml: function () {
      $ ('.shop__filtering').length &&
        $ ('.shop__filtering-inner')
          .empty ()
          .append ($ ('.site-sidebar').html ());
    },
    _initFiltersActive: function () {
      var i;
      $ ('.filters__active').length &&
        ((i = $ ('.filters__active .clear_nav').empty ()), $ (
          '.site-sidebar .site-widget.filtering'
        ).each (function () {
          var e, t = $ (this);
          t.find ('.filter-tag.active').length
            ? ((e = t.find ('.filter-tag.active label').clone ()), i.append (e))
            : t.find ('.filter-tag select').length &&
                '' != t.find ('.filter-tag select').val () &&
                ((e =
                  '<label for="' +
                  t.find ('.filter-tag input').attr ('id') +
                  '">' +
                  t.find ('.filter-tag select').val () +
                  '</label>'), i.append (e));
        }), i.find ('label').length
          ? $ ('.filters__active').show ()
          : $ ('.filters__active').hide ());
    },
    _filterClearAll: function () {
      var e = this;
      $ ('.filters__active').length &&
        $ ('.filters__active').on ('click', '.clear_all', function () {
          delete Shopify.queryParams[d], e._filterAjaxClick (!0);
        });
    },
    _onFilterClear: function (e) {
      var i = [];
      Shopify.queryParams[d] && (i = Shopify.queryParams[d].split ('+'));
      var t = $ (e.currentTarget).closest ('.site-widget.filtering'),
        s = t.find ('select');
      0 < s.length &&
        s.find ('option').each (function () {
          var e, t = $ (this).val ();
          !t || (0 <= (e = i.indexOf (t)) && i.splice (e, 1));
        });
      var o = t.find ('input');
      0 < o.length &&
        o.each (function () {
          var e, t = $ (this).val ();
          !t || (0 <= (e = i.indexOf (t)) && i.splice (e, 1));
        }), i.length
        ? (Shopify.queryParams[d] = i.join ('+'))
        : delete Shopify.queryParams[d], this._filterAjaxClick (!0);
    },
    _onFilterChange: function (e) {
      var t,
        i = $ (e.currentTarget),
        s = i.closest ('.advanced-filter'),
        o = i.closest ('.filter-tag'),
        a = s.data ('multi_choice'),
        n = [];
      Shopify.queryParams[d] && (n = Shopify.queryParams[d].split ('+')), 0 !=
        a ||
        o.hasClass ('active') ||
        (0 < (t = s.find ('.active input')).length &&
          t.each (function () {
            var e, t = $ (this).val ();
            !t || (0 <= (e = n.indexOf (t)) && n.splice (e, 1));
          }));
      var r = s.find ('select');
      0 < r.length &&
        r.find ('option').each (function () {
          var e, t = $ (this).val ();
          !t || (0 <= (e = n.indexOf (t)) && n.splice (e, 1));
        });
      var c, l = i.val ();
      l && (0 <= (c = n.indexOf (l)) ? n.splice (c, 1) : n.push (l)), n.length
        ? (Shopify.queryParams[d] = n.join ('+'))
        : delete Shopify.queryParams[d], this._filterAjaxClick (!0);
    },
    _onViewClick: function (e) {
      e.preventDefault ();
      var t = $ (e.currentTarget), i = $ (r), s = t.data ('view');
      'grid' == s && (s = s + '-' + t.data ('per_row')), (Shopify.queryParams[
        o
      ] = s), this._filterAjaxClick (), i.removeClass ('active'), t.addClass (
        'active'
      );
    },
    _onLoadMoreInfinite: function (e) {
      var t, i, s = $ (e).closest ('.ajax_load_button');
      s.hasClass ('ajax_load_hidden') &&
        ((t = '#site-primary .products'), (i = Math.abs (0)), $ (
          window
        ).scroll (function () {
          $ (t).length &&
            $ ('#site-pagination').find ('a.next').length &&
            $ (t).offset ().top +
              $ (t).outerHeight () -
              $ (window).scrollTop () -
              i <
              $ (window).height () &&
            0 == parseInt ($ (e).attr ('data-processing')) &&
            $ (e).trigger ('click');
        }));
    },
    _onLoadMoreClick: function (e) {
      e.preventDefault ();
      var t,
        i,
        s = '#site-pagination .loadmore',
        o = '#site-pagination .ajax_load_button',
        a = '#site-primary .products .product',
        n = '#site-pagination';
      1 != parseInt ($ (s).attr ('data-processing')) &&
        ($ (n).find ('a.next').length
          ? ($ (s).attr ('data-processing', 1), (t = $ (n)
              .find ('a.next')
              .attr ('href')), (i = $ (s).data ('no_more')), $ (o).addClass (
              'loading'
            ), $.get (t, function (e) {
              $ (n)
                .empty ()
                .html (
                  $ (e).find (n).html ()
                ), $ (e).find (a).each (function () {
                $ (a).last ().after ($ (this));
              }), $ (o).removeClass (
                'loading'
              ), $ (s).attr ('data-processing', 0), 0 == $ (n).find ('a.next').length && ($ (o).addClass ('ajax_load_finished').removeClass ('ajax_load_hidden'), $ (s).show ().html (i).addClass ('disabled').prop ('disabled', !0));
            }))
          : ((i = $ (s).attr ('data-no-more')), $ (o)
              .addClass ('ajax_load_finished')
              .removeClass ('ajax_load_hidden'), $ (s)
              .show ()
              .html (i)
              .addClass ('disabled')
              .prop ('disabled', !0)));
    },
    _onPageClick: function (e) {
      e.preventDefault ();
      var t = $ (e.currentTarget).attr ('href');
      this._filterGetContent (t);
    },
    _onSortChange: function (e) {
      var t = this.$sortSelect.val () || this.defaultSort;
      (Shopify.queryParams[
        i
      ] = t), this._filterAjaxClick (), this._resizeSelect ($ (e.target));
    },
    _onLimitChange: function (e) {
      var t = this.$limitSelect.val () || this.defaultLimit;
      (Shopify.queryParams[
        s
      ] = t), this._filterAjaxClick (), this._resizeSelect ($ (e.target));
    },
    _getDefaultLimitValue: function () {
      return $ (e, this.$container).val ();
    },
    _getDefaultSortValue: function () {
      return $ (t, this.$container).val ();
    },
    _resizeSelect: function (e) {
      e.each (function () {
        var e = $ (this),
          t = e.find ('option:selected').text (),
          i = $ ('<span>').html (t);
        i.appendTo ('body');
        var s = i.width ();
        i.remove (), e.width (s + 3);
      });
    },
    _filterAjaxClick: function (e) {
      void 0 === e && (e = !1), delete Shopify.queryParams.page;
      var t = this._filterCreateUrl ();
      this._filterGetContent (t, e);
    },
    _filterCreateUrl: function () {
      var e = $.param (Shopify.queryParams).replace (/%2B/g, '+');
      return location.pathname + '?' + e;
    },
    _filterGetContent: function (i, s) {
      void 0 === s && (s = !1);
      var o = '#site-primary .products',
        a = '#site-primary .product-found',
        n = '#site-primary .products .product',
        r = '#site-pagination',
        c = '#site-secondary .site-sidebar',
        l = this;
      $ ('body').removeClass ('sidebar-open'), $ (
        '.shop__filtering'
      ).slideUp ();
      var e = 40;
      $ ('#shopify-section-header-sticky').length &&
        $ ('#shopify-section-header-sticky').is (':visible')
        ? (e += $ ('#shopify-section-header-sticky').outerHeight ())
        : $ ('#shopify-section-header-mobile').length &&
            $ ('#shopify-section-header-mobile').is (':visible') &&
            (e += $ ('#shopify-section-header-mobile').outerHeight ()), $ (
        'html, body'
      ).animate (
        {scrollTop: $ ('#site-primary').offset ().top - e},
        1200
      ), $.ajax ({
        type: 'GET',
        url: i,
        beforeSend: function () {
          $ ('body').addClass ('loading');
        },
        complete: function () {
          $ ('body').removeClass ('loading');
        },
        success: function (e) {
          $.fn.countdown &&
            $ (o).find ('.product__countdown .is-countdown').each (function () {
              $ (this).countdown ('destroy');
            }), $ (r).empty ().html ($ (e).find (r).html ()), s &&
            ($ (c).empty ().html ($ (e).find (c).html ()), $ (
              '#site-primary .shop__filtering-inner'
            )
              .empty ()
              .append ($ (c).html ()), new theme.Sections ().register (
              'sidebar-sticky',
              theme.SidebarSticky
            )), $ (o)
            .empty ()
            .attr ('class', $ (e).find (o).attr ('class')), 0 <
            $ (e).find (n).length
            ? $ (e).find (n).each (function () {
                $ (o).append ($ (this));
              })
            : $ (o).append ($ (e).find ('#site-primary .no-products')), $ (a)
            .empty ()
            .html ($ (e).find (a).html ()), l._initFiltersActive ();
          var t = $ (e).filter ('title').text ();
          History.pushState ({param: Shopify.queryParams}, t, i);
        },
      });
    },
    _lineItem: function () {
      theme.roarJs.initReviews (), theme.roarJs.fixtooltipHover ();
      var e = new theme.Sections ();
      e.register ('line_item', theme.LineItem), e.register (
        'countdown-timer',
        theme.CountdownTimer
      );
    },
    onLoad: function () {
      this._lineItem ();
    },
    onUnload: function () {
      this.$limitSelect.off (
        'change',
        this._onLimitChange
      ), this.$sortSelect.off ('change', this._onSortChange), $ (document).off (
        'click',
        r,
        this._onViewClick
      ), $ (document).off ('click', c, this._onPageClick), $ (document).off (
        'click',
        l,
        this._onLoadMoreClick
      );
    },
  })), p;
}) ()), (theme.SidebarSticky = (function () {
  function e (e) {
    (this.$container = $ (e)).attr ('data-section-id');
    (this.settings = {
      selector: '#site-secondary .site-sidebar',
      primary: '#site-primary',
      toggle: '#site-secondary .site-widget__toggle',
    }), this.init (), this.update ();
  }
  return (e.prototype = _.assignIn ({}, e.prototype, {
    init: function (e) {
      var t, i, s, o = $ (this.settings.selector);
      $ (window).width () < 992 ||
        ((t = 40), (i = $ (this.settings.primary)), $ (
          '.site-header'
        ).hasClass ('header-sticky') && (t = 60), (s =
          o.outerHeight () - i.outerHeight ()) < -100
          ? o.stick_in_parent ({offset_top: t})
          : 100 < s && i.stick_in_parent ({offset_top: t}), $ (
          window
        ).resize (function () {
          $ (window).width () < 992
            ? (o.trigger ('sticky_kit:detach'), i.trigger ('sticky_kit:detach'))
            : o.outerHeight () < i.outerHeight ()
                ? o.stick_in_parent ({offset_top: t})
                : i.stick_in_parent ({offset_top: t});
        }));
    },
    update: function () {
      $ (this.settings.toggle).on ('change', function () {
        $ (document.body).trigger ('sticky_kit:recalc');
      });
    },
  })), e;
}) ()), (theme.HeaderMobile = (function () {
  function e (e) {
    (this.$container = $ (e)).attr ('data-section-id');
    (this.selectors = {
      headerFixed: '.header__mobile.is-fixed',
      navOpenIcon: '.mobile-nav__open',
      navCloseIcon: '.mobile-nav__close',
      navWrapper: '.mobile-header__nav .mobile__menu',
      megaMenu: '#phantom__menu',
    }), this._initHeaderFixed (), this._initMenu (), this._productsSlider (), theme.Search.init (), theme.MiniCart.init ();
  }
  return (e.prototype = _.assignIn ({}, e.prototype, {
    _animMenu: function () {
      var e = new TimelineLite (),
        t = $ ('.mobile__menu .listitem-0'),
        i = $ ('.mobile__menu .listitem-0 > .listitem > .site-nav__link');
      theme.settings.rtl
        ? (e.fromTo (
            t,
            0.1,
            {autoAlpha: 0},
            {autoAlpha: 1},
            0
          ), e.staggerFromTo (
            i,
            2,
            {opacity: 0, y: 150, x: -30, rotation: -10},
            {opacity: 1, y: 0, x: 0, rotation: 0, ease: Power4.easeInOut},
            0.08,
            -0.8
          ))
        : (e.fromTo (
            t,
            0.1,
            {autoAlpha: 0},
            {autoAlpha: 1},
            0
          ), e.staggerFromTo (
            i,
            2,
            {opacity: 0, y: 150, x: 30, rotation: 10},
            {opacity: 1, y: 0, x: 0, rotation: 0, ease: Power4.easeInOut},
            0.08,
            -0.8
          ));
    },
    _initHeaderFixed: function () {
      function e () {
        var e;
        i.is (':visible') &&
          ((e = i.outerHeight ()), i.addClass ('finished'), s.css (
            'height',
            e
          ));
      }
      function t () {
        var e = $ (window).scrollTop ();
        $ (s).offset ().top + o <= e
          ? $ (i).removeClass ('unstick').addClass ('stick')
          : $ (i).removeClass ('stick').addClass ('unstick');
      }
      var i, s, o;
      $ (this.selectors.headerFixed).length &&
        ((i = $ (this.selectors.headerFixed)), (s = i.parent ()), e (), $ (
          window
        ).resize (function () {
          e ();
        }), (o = 10), $ (s).offset ().top, t (), $ (
          window
        ).scroll (function () {
          t ();
        }));
    },
    _initMenu: function () {
      if (void 0 === $.fn.roarmenu) return !1;
      var e, t = this, i = t.selectors;
      $ (i.navWrapper).hasClass ('has-megamenu') &&
        $ (i.megaMenu).length &&
        ((e = $ ($ (i.megaMenu).val ()))
          .find ('.product__form')
          .remove (), e
          .find ('.site-nav__dropdown:not(.drilldown)')
          .removeAttr ('class')
          .removeAttr ('style'), e
          .find ('.drilldown')
          .removeAttr ('class')
          .addClass ('drilldown'), e
          .find ('.text-left')
          .removeClass ('text-left'), e
          .find ('.text-center')
          .removeClass ('text-center'), e
          .find ('.text-right')
          .removeClass ('text-right'), $ (i.navWrapper)
          .find ('.listitem-1')
          .remove (), $ (i.navWrapper + ' .listitem-0').prepend (
          e.find ('.site-nav__items > .site-nav__item').removeAttr ('class')
        )), $ (i.navWrapper).length &&
        $ (i.navWrapper).roarmenu ({
          navbar: {
            add: !0,
            close: 'mobile-nav__close',
            back: theme.strings.back,
            title: theme.strings.menu,
            titleLink: 'anchor',
          },
        }), $ (document).off ('click', i.navOpenIcon), $ (
        document
      ).on ('click', i.navOpenIcon, function (e) {
        e.preventDefault (), $ ('body').addClass ('menu-opened'), t._animMenu ();
      }), $ (document).off ('click', i.navCloseIcon), $ (
        document
      ).on ('click', i.navCloseIcon, function (e) {
        e.preventDefault (), $ ('body').removeClass ('menu-opened');
      });
    },
    _productsSlider: function () {
      new theme.Sections ().register (
        'products-slider-sub',
        theme.ProductsSlider
      );
    },
    _lineItem: function () {
      theme.roarJs.initReviews (), theme.roarJs.fixtooltipHover ();
      var e = new theme.Sections ();
      e.register ('line_item', theme.LineItem), e.register (
        'countdown-timer',
        theme.CountdownTimer
      );
    },
    onLoad: function () {
      this._lineItem ();
    },
  })), e;
}) ()), (theme.HeaderSection = (function () {
  function e (e) {
    (this.$container = $ (e)).attr ('data-section-id');
    this._initElements (), this._initSticky ();
  }
  return (e.prototype = _.assignIn ({}, e.prototype, {
    _initElements: function () {
      theme.Search.init (), theme.CurrencyPicker.init (), theme.LanguagePicker.init (), theme.MiniCart.init (), new theme.Sections ().register (
        'mega-menu',
        theme.MegaMenu
      );
    },
    _initSticky: function () {
      var t,
        e,
        i = '#shopify-section-header-sticky',
        s = '#shopify-section-header',
        o = '#shopify-section-header-topbar';
      $ (i).length &&
        ((t =
          $ (s).offset ().top +
          $ (s).outerHeight () +
          $ (o).outerHeight () +
          200), $ (window).scroll (function () {
          var e = $ (this).scrollTop ();
          $ (i).is (':visible') &&
            (e < t
              ? $ (i).hasClass ('stick') &&
                  ($ (i)
                    .removeClass ('stick')
                    .removeClass ('sticky-hide')
                    .addClass ('unstick'), 0)
              : $ (i).hasClass ('stick') ||
                  ($ (i).removeClass ('unstick').addClass ('stick'), 0));
        }), (e = $ (window).scrollTop ()), $ (s).offset ().top +
          $ (s).outerHeight () +
          $ (o).outerHeight () +
          200 <=
          e && $ (i).addClass ('stick'));
    },
  })), e;
}) ()), (theme.MegaMenu = (function () {
  function e () {
    this._initMenu (), this._navigationInit (), this._productsSlider ();
  }
  return (e.prototype = _.assignIn ({}, e.prototype, {
    _initMenu: function () {
      var t,
        i = '#phantom__menu',
        e = '.header__menu',
        s = '.header__menu-left',
        o = '.header__menu-right';
      $ (i).length &&
        $ (e).length &&
        $ (e).each (function () {
          var e = $ (i).val ();
          $ (this).empty ().append (e);
        }), $ (i).length &&
        $ (s).length &&
        ((t = $ ($ (i).val ()))
          .find ('.site-nav__items > .site-nav__item')
          .each (function () {
            $ (this).hasClass ('pull-right') && $ (this).remove ();
          }), $ (s).each (function () {
          var e = t.clone ();
          $ (this).empty ().append (e);
        })), $ (i).length &&
        $ (o).length &&
        ((t = $ ($ (i).val ()))
          .find ('.site-nav__items > .site-nav__item')
          .each (function () {
            $ (this).hasClass ('pull-right') || $ (this).remove ();
          }), $ (o).each (function () {
          var e = t.clone ();
          $ (this).empty ().append (e);
        }));
    },
    _navigationInit: function () {
      var e = [
        '.site-navigation .site-nav__items > .site-nav--has-dropdown',
        '.my-account-has-drop',
        '.currency__picker .has-drop',
        '.language__picker .has-drop',
      ].join (', ');
      $ (e)
        .mouseenter (function (e) {
          $ (this)
            .closest ('.site-header-main, .header-sticky__placeholder')
            .attr (
              'data-sticky',
              'visible'
            ), $ ('.site-overlay').addClass ('visible');
        })
        .mouseleave (function (e) {
          $ ('.site-overlay').removeClass (
            'visible'
          ), $ (this).closest ('.site-header-main, .header-sticky__placeholder').removeAttr ('data-sticky', 'visible');
        });
    },
    _productsSlider: function () {
      new theme.Sections ().register (
        'products-slider-sub',
        theme.ProductsSlider
      );
    },
    _lineItem: function () {
      theme.roarJs.initReviews (), theme.roarJs.fixtooltipHover ();
      var e = new theme.Sections ();
      e.register ('line_item', theme.LineItem), e.register (
        'countdown-timer',
        theme.CountdownTimer
      );
    },
    onLoad: function () {
      this._lineItem ();
    },
  })), e;
}) ()), (theme.VerticalMenu = (function () {
  function e () {
    this.init ();
  }
  return (e.prototype = _.assignIn ({}, e.prototype, {
    init: function () {
      var t = '.phantom__menu-vertical .site-nav__vertical',
        e = '.header__menu-vertical';
      $ (t).length &&
        $ (e).length &&
        $ (e).each (function () {
          var e = $ (t).clone ();
          $ (this).empty ().append (e);
        });
    },
  })), e;
}) ()), (theme.Maps = (function () {
  var d = 19,
    t = null,
    i = [],
    o = {
      addressNoResults: theme.strings.addressNoResults,
      addressQueryLimit: theme.strings.addressQueryLimit,
      addressError: theme.strings.addressError,
      authError: theme.strings.authError,
    },
    e = '[data-section-type="map"]',
    s = '[data-map]',
    a = '[data-map-overlay]',
    n = 'map-section--load-error',
    r = 'map-section__error errors text-center';
  function c (e) {
    (this.$container = $ (e)), (this.$map = this.$container.find (
      s
    )), (this.key = this.$map.data ('api-key')), void 0 !== this.key &&
      ('loaded' === t
        ? this.createMap ()
        : (i.push (this), 'loading' !== t &&
            ((t = 'loading'), void 0 === window.google &&
              $.getScript (
                'https://maps.googleapis.com/maps/api/js?key=' + this.key
              ).then (function () {
                (t = 'loaded'), $.each (i, function (e, t) {
                  t.createMap ();
                });
              }))));
  }
  return (window.gm_authFailure = function () {
    Shopify.designMode &&
      ($ (e).addClass (n), $ (s).remove (), $ (a).after (
        '<div class="' + r + '">' + theme.strings.authError + '</div>'
      ));
  }), (c.prototype = _.assignIn ({}, c.prototype, {
    createMap: function () {
      var e, i, t, s, l = this.$map;
      return (e = l), (i = $.Deferred ()), (t = new google.maps
        .Geocoder ()), (s = e.data ('address-setting')), t.geocode (
        {address: s},
        function (e, t) {
          t !== google.maps.GeocoderStatus.OK && i.reject (t), i.resolve (e);
        }
      ), i
        .then (
          function (e) {
            var t = [];
            (t[0] = {}), (t[1] = {}), (t[2] = {});
            var i = [];
            (i[0] = {}), (i[1] = {}), (i[2] = {}), (i[3] = {}), (i[4] = {}), (i[5] = {}), (i[6] = {}), (i[7] = {}), (i[8] = {}), (i[9] = {}), (i[10] = {}), (i[11] = {}), (i[12] = {});
            var s = [
              {
                featureType: 'poi',
                elementType: 'labels',
                stylers: [{visibility: 'off'}],
              },
              {
                featureType: 'road.local',
                elementType: 'labels.icon',
                stylers: [{visibility: 'off'}],
              },
              {
                featureType: 'road.arterial',
                elementType: 'labels.icon',
                stylers: [{visibility: 'off'}],
              },
              {
                featureType: 'road',
                elementType: 'geometry.stroke',
                stylers: [{visibility: 'off'}],
              },
              {
                featureType: 'transit',
                elementType: 'geometry.fill',
                stylers: [
                  {hue: '#dadeef'},
                  {visibility: 'on'},
                  {lightness: 1},
                  {saturation: 7},
                ],
              },
              {elementType: 'labels', stylers: [{saturation: -100}]},
              {
                featureType: 'poi',
                elementType: 'geometry.fill',
                stylers: [
                  {hue: '#dadeef'},
                  {visibility: 'on'},
                  {lightness: 20},
                  {saturation: 7},
                ],
              },
              {
                featureType: 'landscape',
                stylers: [
                  {hue: '#dadeef'},
                  {visibility: 'on'},
                  {lightness: 20},
                  {saturation: 20},
                ],
              },
              {
                featureType: 'road',
                elementType: 'geometry.fill',
                stylers: [
                  {hue: '#dadeef'},
                  {visibility: 'on'},
                  {lightness: 1},
                  {saturation: 7},
                ],
              },
              {
                featureType: 'water',
                elementType: 'geometry',
                stylers: [
                  {hue: '#dadeef'},
                  {visibility: 'on'},
                  {lightness: 1},
                  {saturation: 7},
                ],
              },
              i[0],
              i[1],
              i[2],
              i[3],
              i[4],
              i[5],
              i[6],
              i[7],
              i[8],
              i[9],
              i[10],
              i[11],
              i[12],
              t[0],
              t[1],
              t[2],
            ],
              o = new google.maps.StyledMapType (s, {name: 'Styled Map'}),
              a = {
                center: e[0].geometry.location,
                zoom: d,
                mapTypeControlOptions: {
                  mapTypeIds: [google.maps.MapTypeId.ROADMAP, 'map_style'],
                },
                scrollwheel: !1,
                panControl: !1,
                zoomControl: 1,
                disableDoubleClickZoom: 1,
                zoomControlOptions: {
                  style: google.maps.ZoomControlStyle.LARGE,
                  position: google.maps.ControlPosition.LEFT_CENTER,
                },
                mapTypeControl: !1,
                scaleControl: !1,
                streetViewControl: !1,
                fullscreenControlOptions: {
                  position: google.maps.ControlPosition.RIGHT_BOTTOM,
                },
              },
              n = (this.map = new google.maps.Map (l[0], a));
            n.mapTypes.set ('map_style', o), n.setMapTypeId ('map_style');
            var r = (this.center = n.getCenter ()),
              c = new google.maps.OverlayView ();
            (c.draw = function () {
              var e = this.div_;
              e ||
                (((e = this.div_ = $ (
                  '<div><div class="animated-dot"><div class="pin"></div><div class="pulse"></div></div></div>'
                )[0]).style.position =
                  'absolute'), (e.style.paddingLeft = '0px'), (e.style.cursor =
                  'pointer'), this.getPanes ().overlayImage.appendChild (e));
            }), c.setMap (n), google.maps.event.addDomListener (
              window,
              'resize',
              $.debounce (250, function () {
                google.maps.event.trigger (
                  n,
                  'resize'
                ), n.setCenter (r), l.removeAttr ('style');
              })
            );
          }.bind (this)
        )
        .fail (function () {
          var e;
          switch (status) {
            case 'ZERO_RESULTS':
              e = o.addressNoResults;
              break;
            case 'OVER_QUERY_LIMIT':
              e = o.addressQueryLimit;
              break;
            case 'REQUEST_DENIED':
              e = o.authError;
              break;
            default:
              e = o.addressError;
          }
          Shopify.designMode &&
            l
              .parent ()
              .addClass (n)
              .html ('<div class="' + r + '">' + e + '</div>');
        });
    },
    onUnload: function () {
      0 !== this.$map.length &&
        google.maps.event.clearListeners (this.map, 'resize');
    },
  })), c;
}) ()), (theme.Product = (function () {
  function e (e) {
    var t = (this.$container = $ (e)), i = t.attr ('data-section-id');
    (this.settings = {
      mediaQueryLargeUp: 'screen and (min-width: 992px)',
      mediaQueryMedium: 'screen and (max-width: 991px)',
      mediaQueryMediumUp: 'screen and (min-width: 768px)',
      mediaQuerySmall: 'screen and (max-width: 767px)',
      enableHistoryState: t.data ('enable-history-state') || !1,
      namespace: '.ProductSection-' + i,
      sectionId: i,
      sectionType: t.data ('section-type'),
      zoomEnabled: !1,
      sliderThumbsActive: !1,
      sliderImagesActive: !1,
      swatchColor: t.data ('product_swatch_color'),
      swatchColorAdvanced: t.data ('product_swatch_color_advanced'),
      swatchSize: t.data ('product_swatch_size'),
    }), (this.selectors = {
      container: t,
      inComing: '.InComing-' + i,
      addToCart: '.AddToCart-' + i,
      addToCartText: '.AddToCartText-' + i,
      comparePrice: '.ComparePrice-' + i,
      originalPrice: '.ProductPrice-' + i,
      SKU: '.product-single__sku',
      originalSelectorId: '.ProductSelect-' + i,
      productImage: '.ProductImage-' + i,
      productImages: '.product-single__photos-' + i,
      productImageWraps: '.product-single__photo-' + i,
      productVideo: '.product-single__video-' + i,
      productVideoWrap: '.product-single__video-wrapper',
      productPrices: '.product-single__price-' + i,
      productThumbs: '.product-single__thumbnails-' + i,
      productNav: '.product-single__nav-' + i,
      singleOptionSelector: '.single-option-selector-' + i,
      singleOptionSelectorId: '.single-option-selector-' + i,
      singleOptionSwatches: 'tawcvs-swatches-' + i,
      sizeChart: '.sizechart_btn',
      productContent: '.product-single__content',
      productQuantity: '.product-form__item--quantity',
      productTabs: '.product-single__tabs',
      productReviews: '.product-single__review',
      productGalleryTrigger: '.product-single__photo.photoswipe-enabled',
      productVideoTrigger: '.product-single__show-video',
      recentlyViewed: '.recently-viewed-' + i,
      cartAgree: '#product-cart__agree-' + i,
      cartCheckout: '#product-buy__1click-' + i,
      stockCountdown: '#product-single__stock-' + i,
      visitorCounter: '#product-single__visitor-' + i,
      totalSold: '#product-single__sold-' + i,
      productThumbImages: '.product-single__thumbnail--' + i,
      productThumbImagesWrapper: '.product-single__thumbnails-' + i,
      productThumbListItem: '.product-single__thumbnails-item',
      productMediaWrapper: '[data-product-single-media-wrapper]',
      productMediaTypeVideo: ':not(.slick-cloned)[data-product-media-type-video]',
      productMediaTypeModel: '[data-product-media-type-model]',
    }), (this.classes = {
      hidden: 'classes-hide',
      visibilityHidden: 'visibility-hidden',
      activeClass: 'active-thumb',
      jsZoomEnabled: 'js-zoom-enabled',
    }), $ ('.ProductJson-' + i, t).html () &&
      ((this.productSingleObject = JSON.parse (
        $ ('.ProductJson-' + i, t).html ()
      )), (this.productSwatchSingleObject = JSON.parse (
        $ ('.ProductSwatchJson-' + i, t).html ()
      )), (this.productMoreSingleObject = JSON.parse (
        $ ('.ProductMoreJson-' + i, t).html ()
      )), (this.settings.zoomEnabled = $ (
        this.selectors.productImageWraps
      ).hasClass (
        'zoom-enabled'
      )), this._updateProductObject (), this._initBreakpoints (), this._initVariants (), this._initSwatches (), this._initMediaSwitch (), this._initReviews (), this._initQuantity (), this._productInView (), 'product-template' ==
        this.settings.sectionType &&
        (this._initGalleryZoom (), this._initVideoZoom (), this._initTabs (), this._stickyDetails (), this._recordRecentlyViewed (), this._sizeChart (), this._checkoutCart (), this._initStockCountdown (), this._visitorCounter (), this._totalSold (), this._productNav (), this._productsSlider ()), this._initProductVideo (), this._initModelViewerLibraries (), this._initShopifyXrLaunch ());
  }
  return (e.prototype = _.assignIn ({}, e.prototype, {
    _initMediaSwitch: function () {
      var n;
      $ (this.selectors.productThumbImages).length &&
        (($.fn.visible = function (e) {
          var t = $ (this),
            i = $ (window),
            s = i.scrollTop (),
            o = s + i.height (),
            a = t.offset ().top,
            n = a + t.height ();
          return (!0 === e ? a : n) <= o && s <= (!0 === e ? n : a);
        }), (n = this), $ (this.selectors.productThumbImages)
          .on ('click', function (e) {
            e.preventDefault ();
            var t = $ (this).data ('thumbnail-id');
            n._switchMedia (t), n._setActiveThumbnail (t);
          })
          .on ('keyup', n._handleMediaFocus.bind (n)), $ (
          n.selectors.productThumbs
        ).on ('beforeChange', function (e, t, i, s) {
          var o,
            a = $ (n.selectors.productThumbs).find ('.slick-slide').eq ([s]);
          a.find ('.product-single__thumbnail').length &&
            ((o = a
              .find ('.product-single__thumbnail')
              .data ('thumbnail_id')), $ (n.selectors.productVideo).data (
              'thumbnail_prev',
              o
            ), $ (n.selectors.productVideoWrap).hide (), $ (
              n.selectors.productImages
            ).show (), n._pauseVideo ());
        }), $ (n.selectors.productImages).on ('afterChange', function (
          e,
          t,
          i
        ) {
          var s = $ (n.selectors.productImages)
            .find ('.slick-slide')
            .eq ([i])
            .data ('media-id');
          n._switchMedia (s);
        }), $ (n.selectors.productVideo).on ('click', function () {
          var e = $ (this), t = e.data ('thumbnail_prev');
          e.hasClass ('played')
            ? $ (
                n.selectors.productThumbImages +
                  "[data-thumbnail_id='" +
                  t +
                  "']"
              )[0].click ()
            : ($ (n.selectors.productThumbs)
                .find ('.slick-slide')
                .removeClass ('slick-current'), $ (
                n.selectors.productImages
              ).hide (), $ (
                n.selectors.productVideoWrap
              ).show (), n._playVideo (t));
        }), $ (window).scroll (function (e) {
          $ (n.selectors.productImageWraps).each (function (e, t) {
            var i = $ (t);
            i.visible (!0) && i.addClass ('come-in');
          });
        }));
    },
    _setActiveThumbnail: function (e) {
      void 0 === e &&
        (e = $ (
          this.selectors.productMediaWrapper +
            ':not(.' +
            this.classes.hidden +
            ')',
          this.$container
        ).data ('media-id'));
      var t,
        i = $ (
          this.selectors.productThumbListItem + ':not(.slick-cloned)',
          this.$container
        ),
        s = i.find (
          this.selectors.productThumbImages + "[data-thumbnail-id='" + e + "']"
        );
      $ (this.selectors.productThumbImages)
        .removeClass (this.classes.activeClass)
        .removeAttr ('aria-current'), s.addClass (
        this.classes.activeClass
      ), s.attr ('aria-current', !0), i.hasClass ('slick-slide') &&
        ((t = s.parent ().data ('slick-index')), $ (
          this.selectors.productThumbImagesWrapper
        ).slick ('slickGoTo', t, !0));
    },
    _initProductVideo: function () {
      var t = this.settings.sectionId;
      $ (
        this.selectors.productMediaTypeVideo,
        this.$container
      ).each (function () {
        var e = $ (this);
        theme.ProductVideo.init (e, t);
      });
    },
    _initModelViewerLibraries: function () {
      var e = $ (this.selectors.productMediaTypeModel, this.$container);
      e.length < 1 || theme.ProductModel.init (e, this.settings.sectionId);
    },
    _initShopifyXrLaunch: function () {
      var e = this;
      $ (document).on ('shopify_xr_launch', function () {
        $ (
          e.selectors.productMediaWrapper + ':not(.' + e.classes.hidden + ')',
          e.$container
        ).trigger ('xrLaunch');
      });
    },
    _updateMedia: function (e) {
      var t = e.variant.featured_media.id,
        i = this.settings.sectionId + '-' + t;
      this._switchMedia (i), this._setActiveThumbnail (i);
    },
    _switchMedia: function (e) {
      var t = $ (
        this.selectors.productMediaWrapper +
          ':not(.' +
          this.classes.hidden +
          ')',
        this.$container
      ),
        i = $ (
          this.selectors.productMediaWrapper + "[data-media-id='" + e + "']",
          this.$container
        ),
        s = $ (
          this.selectors.productMediaWrapper +
            ":not([data-media-id='" +
            e +
            "'])",
          this.$container
        );
      t.trigger ('mediaHidden'), i.trigger ('mediaVisible'), i
        .removeClass (this.classes.hidden)
        .trigger ('mediaVisible'), s.addClass (this.classes.hidden);
    },
    _handleMediaFocus: function (e) {
      var t;
      e.keyCode === slate.utils.keyboardKeys.ENTER &&
        ((t = $ (e.currentTarget).data ('thumbnail-id')), $ (
          this.selectors.productMediaWrapper + "[data-media-id='" + t + "']",
          this.$container
        ).focus ());
    },
    _initImageSlider: function (e) {
      void 0 === e && (e = !0);
      var t = this, i = !1;
      '1' == $ (t.selectors.productImages).data ('adaptive_height') && (i = !0);
      var o,
        s = {
          infinite: !1,
          adaptiveHeight: i,
          rtl: theme.settings.rtl,
          slidesToShow: 1,
          slidesToScroll: 1,
          fade: !0,
          dots: !0,
          arrows: !0,
          prevArrow: '<button class="slick-prev" type="button"><svg class="svg-icon"><use xlink:href="#global__symbols-prev2"></use></svg></button>',
          nextArrow: '<button class="slick-next" type="button"><svg class="svg-icon"><use xlink:href="#global__symbols-next2"></use></svg></button>',
          asNavFor: t.selectors.productThumbs,
          responsive: [{breakpoint: 767, settings: {adaptiveHeight: !0}}],
        };
      0 == e
        ? 1 == $ (t.selectors.productImages).data ('center_mode') &&
            ((s.centerMode = !0), (s.centerPadding =
              '25%'), (s.fade = !1), (s.arrows = !0))
        : ((s.slidesToShow = 1), (s.fade = !1), (s.dots = !0), (s.arrows = !1)), $ (
        t.selectors.productImages
      )
        .closest ('.product-single__photos')
        .find ('.carousel-status').length &&
        ((o = $ (t.selectors.productImages)
          .closest ('.product-single__photos')
          .find ('.carousel-status')), $ (
          t.selectors.productImages
        ).on ('beforeChange', function (e, t, i, s) {
          o.html (
            '<span>' + (s + 1) + '</span>/<span>' + t.$slides.length + '</span>'
          );
        })), theme.settings.animation &&
        $ (t.selectors.productImages).on ('init', function (e, t) {
          var i = new TimelineLite (), s = t.$slider, o = s.parent ();
          i.fromTo (
            s,
            1,
            {opacity: 0},
            {ease: Power4.easeInOut, opacity: 1},
            0
          ), i.fromTo (o, 2, {scale: 1.1, opacity: 0}, {ease: Power4.easeInOut, scale: 1, opacity: 1}, 0.3);
        }), (t.settings.sliderImagesActive = !0), $ (
        t.selectors.productImages
      ).slick (s);
    },
    _initThumbnailSlider: function (e) {
      void 0 === e && (e = !0);
      var t = this, i = !1;
      0 == e &&
        1 == $ (t.selectors.productThumbs).data ('vertical') &&
        (i = !0);
      var s = {
        rtl: theme.settings.rtl,
        slidesToShow: 4,
        slidesToScroll: 1,
        vertical: i,
        verticalSwiping: i,
        asNavFor: t.selectors.productImages,
        focusOnSelect: !0,
        arrows: !1,
      };
      theme.settings.animation &&
        $ (t.selectors.productThumbs).on ('init', function (e, t) {
          var i = new TimelineLite (), s = t.$slider;
          i.fromTo (
            s.find ('.slick-list'),
            1.4,
            {y: 20, opacity: 0},
            {
              ease: Power4.easeInOut,
              y: 0,
              opacity: 1,
              onStart: function () {
                setTimeout (function () {
                  s.addClass ('shadow');
                }, 600);
              },
            },
            1
          );
        }), (t.settings.sliderThumbsActive = !0), $ (
        t.selectors.productThumbs
      ).slick (s);
    },
    _destroyImageSlider: function () {
      $ (this.selectors.productImages).slick (
        'unslick'
      ), (this.settings.sliderImagesActive = !1);
    },
    _destroyThumbnailSlider: function () {
      $ (this.selectors.productThumbs).slick (
        'unslick'
      ), (this.settings.sliderThumbsActive = !1);
    },
    _initImageSwitch: function () {
      var n;
      $ (this.selectors.productThumbImages).length &&
        (($.fn.visible = function (e) {
          var t = $ (this),
            i = $ (window),
            s = i.scrollTop (),
            o = s + i.height (),
            a = t.offset ().top,
            n = a + t.height ();
          return (!0 === e ? a : n) <= o && s <= (!0 === e ? n : a);
        }), (n = this), $ (document).off (
          'click',
          n.selectors.productThumbImages
        ), $ (document).on ('click', n.selectors.productThumbImages, function (
          e
        ) {
          e.preventDefault ();
        }), $ (n.selectors.productThumbs).on ('beforeChange', function (
          e,
          t,
          i,
          s
        ) {
          var o,
            a = $ (n.selectors.productThumbs).find ('.slick-slide').eq ([s]);
          a.find ('.product-single__thumbnail').length &&
            ((o = a
              .find ('.product-single__thumbnail')
              .data ('thumbnail_id')), $ (n.selectors.productVideo).data (
              'thumbnail_prev',
              o
            ), $ (n.selectors.productVideoWrap).hide (), $ (
              n.selectors.productImages
            ).show (), n._pauseVideo ());
        }), $ (n.selectors.productVideo).on ('click', function () {
          var e = $ (this), t = e.data ('thumbnail_prev');
          e.hasClass ('played')
            ? $ (
                n.selectors.productThumbImages +
                  "[data-thumbnail_id='" +
                  t +
                  "']"
              )[0].click ()
            : ($ (n.selectors.productThumbs)
                .find ('.slick-slide')
                .removeClass ('slick-current'), $ (
                n.selectors.productImages
              ).hide (), $ (
                n.selectors.productVideoWrap
              ).show (), n._playVideo (t));
        }), $ (window).scroll (function (e) {
          $ (n.selectors.productImageWraps).each (function (e, t) {
            var i = $ (t);
            i.visible (!0) && i.addClass ('come-in');
          });
        }));
    },
    _switchImage: function (e) {
      'product-quickview' != this.settings.sectionType
        ? $ (this.selectors.productThumbImages).length &&
            $ (
              this.selectors.productThumbImages +
                "[data-thumbnail_id='" +
                e.id +
                "']"
            )[0].click ()
        : $ (this.selectors.productImage, this.selectors.container)
            .attr ('data-bgset', theme.roarJs.bgSet (e))
            .removeClass ('lazyloaded')
            .addClass ('lazyload');
    },
    _initBreakpoints: function () {
      var e = this;
      enquire.register (e.settings.mediaQueryMedium, {
        match: function () {
          e.settings.sliderThumbsActive &&
            e._destroyThumbnailSlider (), e._initThumbnailSlider ();
        },
      }), enquire.register (e.settings.mediaQueryLargeUp, {
        match: function () {
          e.settings.sliderThumbsActive &&
            e._destroyThumbnailSlider (), e._initThumbnailSlider (!1);
        },
      }), enquire.register (e.settings.mediaQuerySmall, {
        match: function () {
          e.settings.sliderImagesActive &&
            e._destroyImageSlider (), e._initImageSlider (), e.settings
            .zoomEnabled &&
            $ (e.selectors.productImageWraps).each (function () {
              $ (this).trigger ('zoom.destroy');
            });
        },
      }), enquire.register (e.settings.mediaQueryMediumUp, {
        match: function () {
          e.settings.sliderImagesActive &&
            e._destroyImageSlider (), e._initImageSlider (!1), e.settings
            .zoomEnabled &&
            $ (e.selectors.productImageWraps).each (function () {
              var e, t;
              (e = this), (t = $ (e).data ('zoom')), $ (e).zoom ({
                duration: 500,
                url: t,
                onZoomIn: function () {
                  $ (this).addClass ('active');
                },
                onZoomOut: function () {
                  $ (this).removeClass ('active');
                },
              });
            });
        },
      });
    },
    _productNav: function () {
      var s, o, a, e;
      $ (this.selectors.productNav).length &&
        ((s = $ (this.selectors.productNav)), (o = s), (a = $ (
          '.product-template__end'
        )), (e = function () {
          var e = o.offset ().top / 3,
            t = a.offset ().top - 400,
            i = $ (window).scrollTop ();
          e < i ? s.addClass ('visible') : s.removeClass ('visible'), t < i &&
            s.removeClass ('visible');
        }) (), $ (window).scroll (e), $ (window).resize (e));
    },
    _productInView: function () {
      if ('undefined' == typeof ScrollReveal || 0 == theme.settings.animation)
        return !1;
      (window.sr = ScrollReveal ()), sr.reveal (
        '.product-single__inview:not(.no-anim)',
        {
          mobile: !0,
          beforeReveal: function (t) {
            (t.visuelRevealTL = new TimelineLite ()), $ (t).addClass (
              'anim'
            ), t.visuelRevealTL
              .fromTo (
                t,
                2,
                {y: 40, opacity: 0},
                {ease: Power4.easeInOut, y: 0, opacity: 1},
                0
              )
              .call (function (e) {
                $ (t).removeClass ('anim').addClass ('no-anim');
              });
          },
        }
      );
    },
    _updateProductObject: function () {
      var s = this;
      $.each (s.productMoreSingleObject.variants, function (i, e) {
        $.each (e, function (e, t) {
          s.productSingleObject.variants[i][e] = t;
        });
      });
    },
    _totalSold: function () {
      var e, t, i, s, o, a, n;
      $ (this.selectors.totalSold).length &&
        ((t = (e = $ (this.selectors.totalSold)).data (
          'qty_min'
        )), (i = e.data ('qty_max')), (s = e.data ('time_min')), (o = e.data (
          'time_max'
        )), (t = Math.ceil (t)), (i = Math.floor (i)), (s = Math.ceil (
          s
        )), (o = Math.floor (o)), (a =
          Math.floor (Math.random () * (i - t + 1)) + t), (a = parseInt (a)) <=
          t && (a = t), i < a && (a = i), e.html (
          e.html ().replace ('/count/', a)
        ), (n = Math.floor (Math.random () * (o - s + 1)) + s), (n = parseInt (
          n
        )) <= s && (n = s), o < n && (n = o), e.html (
          e.html ().replace ('/time/', n)
        ), e.addClass ('active'), e.find ('img').first ().length &&
          setInterval (function () {
            e
              .find ('img')
              .first ()
              .fadeIn (function () {
                $ (this).css ('visibility', 'visible');
              })
              .delay (1600)
              .fadeIn (function () {
                $ (this).css ('visibility', 'hidden');
              })
              .delay (400);
          }, 2e3));
    },
    _visitorCounter: function () {
      var e, t, i, s, o, a, n, r, c, l, d;
      $ (this.selectors.visitorCounter).length &&
        ((e = $ (this.selectors.visitorCounter)), (t = e.data (
          'max'
        )), (i = e.data ('interval')), (s = 1), (o = t), (s = Math.ceil (
          s
        )), (o = Math.floor (o)), (a =
          Math.floor (Math.random () * (o - s + 1)) + s), (n = [
          '1',
          '2',
          '4',
          '3',
          '6',
          '10',
          '-1',
          '-3',
          '-2',
          '-4',
          '-6',
        ]), (r = ['10', '20', '15']), (d = l = c = l = c =
          ''), setInterval (function () {
          (c = Math.floor (
            Math.random () * n.length
          )), (l = n[c]), (a = parseInt (a) + parseInt (l)) <= 1 && ((d = Math.floor (Math.random () * r.length)), (a += r[d])), (a < 1 || t < a) && (a = Math.floor (Math.random () * (o - s + 1)) + s), e.find ('strong').first ().text (parseInt (a)), e.addClass ('active');
        }, 1e3 * i));
    },
    _initStockCountdown: function () {
      var t, i, e, s, o, a, n, r, c, l;
      function d (e, t) {
        return Math.floor (Math.random () * (t - e + 1) + e);
      }
      function u () {
        var e = 100 * o / i;
        t.find ('.progress-bar span').css ('width', e + '%');
      }
      !$ (this.selectors.stockCountdown).length ||
        ((t = $ (this.selectors.stockCountdown)).hasClass ('is-fake') &&
          ((i = 60), (e = t.data ('min')), (s = t.data ('max')), (o = d (
            e,
            s
          )), (n = a = null), (r = 1), (c = 1.7), (l = 3), t
            .find ('.stock-countdown-message')
            .first ()
            .html (
              theme.strings.onlyLeft.replace ('{{ count }}', o)
            ), (a = setTimeout (function () {
            --o < r &&
              (o = d (
                e,
                s
              )), t.find ('.stock-countdown-message strong').text (o), u (), o < e && clearTimeout (a);
          }, 1e3 * l)), (n = setInterval (function () {
            --o < r &&
              (o = d (
                e,
                s
              )), t.find ('.stock-countdown-message strong').text (o), u (), o < e && clearInterval (n);
          }, 6e4 * c)), t.hasClass ('is-visible') && t.removeClass ('hide')));
    },
    _updateStockCountdown: function (e) {
      var t = $ (this.selectors.stockCountdown);
      t.hasClass ('is-fake')
        ? t.removeClass ('hide')
        : (t
            .find ('.stock-countdown-message')
            .first ()
            .html (theme.strings.onlyLeft.replace ('{{ count }}', e)), t
            .find ('.progress-bar span')
            .first ()
            .css ('width', '100%'), t.removeClass (
            'hide'
          ), setTimeout (function () {
            t.find ('.progress-bar span').first ().css ('width', '28%');
          }, 500));
    },
    _checkoutCart: function () {
      var s = this;
      $ (s.selectors.cartAgree).length &&
        ($ (document).on (
          'DOMNodeInserted',
          s.selectors.cartCheckout,
          function () {
            var t = $ (this);
            setTimeout (function () {
              var e = t.find ('.shopify-payment-button__button');
              e.length &&
                (t.hide (), setTimeout (function () {
                  $ (s.selectors.cartAgree).is (':checked')
                    ? e.removeClass ('btn-disabled')
                    : e.addClass ('btn-disabled'), t.fadeIn ();
                }, 300));
            }, 0);
          }
        ), $ (document).on ('change', s.selectors.cartAgree, function (e) {
          var t = $ (this),
            i = $ (s.selectors.cartCheckout).find (
              '.shopify-payment-button__button'
            );
          t.is (':checked')
            ? i.removeClass ('btn-disabled')
            : i.addClass ('btn-disabled');
        }));
    },
    _pauseVideo: function () {
      var e = $ (this.selectors.productVideoWrap).find ('video')[0];
      e && e.played && (e.pause (), e.load ()), $ (
        this.selectors.productVideo
      ).removeClass ('played');
    },
    _playVideo: function (e) {
      var t, i = this, s = $ (i.selectors.productVideoWrap).find ('video')[0];
      s &&
        (s.play (), (t = 1), s.addEventListener (
          'ended',
          function () {
            t < 2
              ? (s.play (), t++)
              : $ (
                  i.selectors.productThumbImages +
                    "[data-thumbnail_id='" +
                    e +
                    "']"
                )[0].click ();
          },
          !1
        )), $ (i.selectors.productVideo).addClass ('played');
    },
    _initVideoZoom: function () {
      var s = this, o = $ ('.pswp')[0];
      $ (document).off ('click', s.selectors.productVideoTrigger), $ (
        document
      ).on ('click', s.selectors.productVideoTrigger, function (e) {
        e.preventDefault ();
        $ (this).parent ();
        var t,
          i = new PhotoSwipe (
            o,
            PhotoSwipeUI_Default,
            ((t = []).push ({
              html: $ (
                s.selectors.productVideoWrap + ' .product-single__video'
              ).html (),
            }), t),
            {
              index: 0,
              closeOnScroll: !1,
              bgOpacity: 0.1,
              tapToClose: !0,
              tapToToggleControls: !1,
            }
          );
        i.init (), $ ('body').addClass ('blurred'), $ ('.pswp__item').fadeTo (1e3, 1), i.listen (
          'close',
          function () {
            $ ('.pswp__item .pswp__video').each (function () {
              $ (this).attr ('src', $ (this).attr ('src'));
            }), $ ('.pswp__item').fadeOut ('slow', 0), $ ('body').removeClass (
              'blurred'
            );
          }
        );
      });
    },
    _initGalleryZoom: function () {
      var o = this, a = $ ('.pswp')[0];
      $ (document).off ('click', o.selectors.productGalleryTrigger), $ (
        document
      ).on ('click', o.selectors.productGalleryTrigger, function (e) {
        e.preventDefault ();
        $ (this).parent ();
        var s,
          t = {
            index: $ (this).data ('index'),
            closeOnScroll: !1,
            bgOpacity: 0.1,
            tapToClose: !0,
            tapToToggleControls: !1,
          },
          i = new PhotoSwipe (
            a,
            PhotoSwipeUI_Default,
            ((s = []), $ (
              o.selectors.productImages +
                ' .product-single__photo-container:not(.slick-cloned) .feature-row__image'
            ).each (function () {
              var e = $ (this).data ('large_image'),
                t = $ (this).data ('large_image_width'),
                i = $ (this).data ('large_image_height');
              s.push ({src: e, w: t, h: i, title: !1});
            }), s),
            t
          );
        i.init (), i.listen ('imageLoadComplete', function (e, t) {
          $ ('.pswp__item').fadeTo (1e3, 1), $ ('body').addClass ('blurred');
        }), i.listen ('close', function (e, t) {
          $ ('.pswp__item').fadeOut (
            'slow',
            0
          ), $ ('body').removeClass ('blurred');
        });
      });
    },
    _initQuantity: function () {
      var i = this;
      function s (e) {
        var t = 0;
        $ (e)
          .closest (i.selectors.productContent)
          .find (i.selectors.productQuantity + ' .quantity')
          .each (function () {
            t += parseInt ($ (this).val ());
          }), 0 < t
          ? $ (i.selectors.addToCart).prop ('disabled', !1)
          : $ (i.selectors.addToCart).prop ('disabled', !0);
      }
      $ (document).off ('click', i.selectors.productQuantity + ' .plus'), $ (
        document
      ).on ('click', i.selectors.productQuantity + ' .plus', function () {
        var e = $ (this)
          .closest (i.selectors.productQuantity)
          .find ('.quantity'),
          t = parseInt (e.val ());
        (t += 1), e.val (t), s (this);
      }), $ (document).off (
        'click',
        i.selectors.productQuantity + ' .minus'
      ), $ (document).on (
        'click',
        i.selectors.productQuantity + ' .minus',
        function () {
          var e = $ (this)
            .closest (i.selectors.productQuantity)
            .find ('.quantity'),
            t = parseInt (e.val ());
          0 < t && (--t, e.val (t), s (this));
        }
      );
    },
    _stickyDetails: function () {
      var e = $ (this.selectors.productContent);
      !e.data ('sticky') ||
        $ (window).width () < 992 ||
        e.each (function () {
          var e = $ (this).parent (),
            t = $ (this),
            i = e.closest ('.product-single').find ('.product-single__photos'),
            s = t.outerHeight () - i.outerHeight ();
          s < -100
            ? t.stick_in_parent ({offset_top: 20})
            : 100 < s && i.stick_in_parent ({offset_top: 20}), $ (
            window
          ).resize (function () {
            $ (window).width () < 992
              ? (t.trigger ('sticky_kit:detach'), i.trigger (
                  'sticky_kit:detach'
                ))
              : t.outerHeight () < i.outerHeight ()
                  ? t.stick_in_parent ({offset_top: 20})
                  : i.stick_in_parent ({offset_top: 20});
          });
        });
    },
    _initTabs: function () {
      var a = $ (this.selectors.productTabs), n = '.product-tabs__title';
      (a.hasClass ('tabs-layout-tabs') ||
        a.hasClass ('tabs-layout-accordion')) &&
        ($ (document).off ('click', n), $ (document).on ('click', n, function (
          e
        ) {
          e.preventDefault ();
          var t = $ (this),
            i = t.attr ('href'),
            s = $ (n, a),
            o = $ ('.product-tabs__panel', a);
          $ ('.product-tabs', a).is (':visible')
            ? (s.removeClass ('active'), o.removeClass ('active'), t.addClass (
                'active'
              ), $ (i).addClass ('active'))
            : (t.hasClass ('active')
                ? (t.removeClass ('active'), $ (i).removeClass ('active'))
                : (s.removeClass ('active'), o.removeClass (
                    'active'
                  ), t.addClass ('active'), $ (i).addClass (
                    'active'
                  )), o.each (function () {
                $ (this).hasClass ('active')
                  ? $ (this).slideDown (250)
                  : $ (this).slideUp (250);
              }));
        }));
    },
    _initReviews: function () {
      if (!$ (this.selectors.productTabs).length) return !1;
      var i = this.selectors.productTabs;
      $ (document).off ('click', this.selectors.productReviews), $ (
        document
      ).on ('click', this.selectors.productReviews, function () {
        var e;
        ($ (i).hasClass ('tabs-layout-tabs') ||
          $ (i).hasClass ('tabs-layout-accordion')) &&
          ((e = $ (i + ' #tab-reviews').prev ()), $ ('.product-tabs', i).is (
            ':visible'
          ) && (e = $ (i + ' .reviews_tab .product-tabs__title')), e.hasClass (
            'active'
          ) || e.trigger ('click'));
        var t = $ (i + ' #tab-reviews').parent ();
        $ ('.product-tabs', i).is (':visible') &&
          (t = $ (i)), setTimeout (function () {
          $ ('html, body').animate ({scrollTop: t.offset ().top}, 500, 'swing');
        }, 250);
      });
    },
    _initSwatches: function () {
      var c = this;
      var e,
        o = this.productSingleObject,
        t = this.productSwatchSingleObject,
        s = new Array ();
      if (
        ('1' == this.settings.swatchSize && s.push ('Size'), s.push (
          'size'
        ), '1' == this.settings.swatchColor &&
          (s.push ('Color'), s.push ('Colour'), s.push ('color'), s.push (
            'colour'
          )), 0 < s.length)
      ) {
        var a = !1,
          n = 0,
          r = theme.settings.assetUrl.substring (
            0,
            theme.settings.assetUrl.lastIndexOf ('?')
          ),
          l = theme.settings.assetUrl.substring (
            theme.settings.assetUrl.lastIndexOf ('?'),
            theme.settings.assetUrl.length
          );
        for (i = 0; i < o.options.length; i++) {
          var d = '',
            u = '',
            h = '',
            p = '',
            m = '',
            f = '',
            g = ' img',
            d = 'object' == typeof o.options[i]
              ? o.options[i].name
              : o.options[i],
            a = !1;
          if (-1 < s.indexOf (d)) {
            (a = !0), (n = i);
            var v = d.toLowerCase ();
            if ((/color|colour/i.test (v) && 0, a)) {
              var _ = new Array ();
              for (j = 0; j < o.variants.length; j++) {
                var y = o.variants[j],
                  w = ((e = y.options[n]), String (e)
                    .replace (/&/g, '&amp;')
                    .replace (/</g, '&lt;')
                    .replace (/>/g, '&gt;')
                    .replace (/"/g, '&quot;')),
                  b = w
                    .toLowerCase ()
                    .replace (/[^a-z0-9 -]/g, '')
                    .replace (/\s+/g, '-')
                    .replace (/-+/g, '-');
                c.settings.sectionId;
                _.indexOf (w) < 0 &&
                  ('color' != v && 'colour' != v
                    ? ((f = '<i>' + w + '</i>'), (g = ''))
                    : (f = '1' == this.settings.swatchColorAdvanced
                        ? null !== t[b] && void 0 !== t[b] && '' != t[b]
                            ? ((g =
                                ' img swatch_color_advanced'), '<i style="background-image:url(' +
                                r +
                                t[b] +
                                '.png' +
                                l +
                                ');"></i>')
                            : null !== y.featured_image
                                ? ((g =
                                    ' img swatch_color_advanced'), '<i style="background-image:url(' +
                                    theme.Images.getSizedImageUrl (
                                      y.featured_image.src,
                                      '100x'
                                    ) +
                                    ');"></i>')
                                : '<i style="background-color:' +
                                    w +
                                    ';background-image:url(' +
                                    r +
                                    b +
                                    '.png' +
                                    l +
                                    ');"></i>'
                        : '<i style="background-color:' +
                            w +
                            ';background-image:url(' +
                            r +
                            b +
                            '.png' +
                            l +
                            ');"></i>'), (h =
                    h +
                    '<div class="swatch-element ' +
                    v +
                    b +
                    ' available"><label class="swatch-label' +
                    g +
                    ($ (c.selectors.singleOptionSelectorId + '-' + n).val () ==
                      w
                      ? ' selected'
                      : '') +
                    '" title="' +
                    w +
                    '"><input class="swatch-radio swatch-' +
                    c.settings.sectionId +
                    '-' +
                    n +
                    '-' +
                    b +
                    '" type="radio" value="' +
                    w +
                    '" data-value="' +
                    w +
                    '" data-poption="' +
                    n +
                    '" name="option-' +
                    n +
                    '">' +
                    f +
                    '<span class="soldout-image"></span></label></div>'), _.push (
                    w
                  ));
              }
              (u =
                '<div class="' +
                c.selectors.singleOptionSwatches +
                ' wrapper-swatches swatch ' +
                v +
                '" data-attribute_name="attribute_pa_' +
                v +
                '">' +
                h +
                '</div>'), (p = $ (
                c.selectors.singleOptionSelectorId + '-' + n
              )), (m = $ (c.selectors.variationSelector + '-' + n)), '' != u &&
                (p.after (u), p.hide (), p
                  .closest ('.variation-select')
                  .addClass ('variation-select-hidden'), m.addClass (
                  'hide-choose-option'
                ));
            }
          }
        }
      }
      var k = '', C = '.' + c.selectors.singleOptionSwatches + ' .swatch-radio';
      0 <
        $ ('.' + c.selectors.singleOptionSwatches, c.selectors.container)
          .length &&
        ((k = $ (C)).unbind ('click'), k.on ('click', function () {
          var e = $ (this)
            .closest ('.selector-wrapper')
            .find ('.single-option-selector')
            .first (),
            t = $ (this).data ('poption'),
            s = $ (this).data ('value');
          s != e.val () &&
            (e.val (s).trigger ('change'), e
              .closest ('.selector-wrapper')
              .find ('.swatch-label')
              .removeClass ('selected'), e
              .closest ('.selector-wrapper')
              .find ('.option-select-value')
              .html (s), $ (this)
              .closest ('.swatch-label')
              .addClass ('selected')), (function (a, n, r) {
            if (1 < a.options.length)
              for (i = 0; i < a.options.length; i++)
                i != n &&
                  $ (
                    c.selectors.singleOptionSelectorId + '-' + i + ' option',
                    c.selectors.container
                  ).each (function () {
                    var e = 'unavailable', t = $ (this).attr ('value');
                    for (j = 0; j < a.variants.length; j++) {
                      var s = a.variants[j];
                      if (s.options[n] == r && s.options[i] == t) {
                        e = 1 == s.available ? 'available' : 'sold_out';
                        break;
                      }
                    }
                    var o =
                      '.swatch-' +
                      c.settings.sectionId +
                      '-' +
                      i +
                      '-' +
                      t
                        .toLowerCase ()
                        .replace (/[^a-z0-9 -]/g, '')
                        .replace (/\s+/g, '-')
                        .replace (/-+/g, '-');
                    $ (o, c.selectors.container)
                      .closest ('.swatch-element')
                      .removeClass ('available')
                      .removeClass ('sold_out')
                      .removeClass ('unavailable')
                      .addClass (e);
                  });
            else
              for (i = 0; i < a.options.length; i++)
                $ (
                  c.selectors.singleOptionSelectorId + '-' + i + ' option',
                  c.selectors.container
                ).each (function () {
                  var e = 'unavailable', t = $ (this).attr ('value');
                  for (j = 0; j < a.variants.length; j++) if (
                      a.variants[j].options[i] == t
                    ) {
                      e = a.variants[j].available ? 'available' : 'sold_out';
                      break;
                    }
                  var s =
                    '.swatch-' +
                    c.settings.sectionId +
                    '-' +
                    i +
                    '-' +
                    t
                      .toLowerCase ()
                      .replace (/[^a-z0-9 -]/g, '')
                      .replace (/\s+/g, '-')
                      .replace (/-+/g, '-');
                  $ (s, c.selectors.container)
                    .closest ('.swatch-element')
                    .removeClass ('available')
                    .removeClass ('sold_out')
                    .removeClass ('unavailable')
                    .addClass (e);
                });
          }) (o, t, s);
        })), $ (C, c.selectors.container)
        .closest ('.selector-wrapper')
        .find ('.swatch-label.selected .swatch-radio')
        .trigger ('click');
    },
    _initVariants: function () {
      var e = {
        $container: this.$container,
        enableHistoryState: this.$container.data ('enable-history-state') || !1,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject,
      };
      (this.variants = new slate.Variants (e)), this.$container.on (
        'variantChange' + this.settings.namespace,
        this._updateAddToCart.bind (this)
      ), this.$container.on (
        'variantImageChange' + this.settings.namespace,
        this._updateMedia.bind (this)
      ), this.$container.on (
        'variantPriceChange' + this.settings.namespace,
        this._updatePrice.bind (this)
      ), this.$container.on (
        'variantSKUChange' + this.settings.namespace,
        this._updateSKU.bind (this)
      );
    },
    _updateAddToCart: function (e) {
      var t = e.variant;
      t
        ? ($ (this.selectors.productPrices).removeClass (
            'visibility-hidden'
          ), t.available
            ? ($ (this.selectors.addToCart, this.selectors.container).prop (
                'disabled',
                !1
              ), t.inventory_quantity <= 0 &&
                'shopify' == t.inventory_management
                ? $ (
                    this.selectors.addToCartText,
                    this.selectors.container
                  ).text (theme.strings.preOrder)
                : $ (
                    this.selectors.addToCartText,
                    this.selectors.container
                  ).text (theme.strings.addToCart), $ (
                this.selectors.productQuantity
              ).removeClass ('btn-disabled'), $ (
                this.selectors.inComing,
                this.selectors.container
              ).addClass ('hide'), 0 < t.inventory_quantity &&
                'shopify' == t.inventory_management
                ? this._updateStockCountdown (t.inventory_quantity)
                : $ (this.selectors.stockCountdown).removeClass ('hide'), $ (
                this.selectors.totalSold
              ).removeClass ('hide'))
            : ($ (this.selectors.addToCart, this.selectors.container).prop (
                'disabled',
                !0
              ), $ (
                this.selectors.addToCartText,
                this.selectors.container
              ).text (theme.strings.soldOut), $ (
                this.selectors.productQuantity
              ).addClass ('btn-disabled'), t.incoming
                ? $ (this.selectors.inComing, this.selectors.container)
                    .html (
                      theme.strings.inComing.replace (
                        '{{ date }}',
                        t.next_incoming_date
                      )
                    )
                    .removeClass ('hide')
                : $ (
                    this.selectors.inComing,
                    this.selectors.container
                  ).addClass ('hide'), $ (
                this.selectors.stockCountdown
              ).addClass ('hide'), $ (this.selectors.totalSold).addClass (
                'hide'
              )))
        : ($ (this.selectors.addToCart, this.selectors.container).prop (
            'disabled',
            !0
          ), $ (this.selectors.addToCartText, this.selectors.container).text (
            theme.strings.unavailable
          ), $ (this.selectors.productQuantity).addClass ('btn-disabled'), $ (
            this.selectors.productPrices
          ).addClass ('visibility-hidden'), $ (
            this.selectors.inComing,
            this.selectors.container
          ).addClass ('hide'), $ (this.selectors.stockCountdown).addClass (
            'hide'
          ), $ (this.selectors.totalSold).addClass ('hide'));
    },
    _updateImages: function (e) {
      var t = e.variant;
      this._switchImage (t.featured_image);
    },
    _updatePrice: function (e) {
      var t = e.variant;
      $ (this.selectors.originalPrice, this.selectors.container).html (
        theme.CurrencyPicker.formatMoney (t.price)
      ), t.compare_at_price > t.price
        ? $ (this.selectors.comparePrice, this.selectors.container)
            .html (theme.CurrencyPicker.formatMoney (t.compare_at_price))
            .removeClass ('hide')
        : $ (this.selectors.comparePrice, this.selectors.container).addClass (
            'hide'
          );
    },
    _updateSKU: function (e) {
      var t = e.variant;
      $ (this.selectors.SKU).html (t.sku);
    },
    _recordRecentlyViewed: function () {
      var t = 'roarStorage_recentlyViewed',
        i = localStorage.getItem (t) || '[]';
      try {
        i = JSON.parse (i);
      } catch (e) {
        localStorage.removeItem (t), (i = JSON.parse ('[]'));
      }
      var e = this.productSingleObject.id;
      i.includes (e) || i.unshift (e);
      var s = i.filter (function (e) {
        return null != e;
      });
      try {
        localStorage.setItem (t, JSON.stringify (s.slice (0, 180)));
      } catch (e) {}
    },
    _sizeChart: function () {
      var t = $ ('body'), i = $ ('.sizechart-modal');
      $ (document).off ('click', this.selectors.sizeChart), $ (
        document
      ).on ('click', this.selectors.sizeChart, function (e) {
        e.preventDefault (), i.addClass ('opened'), t.addClass ('sizechart-opened');
      }), $ (document).off (
        'click',
        '.sizechart_overlay, .sizechart_close'
      ), $ (
        document
      ).on ('click', '.sizechart_overlay, .sizechart_close', function (e) {
        e.preventDefault (), i.removeClass ('opened'), t.removeClass ('sizechart-opened');
      }), $ (document).keyup (function (e) {
        '27' == e.which &&
          (i.removeClass ('opened'), t.removeClass ('sizechart-opened'));
      }), $ ('body').append (i);
    },
    _productsSlider: function () {
      new theme.Sections ().register (
        'products-slider-sub',
        theme.ProductsSlider
      );
    },
    _lineItem: function () {
      theme.roarJs.initReviews (), theme.roarJs.fixtooltipHover ();
      var e = new theme.Sections ();
      e.register ('line_item', theme.LineItem), e.register (
        'countdown-timer',
        theme.CountdownTimer
      );
    },
    onLoad: function () {
      this._lineItem ();
    },
    onUnload: function () {
      this.$container.off (
        this.settings.namespace
      ), theme.ProductVideo.removeSectionVideos (
        this.settings.sectionId
      ), theme.ProductModel.removeSectionModels (this.settings.sectionId);
    },
  })), e;
}) ()), (theme.ProductModel = (function () {
  var o = {},
    r = {},
    c = {},
    l = '[data-product-single-media-group]',
    d = '[data-shopify-xr]';
  function a (e) {
    if (!e)
      if (window.ShopifyXR) {
        for (var t in o)
          if (o.hasOwnProperty (t)) {
            var i = o[t];
            if (i.loaded) continue;
            var s = $ ('#ModelJson-' + t);
            window.ShopifyXR.addModels (
              JSON.parse (s.html ())
            ), (i.loaded = !0);
          }
        window.ShopifyXR.setupXRElements ();
      } else
        document.addEventListener ('shopify_xr_initialized', function () {
          a ();
        });
  }
  function t (e) {
    if (!e)
      for (var t in r) {
        var i;
        r.hasOwnProperty (t) &&
          ((i = r[t]).modelViewerUi ||
            (i.modelViewerUi = new Shopify.ModelViewerUI (
              i.$element
            )), (function (e) {
            var t = c[e.sectionId];
            e.$container.on ('mediaVisible', function () {
              t.$element.attr (
                'data-shopify-model3d-id',
                e.modelId
              ), theme.Helpers.isTouch () || e.modelViewerUi.play ();
            }), e.$container
              .on ('mediaHidden', function () {
                t.$element.attr (
                  'data-shopify-model3d-id',
                  t.defaultId
                ), e.modelViewerUi.pause ();
              })
              .on ('xrLaunch', function () {
                e.modelViewerUi.pause ();
              });
          }) (i));
      }
  }
  return {
    init: function (e, n) {
      (o[n] = {loaded: !1}), e.each (function (e) {
        var t,
          i = $ (this),
          s = i.data ('media-id'),
          o = $ (i.find ('model-viewer')[0]),
          a = o.data ('model-id');
        0 === e &&
          ((t = i.closest (l).find (d)), (c[n] = {
            $element: t,
            defaultId: a,
          })), (r[s] = {modelId: a, sectionId: n, $container: i, $element: o});
      }), window.Shopify.loadFeatures ([
        {name: 'shopify-xr', version: '1.0', onLoad: a},
        {name: 'model-viewer-ui', version: '1.0', onLoad: t},
      ]), theme.LibraryLoader.load ('modelViewerUiStyles');
    },
    removeSectionModels: function (e) {
      for (var t in r) {
        r.hasOwnProperty (t) &&
          r[t].sectionId === e &&
          (r[t].modelViewerUi.destroy (), delete r[t]);
      }
      delete o[e];
    },
  };
}) ()), (theme.ProductVideo = (function () {
  var o = {},
    a = {html5: 'html5', youtube: 'youtube'},
    n = {productMediaWrapper: '[data-product-single-media-wrapper]'},
    r = {enableVideoLooping: 'enable-video-looping', videoId: 'video-id'};
  function c (e) {
    e
      ? (function () {
          for (var e in o)
            if (o.hasOwnProperty (e)) {
              var t = o[e];
              if (t.nativeVideo) continue;
              t.host === a.html5 &&
                (t.element.setAttribute (
                  'controls',
                  'controls'
                ), (t.nativeVideo = !0));
            }
        }) ()
      : t (a.html5);
  }
  function l () {
    window.YT.Player && t (a.youtube);
  }
  function t (e) {
    for (var t in o) {
      var i;
      !o.hasOwnProperty (t) || ((i = o[t]).host === e && i.ready ());
    }
  }
  return {
    init: function (e, t) {
      if (e.length) {
        var i = e.find ('iframe, video')[0], s = e.data ('mediaId');
        if (i)
          switch (((o[s] = {
            mediaId: s,
            sectionId: t,
            host: (function (e) {
              if ('VIDEO' === e.tagName) return a.html5;
              if (
                'IFRAME' === e.tagName &&
                /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test (
                  e.src
                )
              )
                return a.youtube;
              return null;
            }) (i),
            container: e,
            element: i,
            ready: function () {
              !(function (e) {
                if (e.player) return;
                var t = e.container.closest (n.productMediaWrapper),
                  i = t.data (r.enableVideoLooping);
                switch (e.host) {
                  case a.html5:
                    e.player = new Shopify.Plyr (e.element, {
                      loop: {active: i},
                    });
                    break;
                  case a.youtube:
                    var s = t.data (r.videoId);
                    e.player = new YT.Player (e.element, {
                      videoId: s,
                      events: {
                        onStateChange: function (e) {
                          0 === e.data && i && e.target.seekTo (0);
                        },
                      },
                    });
                }
                t.on ('mediaHidden xrLaunch', function () {
                  e.player &&
                    (e.host === a.html5 && e.player.pause (), e.host ===
                      a.youtube &&
                      e.player.pauseVideo &&
                      e.player.pauseVideo ());
                }), t.on ('mediaVisible', function () {
                  theme.Helpers.isTouch () ||
                    (e.player &&
                      (e.host === a.html5 && e.player.play (), e.host ===
                        a.youtube &&
                        e.player.playVideo &&
                        e.player.playVideo ()));
                });
              }) (this);
            },
          }), o[s].host)) {
            case a.html5:
              window.Shopify.loadFeatures ([
                {name: 'video-ui', version: '1.0', onLoad: c},
              ]), theme.LibraryLoader.load ('plyrShopifyStyles');
              break;
            case a.youtube:
              theme.LibraryLoader.load ('youtubeSdk', l);
          }
      }
    },
    hosts: a,
    loadVideos: t,
    removeSectionVideos: function (e) {
      for (var t in o) {
        var i;
        !o.hasOwnProperty (t) ||
          ((i = o[t]).sectionId === e &&
            (i.player && i.player.destroy (), delete o[t]));
      }
    },
  };
}) ()), (theme.LineItem = (function () {
  function e (e) {
    var t = (this.$container = $ (e)), i = t.attr ('data-section-id');
    (this.settings = {
      enableHistoryState: !1,
      namespace: '.ProductSection-' + i,
      sectionId: i,
      swatchColor: !0,
      swatchColorAdvanced: !0,
      swatchSize: !0,
    }), (this.selectors = {
      container: t,
      productImage: '.ProductImage-' + i,
      productColor: '.ProductColor-' + i,
      addToCart: '.AddToCart-' + i,
      addToCartText: '.AddToCartText-' + i,
      comparePrice: '.ComparePrice-' + i,
      originalPrice: '.ProductPrice-' + i,
      productPrices: '.product-single__price-' + i,
      originalSelectorId: '.ProductSelect-' + i,
      singleOptionSelector: '.single-option-selector-' + i,
      singleOptionSelectorId: '.single-option-selector-' + i,
      singleOptionSwatches: 'tawcvs-swatches-' + i,
    }), $ ('.ProductJson-' + i, t).html () &&
      (t.data ('section-state') ||
        ((this.productSingleObject = JSON.parse (
          $ ('.ProductJson-' + i, t).html ()
        )), (this.productSwatchSingleObject = JSON.parse (
          $ ('.ProductSwatchJson-' + i, t).html ()
        )), (this.productMoreSingleObject = JSON.parse (
          $ ('.ProductMoreJson-' + i, t).html ()
        )), this._updateProductObject (), this._initVariants (), this._initSwatches (), t.data (
          'section-state',
          !0
        )));
  }
  return (e.prototype = _.assignIn ({}, e.prototype, {
    _updateProductObject: function () {
      var s = this;
      $.each (s.productMoreSingleObject.variants, function (i, e) {
        $.each (e, function (e, t) {
          s.productSingleObject.variants[i][e] = t;
        });
      });
    },
    _initSwatches: function () {
      var c = this;
      var e,
        o = this.productSingleObject,
        t = this.productSwatchSingleObject,
        s = new Array ();
      if (
        ('1' == this.settings.swatchSize && s.push ('Size'), s.push (
          'size'
        ), '1' == this.settings.swatchColor &&
          (s.push ('Color'), s.push ('Colour'), s.push ('color'), s.push (
            'colour'
          )), 0 < s.length)
      ) {
        var a = !1,
          n = 0,
          r = theme.settings.assetUrl.substring (
            0,
            theme.settings.assetUrl.lastIndexOf ('?')
          ),
          l = theme.settings.assetUrl.substring (
            theme.settings.assetUrl.lastIndexOf ('?'),
            theme.settings.assetUrl.length
          );
        for (i = 0; i < o.options.length; i++) {
          var d = '',
            u = '',
            h = '',
            p = '',
            m = '',
            f = '',
            g = ' img',
            d = 'object' == typeof o.options[i]
              ? o.options[i].name
              : o.options[i],
            a = !1;
          if (-1 < s.indexOf (d)) {
            (a = !0), (n = i);
            var v = d.toLowerCase ();
            if ((/color|colour/i.test (v) && 0, a)) {
              var _ = new Array ();
              for (j = 0; j < o.variants.length; j++) {
                var y = o.variants[j],
                  w = ((e = y.options[n]), String (e)
                    .replace (/&/g, '&amp;')
                    .replace (/</g, '&lt;')
                    .replace (/>/g, '&gt;')
                    .replace (/"/g, '&quot;')),
                  b = w
                    .toLowerCase ()
                    .replace (/[^a-z0-9 -]/g, '')
                    .replace (/\s+/g, '-')
                    .replace (/-+/g, '-');
                c.settings.sectionId;
                _.indexOf (w) < 0 &&
                  ('color' != v && 'colour' != v
                    ? ((f = '<i>' + w + '</i>'), (g = ''))
                    : (f = '1' == this.settings.swatchColorAdvanced
                        ? null !== t[b] && void 0 !== t[b] && '' != t[b]
                            ? ((g =
                                ' img swatch_color_advanced'), '<i style="background-image:url(' +
                                r +
                                t[b] +
                                '.png' +
                                l +
                                ');"></i>')
                            : null !== y.featured_image
                                ? ((g =
                                    ' img swatch_color_advanced'), '<i style="background-image:url(' +
                                    theme.Images.getSizedImageUrl (
                                      y.featured_image.src,
                                      '100x'
                                    ) +
                                    ');"></i>')
                                : '<i style="background-color:' +
                                    w +
                                    ';background-image:url(' +
                                    r +
                                    b +
                                    '.png' +
                                    l +
                                    ');"></i>'
                        : '<i style="background-color:' +
                            w +
                            ';background-image:url(' +
                            r +
                            b +
                            '.png' +
                            l +
                            ');"></i>'), (h =
                    h +
                    '<div class="swatch-element ' +
                    v +
                    b +
                    ' available"><label class="swatch-label' +
                    g +
                    ($ (c.selectors.singleOptionSelectorId + '-' + n).val () ==
                      w
                      ? ' selected'
                      : '') +
                    '" title="' +
                    w +
                    '"><input class="swatch-radio swatch-' +
                    c.settings.sectionId +
                    '-' +
                    n +
                    '-' +
                    b +
                    '" type="radio" value="' +
                    w +
                    '" data-value="' +
                    w +
                    '" data-poption="' +
                    n +
                    '" name="option-' +
                    n +
                    '">' +
                    f +
                    '<span class="soldout-image"></span></label></div>'), _.push (
                    w
                  ));
              }
              (u =
                '<div class="' +
                c.selectors.singleOptionSwatches +
                ' wrapper-swatches swatch ' +
                v +
                '" data-attribute_name="attribute_pa_' +
                v +
                '">' +
                h +
                '</div>'), (p = $ (
                c.selectors.singleOptionSelectorId + '-' + n,
                c.selectors.container
              )), (m = $ (
                c.selectors.variationSelector + '-' + n,
                c.selectors.container
              )), '' != u &&
                (p.after (u), p.hide (), p
                  .closest ('.variation-select')
                  .addClass ('variation-select-hidden'), m.addClass (
                  'hide-choose-option'
                ));
            }
          }
        }
      }
      var k = '', C = '.' + c.selectors.singleOptionSwatches + ' .swatch-radio';
      0 <
        $ ('.' + c.selectors.singleOptionSwatches, c.selectors.container)
          .length &&
        ((k = $ (C)).unbind ('click'), k.on ('click', function () {
          var e = $ (this)
            .closest ('.selector-wrapper')
            .find ('.single-option-selector')
            .first (),
            t = $ (this).data ('poption'),
            s = $ (this).data ('value');
          s != e.val () &&
            (e.val (s).trigger ('change'), e
              .closest ('.selector-wrapper')
              .find ('.swatch-label')
              .removeClass ('selected'), e
              .closest ('.selector-wrapper')
              .find ('.option-select-value')
              .html (s), $ (this)
              .closest ('.swatch-label')
              .addClass ('selected')), (function (a, n, r) {
            if (1 < a.options.length)
              for (i = 0; i < a.options.length; i++)
                i != n &&
                  $ (
                    c.selectors.singleOptionSelectorId + '-' + i + ' option',
                    c.selectors.container
                  ).each (function () {
                    var e = 'unavailable', t = $ (this).attr ('value');
                    for (j = 0; j < a.variants.length; j++) {
                      var s = a.variants[j];
                      if (s.options[n] == r && s.options[i] == t) {
                        e = 1 == s.available ? 'available' : 'sold_out';
                        break;
                      }
                    }
                    var o =
                      '.swatch-' +
                      c.settings.sectionId +
                      '-' +
                      i +
                      '-' +
                      t
                        .toLowerCase ()
                        .replace (/[^a-z0-9 -]/g, '')
                        .replace (/\s+/g, '-')
                        .replace (/-+/g, '-');
                    $ (o, c.selectors.container)
                      .closest ('.swatch-element')
                      .removeClass ('available')
                      .removeClass ('sold_out')
                      .removeClass ('unavailable')
                      .addClass (e);
                  });
            else
              for (i = 0; i < a.options.length; i++)
                $ (
                  c.selectors.singleOptionSelectorId + '-' + i + ' option',
                  c.selectors.container
                ).each (function () {
                  var e = 'unavailable', t = $ (this).attr ('value');
                  for (j = 0; j < a.variants.length; j++) if (
                      a.variants[j].options[i] == t
                    ) {
                      e = a.variants[j].available ? 'available' : 'sold_out';
                      break;
                    }
                  var s =
                    '.swatch-' +
                    c.settings.sectionId +
                    '-' +
                    i +
                    '-' +
                    t
                      .toLowerCase ()
                      .replace (/[^a-z0-9 -]/g, '')
                      .replace (/\s+/g, '-')
                      .replace (/-+/g, '-');
                  $ (s, c.selectors.container)
                    .closest ('.swatch-element')
                    .removeClass ('available')
                    .removeClass ('sold_out')
                    .removeClass ('unavailable')
                    .addClass (e);
                });
          }) (o, t, s);
        })), $ (C, c.selectors.container)
        .closest ('.selector-wrapper')
        .find ('.swatch-label.selected .swatch-radio')
        .trigger ('click');
    },
    _initVariants: function () {
      var e = {
        $container: this.$container,
        enableHistoryState: !1,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject,
      };
      (this.variants = new slate.Variants (e)), this.$container.on (
        'variantChange' + this.settings.namespace,
        this._updateAddToCart.bind (this)
      ), this.$container.on (
        'variantImageChange' + this.settings.namespace,
        this._updateImages.bind (this)
      ), this.$container.on (
        'variantPriceChange' + this.settings.namespace,
        this._updatePrice.bind (this)
      );
    },
    _updateAddToCart: function (e) {
      var t = e.variant;
      t
        ? ($ (this.selectors.productPrices).removeClass (
            'visibility-hidden'
          ), t.available
            ? ($ (this.selectors.addToCart, this.selectors.container).prop (
                'disabled',
                !1
              ), t.inventory_quantity <= 0 &&
                'shopify' == t.inventory_management
                ? $ (
                    this.selectors.addToCartText,
                    this.selectors.container
                  ).text (theme.strings.preOrder)
                : $ (
                    this.selectors.addToCartText,
                    this.selectors.container
                  ).text (theme.strings.addToCart))
            : ($ (this.selectors.addToCart, this.selectors.container).prop (
                'disabled',
                !0
              ), $ (
                this.selectors.addToCartText,
                this.selectors.container
              ).text (theme.strings.soldOut)))
        : ($ (this.selectors.addToCart, this.selectors.container).prop (
            'disabled',
            !0
          ), $ (this.selectors.addToCartText, this.selectors.container).text (
            theme.strings.unavailable
          ), $ (this.selectors.productPrices).addClass ('visibility-hidden'));
    },
    _updateImages: function (e) {
      var t = e.variant;
      this._switchImage (t.featured_image), this._switchColor (t);
    },
    _updatePrice: function (e) {
      var t = e.variant;
      $ (this.selectors.originalPrice, this.selectors.container).html (
        theme.CurrencyPicker.formatMoney (t.price)
      ), t.compare_at_price > t.price
        ? $ (this.selectors.comparePrice, this.selectors.container)
            .html (theme.CurrencyPicker.formatMoney (t.compare_at_price))
            .removeClass ('hide')
        : $ (this.selectors.comparePrice, this.selectors.container).addClass (
            'hide'
          );
    },
    _switchImage: function (e) {
      $ (this.selectors.productImage)
        .attr ('data-bgset', theme.roarJs.bgSet (e))
        .removeClass ('lazyloaded')
        .addClass ('lazyload');
    },
    _switchColor: function (e) {
      var t = $ (this.selectors.productColor + ' .swatch-item');
      t.length &&
        (t.removeClass ('active'), t.each (function () {
          $ (this).data ('variant_id') == e.id && $ (this).addClass ('active');
        }));
    },
    onUnload: function () {
      this.$container.off (this.settings.namespace);
    },
  })), e;
}) ()), (theme.Instagram = (function () {
  function e (e) {
    var t = (this.$container = $ (e)), i = t.attr ('data-section-id');
    (this.settings = {
      template: '<div class="item"><a href="{{href}}" target="_blank"><span class="meta d-flex align-items-center justify-content-center"><span class="likes">{{likes}}</span><span class="comments">{{comments}}</span></span><img class="lazyload" src="{{src}}" data-srcset="{{srcset}}" /></a></div>',
      accessToken: t.data ('access_token'),
      count: t.data ('count'),
      selector: '#instagram-' + i,
    }), '' != this.settings.accessToken &&
      0 != this.settings.count &&
      this.init ();
  }
  return (e.prototype = _.assignIn ({}, e.prototype, {
    init: function (e) {
      var r = this, t = r._buildUrl ();
      $.get (t, function (e) {
        if ('object' == typeof e && 200 == e.meta.code && 0 < e.data.length) {
          var t = e.data, s = '';
          for ((i = 0), (len = t.length); i < len; i++) {
            var o = t[i],
              a = o.images.thumbnail.url,
              n =
                o.images.thumbnail.url +
                ' 150w, ' +
                o.images.low_resolution.url +
                ' 320w, ' +
                o.images.standard_resolution.url +
                ' 480w';
            s += r._makeTemplate (r.settings.template, {
              href: o.link,
              src: a,
              srcset: n,
              likes: o.likes.count,
              comments: o.comments.count,
            });
          }
          $ (r.settings.selector).append (s);
        }
      });
    },
    _buildUrl: function () {
      var e = 'https://api.instagram.com/v1/users/self/media/recent';
      return (e += '?access_token=' + this.settings.accessToken), (e +=
        '&count=' + this.settings.count);
    },
    _makeTemplate: function (e, t) {
      for (
        var i, s, o, a = /(?:\{{2})([\w\[\]\.]+)(?:\}{2})/, n = e;
        a.test (n);

      )
        (s = n.match (a)[1]), (o = null != (i = this._getObjectProperty (t, s))
          ? i
          : ''), (n = n.replace (a, function () {
          return '' + o;
        }));
      return n;
    },
    _getObjectProperty: function (e, t) {
      for (
        var i, s = (t = t.replace (/\[(\w+)\]/g, '.$1')).split ('.');
        s.length;

      ) {
        if (((i = s.shift ()), !(null != e && i in e))) return null;
        e = e[i];
      }
      return e;
    },
  })), e;
}) ()), (theme.CountdownTimer = (function () {
  function e (e) {
    var t = (this.$container = $ (e)).attr ('data-section-id');
    (this.settings = {
      selector: '.countdown-' + t + ':not(.is-countdown)',
    }), this.regional (), this.init ();
  }
  return (e.prototype = _.assignIn ({}, e.prototype, {
    regional: function () {
      if (void 0 === $.fn.countdown) return !1;
      ($.countdown.regionalOptions.roar = {
        labels: [
          'Years',
          'Months',
          'Weeks',
          theme.strings.days,
          theme.strings.hours,
          theme.strings.minutes,
          theme.strings.seconds,
        ],
        labels1: [
          'Year',
          'Month',
          'Week',
          theme.strings.day,
          theme.strings.hour,
          theme.strings.minute,
          theme.strings.second,
        ],
        compactLabels: ['y', 'm', 'w', 'd'],
        whichLabels: null,
        digits: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
        timeSeparator: ':',
        isRTL: theme.settings.rtl,
      }), $.countdown.setDefaults ($.countdown.regionalOptions.roar);
    },
    init: function (e) {
      if (void 0 === $.fn.countdown) return !1;
      $ (this.settings.selector).each (function () {
        var e, t, i = $ (this);
        '' != i.data ('end_date') &&
          ((e = i.data ('end_date').split ('-')), (t = new Date (
            e[2],
            parseInt (e[0]) - 1,
            e[1]
          )), new Date (), i.countdown ({
            until: t,
            alwaysExpire: !0,
            onExpiry: function () {
              i.hide ();
            },
          }));
      });
    },
  })), e;
}) ()), (theme.NewsletterPopup = (function () {
  function e (e) {
    var t = (this.$container = $ (e)).attr ('data-section-id');
    (this.settings = {selector: '#newsletter-popup-' + t}), this.init ();
  }
  return (e.prototype = _.assignIn ({}, e.prototype, {
    init: function (e) {
      try {
        var t = $ (this.settings.selector),
          o = t.data ('period'),
          i = t.data ('delay'),
          s = t.data ('version');
        if (
          0 < o &&
          document.cookie.match (
            /^(.*;)?\s*roarStorage_newsletter\s*=\s*[^;]+(.*)?$/
          )
        )
          return;
        function a () {
          $ (document.body)
            .removeClass ('newsletter-opened')
            .removeClass ('newsletter2-opened'), $ (
            document.body
          ).trigger ('roarNewsletter_closed', [t]);
        }
        $ (window).on ('load', function () {
          setTimeout (function () {
            'popup2' == s
              ? $ (document.body).addClass ('newsletter2-opened')
              : $ (document.body).addClass ('newsletter-opened');
          }, 1e3 * i);
        }), $ (document.body).on ('roarNewsletter_closed', function (e, t) {
          var i = new Date (), s = i.getTime ();
          i.setTime (
            i.getTime () + 24 * o * 60 * 60 * 1e3
          ), (document.cookie = 'roarStorage_newsletter=' + s + ';expires=' + i.toGMTString () + ';path=/');
        }), $ (
          document.body
        ).on (
          'click',
          '.newsletter-popup-section .close_icon, .newsletter-popup2-section .close_icon, .newsletter-popup-backdrop',
          function (e) {
            e.preventDefault (), a ();
          }
        ), $ (document).on ('keyup', function (e) {
          27 === e.keyCode && a ();
        });
      } catch (e) {
        return;
      }
    },
  })), e;
}) ()), (theme.LookbookSection = (function () {
  function e (e) {
    var t = (this.$container = $ (e)).attr ('data-section-id');
    (this.settings = {init: !1}), (this.selectors = {
      lookbookId: '#lookbook__id-' + t + ' .roarlookbook',
      lookbookContent: '#lookbook__content-' + t,
    }), this.init ();
  }
  return (e.prototype = _.assignIn ({}, e.prototype, {
    init: function (e) {
      var t = this;
      $ (document).on ('DOMNodeInserted', t.selectors.lookbookId, function () {
        var e;
        0 == t.settings.init &&
          ((t.settings.init = !0), (e = $ (this)), setTimeout (function () {
            e
              .closest ('.slideshow__slide')
              .addClass (
                'slide-active'
              ), e.find ('.media__blank-preview').append ($ (t.selectors.lookbookContent));
          }, 0));
      });
    },
    onLoad: function () {
      roarLookbook.buildLookbook ();
    },
  })), e;
}) ()), (theme.ProductsSlider = (function () {
  function ProductsSlider (e) {
    var t = (this.$container = $ (e)).attr ('data-section-id');
    (this.settings = {
      finished: !1,
      cache: {},
      grid_num: 4,
      grid_row: 1,
      max_pages: 1,
      next_page: 1,
      cat_id: !1,
      storage_id: !1,
      storage_data: [],
      atts: {},
    }), (this.selectors = {
      slider: '.slick-slider-' + t + ':not(.slick-initialized)',
    }), this._initSlider ();
  }
  return (ProductsSlider.prototype = _.assignIn ({}, ProductsSlider.prototype, {
    _isEditor: function () {
      return (
        window !== window.parent &&
        0 <= window.top.location.pathname.indexOf ('/admin') &&
        0 <= window.top.location.pathname.indexOf ('/editor')
      );
    },
    _initSlider: function (evt) {
      var self = this, that = $ (self.selectors.slider);
      if (
        ((self.settings.atts = eval (
          '({' + that.data ('atts') + '})'
        )), (self.settings.max_pages = that.data (
          'max_pages'
        )), (self.settings.cat_id = that.data (
          'cat_id'
        )), (self.settings.storage_id = that.data (
          'storage_id'
        )), (self.settings.storage_data = []), void 0 !==
          self.settings.cat_id || void 0 !== self.settings.storage_id)
      ) {
        var parent = that.closest ('.products-slider');
        if (
          ((self.settings.grid_num = that.data (
            'grid_num'
          )), (self.settings.grid_row = that.data ('grid_row')), void 0 !==
            self.settings.storage_id && self.settings.storage_id.length)
        ) {
          var storageName = 'roarStorage_' + self.settings.storage_id,
            items = localStorage.getItem (storageName) || '[]';
          try {
            items = JSON.parse (items);
          } catch (e) {
            localStorage.removeItem (storageName), (items = JSON.parse ('[]'));
          }
          var productId = 0,
            productId = void 0 !== window.ShopifyAnalytics
              ? window.ShopifyAnalytics.meta.product.id
              : weketingShop.productJson.id;
          items.includes (productId) &&
            items.splice (
              items.indexOf (productId),
              1
            ), (self.settings.storage_data = items);
          var howManyToShow = Math.min (self.settings.storage_data.length, 180);
          howManyToShow &&
            (howManyToShow <= self.settings.grid_num * self.settings.grid_row &&
              $ ('.slick-arrows', parent).remove (), self._buildSlider ());
        }
        self.settings.max_pages < 2 ||
          ($ ('.slick-prev', parent).off ('click').on ('click', function (e) {
            e.preventDefault (), self._isEditor () || ((self.settings.next_page = self.settings.next_page - 1), self.settings.next_page <= 0 && (self.settings.next_page = self.settings.max_pages), self._buildSlider ());
          }), $ ('.slick-next', parent)
            .off ('click')
            .on ('click', function (e) {
              e.preventDefault (), self._isEditor () || ((self.settings.next_page = self.settings.next_page + 1), self.settings.next_page > self.settings.max_pages && (self.settings.next_page = 1), self._buildSlider ());
            }), $ (window).scroll (function () {
            var e = $ ('.slick-arrows', parent),
              t = $ ('.slick-prev', parent),
              i = $ ('.slick-next', parent),
              s = $ (window).height () / 2,
              o = ($ (window).outerWidth (!0), parent.outerWidth (!0)),
              a = $ (window).scrollTop (),
              n = parent.offset ().top - s,
              r = parent.offset ().left - 50,
              c = o + parent.offset ().left + 50 - i.outerWidth (),
              l = t.outerHeight (),
              d = n + (parent.height () - l),
              u = 'left';
            theme.settings.rtl &&
              (u =
                'right'), $ (window).width () <= 1024 && ((r += 35), (c -= 35)), t.css (u, r + 'px'), i.css (u, c + 'px'), a < n || d < a ? e.removeClass ('show-arrow') : e.addClass ('show-arrow');
          }));
      }
    },
    _buildSlider: function () {
      var e = this, t = !1, i = 1e3;
      void 0 === e.settings.cache[e.settings.next_page] &&
        ((t = void 0 !== e.settings.cat_id
          ? e._ajaxCollection ()
          : e._ajaxStorage ()), (i = 0));
      var s = $ (e.selectors.slider).closest ('.products-slider');
      s.addClass ('loading'), $.when (t).done (function () {
        setTimeout (function () {
          e._buildProducts (), e._lineItem ();
        }, i), setTimeout (function () {
          s.removeClass ('loading');
        }, i + 250);
      });
    },
    _ajaxCollection: function () {
      var i = this, s = $ (i.selectors.slider).closest ('.products-slider');
      if (!s.hasClass ('loading') && !s.hasClass ('finished')) {
        i = this;
        return $.ajax ({
          url: '/collections/' + i.settings.cat_id,
          type: 'GET',
          dataType: 'html',
          data: {
            view: 'custom',
            limit: i.settings.grid_num + '*' + i.settings.grid_row,
            page: i.settings.next_page,
            type: i.settings.atts.image_ratio +
              '*' +
              +i.settings.atts.image_ratio_crop +
              '*' +
              +i.settings.atts.image_second +
              '*' +
              i.settings.atts.image_overlay +
              '*' +
              i.settings.atts.product_hover +
              '*' +
              +i.settings.atts.vendor +
              '*' +
              +i.settings.atts.review +
              '*' +
              +i.settings.atts.quickview +
              '*' +
              +i.settings.atts.wishlist +
              '*' +
              +i.settings.atts.compare,
            cache: !1,
          },
          success: function (e) {
            if ($ (e).find ('.product').length) {
              if (
                ((i.settings.cache[i.settings.next_page] = e), 0 ==
                  $ (e).data ('is_next'))
              ) {
                i.settings.finished = !0;
                for (var t = 1; t <= i.settings.next_page; t++)
                  void 0 === i.settings.cache[t] && (i.settings.finished = !1);
              }
              i._buildProducts ();
            } else i.settings.finished = !0;
            i.settings.finished && s.addClass ('finished');
          },
        });
      }
    },
    _ajaxStorage: function () {
      var i = this, s = $ (i.selectors.slider).closest ('.products-slider');
      if (!s.hasClass ('loading') && !s.hasClass ('finished')) {
        var e = (i = this).settings.grid_num * i.settings.grid_row,
          t = (i.settings.next_page - 1) * e,
          o = i.settings.storage_data
            .splice (t, e)
            .map (function (e) {
              return 'id:' + e;
            })
            .join (' OR ');
        return $.ajax ({
          url: '/search',
          data: {view: 'viewed', type: 'product', q: o},
          dataType: 'html',
          type: 'GET',
          success: function (e) {
            if ($ (e).find ('.product').length) {
              if (
                ((i.settings.cache[i.settings.next_page] = e), s
                  .closest ('.products-slider_hide')
                  .removeClass ('hide'), 0 == i.settings.storage_data.length)
              ) {
                i.settings.finished = !0;
                for (var t = 1; t <= i.settings.next_page; t++)
                  void 0 === i.settings.cache[t] && (i.settings.finished = !1);
              }
              i._buildProducts ();
            } else i.settings.finished = !0;
            i.settings.finished && s.addClass ('finished');
          },
        });
      }
    },
    _buildProducts: function () {
      var e = $ (this.selectors.slider).closest ('.products-slider'),
        t = $ (this.settings.cache[this.settings.next_page]),
        i = e.find ('.products');
      $.fn.countdown &&
        i.find ('.product__countdown .is-countdown').each (function () {
          $ (this).countdown ('destroy');
        }), i.empty (), 0 < t.find ('.product').length &&
        (t
          .find ('.product__image')
          .removeClass ('lazyloaded')
          .removeClass ('lazyloading')
          .addClass ('lazyload'), t.find ('.product').each (function () {
          i.append ($ (this));
        }));
    },
    _lineItem: function () {
      theme.roarJs.initReviews (), theme.roarJs.splitText (), theme.roarJs.animationProduct (), theme.roarJs.fixtooltipHover ();
      var e = new theme.Sections ();
      e.register ('line_item', theme.LineItem), e.register (
        'countdown-timer',
        theme.CountdownTimer
      );
    },
    onLoad: function () {
      this._lineItem ();
    },
  })), ProductsSlider;
}) ()), (theme.ProductTabs = (function () {
  function e (e) {
    (this.$container = $ (e)).attr ('data-section-id');
    (this.selectors = {
      container: '.tabs__container',
      title: '.tabs__title',
      panel: '.tabs__panel',
    }), this._initTabs (), this._productsSlider ();
  }
  return (e.prototype = _.assignIn ({}, e.prototype, {
    _initTabs: function (e) {
      var r = this;
      $ (document).off ('click', r.selectors.title), $ (document).on (
        'click',
        r.selectors.title,
        function (e) {
          e.preventDefault ();
          var t = $ (this),
            i = t.closest (r.selectors.container),
            s = $ (t.attr ('href')),
            o = s.find ('.slick-slider'),
            a = i.find (r.selectors.title),
            n = i.find (r.selectors.panel);
          a.removeClass ('active'), n.removeClass ('active'), t.addClass (
            'active'
          ), s.addClass ('active'), o.hasClass ('slick-initialized') &&
            o.slick ('setPosition');
        }
      );
    },
    _productsSlider: function () {
      new theme.Sections ().register (
        'products-slider-sub',
        theme.ProductsSlider
      );
    },
    _lineItem: function () {
      theme.roarJs.initReviews (), theme.roarJs.fixtooltipHover ();
      var e = new theme.Sections ();
      e.register ('line_item', theme.LineItem), e.register (
        'countdown-timer',
        theme.CountdownTimer
      );
    },
    onLoad: function () {
      this._lineItem ();
    },
  })), e;
}) ()), (theme.RichBanner = (function () {
  function e (e) {
    var t = (this.$container = $ (e)),
      i = (this.sectionId = t.attr ('data-section-id'));
    (this.selectors = {
      bannerId: '#shopify-section-' + i,
      bannerNamspace: '#rich-banners-' + i,
      bannerAnime: '#rich-banners-' + i + ' .has--anime-fx',
      bannerTilter: '#rich-banners-' + i + ' .has--tilt-effect',
      bannerSlider: '#rich-banners-' +
        i +
        ' .rich-banner--group.is-slick_slider',
    }), (this.settings = {
      mediaQueryMediumUp: 'screen and (min-width: 768px)',
      mediaQuerySmall: 'screen and (max-width: 767px)',
      sliderActive: !1,
    }), this._initBreakpoints (), this._initAnime (), this._initTilter ();
  }
  return (e.prototype = _.assignIn ({}, e.prototype, {
    _initBreakpoints: function () {
      var e = this;
      enquire.register (this.settings.mediaQuerySmall, {
        match: function () {
          e.settings.sliderActive && e._destroySlider (), e._initSlider ();
        },
      }), enquire.register (this.settings.mediaQueryMediumUp, {
        match: function () {
          e.settings.sliderActive && e._destroySlider (), e._initSlider (!1);
        },
      });
    },
    _destroySlider: function () {
      var e = this;
      $ (e.selectors.bannerSlider).each (function () {
        $ (this)
          .find ('.rich-banner--slider.slick-initialized')
          .slick ('unslick'), (e.settings.sliderActive = !1);
      });
    },
    _initSlider: function (s) {
      var o = this;
      $ (o.selectors.bannerSlider).each (function () {
        var e = $ (this);
        void 0 === s && (s = !0);
        var t = e.find ('.rich-banner--slider:not(.slick-initialized)'),
          i = {
            rtl: theme.settings.rtl,
            dots: !1,
            arrows: !0,
            slidesToScroll: 1,
            slidesToShow: e.data ('per_slide'),
            autoplay: e.data ('autoplay'),
            autoplaySpeed: e.data ('interval'),
            variableWidth: e.data ('variable_width'),
            centerMode: e.data ('variable_width'),
            appendArrows: $ ('.slick-arrows', t.parent ()),
            prevArrow: '<button class="slick-prev" type="button"><svg class="svg-icon"><use xlink:href="#global__symbols-prev"></use></svg></button>',
            nextArrow: '<button class="slick-next" type="button"><svg class="svg-icon"><use xlink:href="#global__symbols-next"></use></svg></button>',
          };
        1 == s &&
          (i.slidesToShow = e.data (
            'per_slide_mb'
          )), t.slick (i), (o.settings.sliderActive = !0);
      });
    },
    _initTilter: function () {
      $ (this.selectors.bannerTilter).each (function () {
        var e = $ (this);
        e.on ('mousemove', function (e) {
          var t = $ (this).offset ().left,
            i = $ (this).offset ().top,
            s = e.pageX - t,
            o = e.pageY - i,
            a = $ (this).width () / 2 - s,
            n = $ (this).height () / 2 - o;
          $ (this).css (
            'transform',
            'perspective(500px) rotateX(' +
              n / 40 +
              'deg) rotateY(' +
              -a / 40 +
              'deg) translateZ(10px)'
          );
          Math.sign (a), Math.abs (a);
          $ (this).removeClass ('tilt-leave');
        }), e.on ('mouseleave', function () {
          $ (this).addClass ('tilt-leave');
        });
      });
    },
    _initAnime: function () {
      $ (this.selectors.bannerAnime).each (function () {
        var e = $ (this), t = e.data ('fx'), i = e.data ('fx_type');
        t &&
          ('dominos' == i
            ? anime
                .timeline ({loop: !0})
                .add ({
                  targets: e.find ('.fx__dominos .letter').toArray (),
                  rotateY: [-90, 0],
                  duration: 1300,
                  delay: function (e, t) {
                    return 45 * t;
                  },
                })
                .add ({
                  targets: e.find ('.fx__dominos').toArray (),
                  opacity: 0,
                  duration: 1e3,
                  easing: 'easeOutExpo',
                  delay: 1e3,
                })
            : 'vertical-lines' == i
                ? anime
                    .timeline ({loop: !0})
                    .add ({
                      targets: e
                        .find ('.fx__vertical-lines .letter')
                        .toArray (),
                      scale: [0.3, 1],
                      opacity: [0, 1],
                      translateZ: 0,
                      easing: 'easeOutExpo',
                      duration: 600,
                      delay: function (e, t) {
                        return 70 * (t + 1);
                      },
                    })
                    .add ({
                      targets: e.find ('.fx__vertical-lines .line').toArray (),
                      scaleX: [0, 1],
                      opacity: [0.5, 1],
                      easing: 'easeOutExpo',
                      duration: 700,
                      offset: '-=875',
                      delay: function (e, t, i) {
                        return 80 * (i - t);
                      },
                    })
                    .add ({
                      targets: e.find ('.fx__vertical-lines').toArray (),
                      opacity: 0,
                      duration: 1e3,
                      easing: 'easeOutExpo',
                      delay: 1e3,
                    })
                : 'fading' == i
                    ? anime
                        .timeline ({loop: !0})
                        .add ({
                          targets: e.find ('.fx__fading .letter').toArray (),
                          opacity: [0, 1],
                          easing: 'easeInOutQuad',
                          duration: 2250,
                          delay: function (e, t) {
                            return 150 * (t + 1);
                          },
                        })
                        .add ({
                          targets: e.find ('.fx__fading').toArray (),
                          opacity: 0,
                          duration: 1e3,
                          easing: 'easeOutExpo',
                          delay: 1e3,
                        })
                    : 'intro' == i
                        ? anime
                            .timeline ({loop: !0})
                            .add ({
                              targets: e.find ('.fx__intro .letter').toArray (),
                              translateX: [40, 0],
                              translateZ: 0,
                              opacity: [0, 1],
                              easing: 'easeOutExpo',
                              duration: 1200,
                              delay: function (e, t) {
                                return 500 + 30 * t;
                              },
                            })
                            .add ({
                              targets: e.find ('.fx__intro .letter').toArray (),
                              translateX: [0, -30],
                              opacity: [1, 0],
                              easing: 'easeInExpo',
                              duration: 1100,
                              delay: function (e, t) {
                                return 100 + 30 * t;
                              },
                            })
                        : 'surprising' == i
                            ? anime
                                .timeline ({loop: !0})
                                .add ({
                                  targets: e
                                    .find ('.fx__surprising .word')
                                    .toArray (),
                                  scale: [14, 1],
                                  opacity: [0, 1],
                                  easing: 'easeOutCirc',
                                  duration: 800,
                                  delay: function (e, t) {
                                    return 800 * t;
                                  },
                                })
                                .add ({
                                  targets: e
                                    .find ('.fx__surprising')
                                    .toArray (),
                                  opacity: 0,
                                  duration: 1e3,
                                  easing: 'easeOutExpo',
                                  delay: 1e3,
                                })
                            : anime
                                .timeline ({loop: !0})
                                .add ({
                                  targets: e
                                    .find ('.fx__typing .line')
                                    .toArray (),
                                  scaleY: [0, 1],
                                  opacity: [0.5, 1],
                                  easing: 'easeOutExpo',
                                  duration: 700,
                                })
                                .add ({
                                  targets: e
                                    .find ('.fx__typing .line')
                                    .toArray (),
                                  translateX: [
                                    0,
                                    e
                                      .find ('.fx__typing .letters')
                                      .first ()
                                      .width (),
                                  ],
                                  easing: 'easeOutExpo',
                                  duration: 700,
                                  delay: 100,
                                })
                                .add ({
                                  targets: e
                                    .find ('.fx__typing .letter')
                                    .toArray (),
                                  opacity: [0, 1],
                                  easing: 'easeOutExpo',
                                  duration: 600,
                                  offset: '-=775',
                                  delay: function (e, t) {
                                    return 34 * (t + 1);
                                  },
                                })
                                .add ({
                                  targets: e.find ('.fx__typing').toArray (),
                                  opacity: 0,
                                  duration: 1e3,
                                  easing: 'easeOutExpo',
                                  delay: 1e3,
                                }));
      });
    },
    _lineItem: function () {
      theme.roarJs.initReviews (), theme.roarJs.fixtooltipHover ();
      var e = new theme.Sections ();
      e.register ('line_item', theme.LineItem), e.register (
        'countdown-timer',
        theme.CountdownTimer
      );
    },
    onLoad: function () {
      this._lineItem ();
    },
    onUnload: function (e) {
      this.$container.off (this.bannerNamspace);
    },
  })), e;
}) ()), (theme.CollectionsSlider = (function () {
  function e (e) {
    var t = (this.$container = $ (e)),
      i = (this.sectionId = t.attr ('data-section-id'));
    (this.selectors = {
      container: '#CollectionsSlider-' + i,
      carousel: '#CollectionsSlider-' + i + ' .slider_large',
      carousel_small: '#CollectionsSlider-' + i + ' .slider_small',
      carousel_content: '#CollectionsSlider-' + i + ' .slider_content-wrapper',
    }), this.beforeInit (), this.init ();
  }
  return (e.prototype = _.assignIn ({}, e.prototype, {
    beforeInit: function () {
      var e = 0.01 * window.innerHeight;
      function i (e, t, i) {
        e &&
          e.getCellElements ().forEach (function (e) {
            e.classList[t] (i);
          });
      }
      document.documentElement.style.setProperty (
        '--vh',
        e + 'px'
      ), window.addEventListener ('resize', function () {
        var e = 0.01 * window.innerHeight;
        document.documentElement.style.setProperty ('--vh', e + 'px');
      }), void 0 === Flickity.prototype._createPrevNextCells &&
        (Flickity.createMethods.push (
          '_createPrevNextCells'
        ), (Flickity.prototype._createPrevNextCells = function () {
          this.on ('select', this.setPrevNextCells);
        }), (Flickity.prototype.setPrevNextCells = function () {
          i (this.previousSlide, 'remove', 'is-previous'), i (
            this.nextSlide,
            'remove',
            'is-next'
          );
          var e = fizzyUIUtils.modulo (
            this.selectedIndex - 1,
            this.slides.length
          ),
            t = fizzyUIUtils.modulo (
              this.selectedIndex + 1,
              this.slides.length
            );
          (this.previousSlide = this.slides[e]), (this.nextSlide = this.slides[
            t
          ]), i (this.previousSlide, 'add', 'is-previous'), i (
            this.nextSlide,
            'add',
            'is-next'
          );
        }));
    },
    init: function () {
      var s = this,
        a = $ (s.selectors.carousel),
        i = $ (s.selectors.carousel_small),
        e = ($ (s.selectors.carousel_content), Math.floor (
          i.find ('.slideshow__slide').length
        ) - 1),
        o = a.data ('autoplay'),
        t = a.data ('speed'),
        n = a.find ('.slideshow__image'),
        r = i.find ('.slideshow__image');
      theme.settings.rtl && (e = 1);
      var c = new Flickity (s.selectors.carousel_content, {
        rightToLeft: theme.settings.rtl,
        prevNextButtons: !0,
        pageDots: !0,
        wrapAround: !0,
        autoPlay: !!o && t,
        draggable: !1,
        setGallerySize: !1,
        sync: s.selectors.carousel,
        arrowShape: 'M3.1,28.9 28.6,3.4 32.9,7.7 14.7,25.9 68.1,25.9 68.1,32 14.7,32 32.9,50.2 28.6,54.5 z',
        on: {ready: function () {}},
      }),
        l = new Flickity (s.selectors.carousel_small, {
          rightToLeft: theme.settings.rtl,
          bgLazyLoad: 1,
          imagesLoaded: !0,
          prevNextButtons: !1,
          pageDots: !1,
          wrapAround: !0,
          autoPlay: !!o && t,
          draggable: !1,
          setGallerySize: !1,
          initialIndex: e,
          on: {
            ready: function () {
              var e = new TimelineLite (), t = i.find ('.flickity-slider');
              e.fromTo (
                t,
                2,
                {scale: 1.2},
                {ease: Power4.easeInOut, scale: 1},
                0
              );
            },
          },
        });
      l.on ('scroll', function () {
        l.slides.forEach (function (e, t) {
          var i = r[t], s = 0;
          i &&
            ((s = 0 === t
              ? Math.abs (l.x) > l.slidesWidth
                  ? l.slidesWidth +
                      l.x +
                      l.slides[l.slides.length - 1].outerWidth +
                      e.target
                  : e.target + l.x
              : t === d.slides.length - 1 &&
                  Math.abs (l.x) + l.slides[t].outerWidth < l.slidesWidth
                  ? e.target - l.slidesWidth + l.x - l.slides[t].outerWidth
                  : e.target + l.x), void 0 === window.mobileCheck ||
              window.mobileCheck () ||
              theme.settings.rtl ||
              (i.style.transform = 'translateX(' + -0.5 * s + 'px)'));
        });
      });
      var d = new Flickity (s.selectors.carousel, {
        rightToLeft: theme.settings.rtl,
        bgLazyLoad: 1,
        imagesLoaded: !0,
        accessibility: !1,
        prevNextButtons: !1,
        pageDots: !1,
        contain: !0,
        wrapAround: !0,
        setGallerySize: !1,
        sync: s.selectors.carousel_content,
        autoPlay: !!o && t,
        arrowShape: {x0: 10, x1: 60, y1: 50, x2: 60, y2: 45, x3: 15},
        on: {
          ready: function () {
            var e = new TimelineLite (),
              t = a.find ('.flickity-slider'),
              i = a.find ('.slider-content-wrapper'),
              s = a.find ('.flickity-button svg'),
              o = a.find ('.flickity-page-dots');
            e.fromTo (
              t,
              2,
              {scale: 1.2},
              {ease: Power4.easeInOut, scale: 1},
              0
            ), e.fromTo (
              i,
              2.4,
              {opacity: 0},
              {ease: Power4.easeInOut, opacity: 1},
              1
            ), e.fromTo (
              [s, o],
              2,
              {opacity: 0},
              {ease: Power4.easeInOut, opacity: 1},
              1.3
            );
          },
        },
      });
      $ (document).on (
        'click',
        s.selectors.carousel_content + ' .flickity-prev-next-button.previous',
        function () {
          l.previous ();
        }
      ), $ (document).on (
        'click',
        s.selectors.carousel_content + ' .flickity-prev-next-button.next',
        function () {
          l.next ();
        }
      );
      var u = null, h = null;
      d.on ('dragMove', function (e, t, i) {
        (u =
          d.selectedIndex), (h = s.getSwipeDirection (i)), o && l.stopPlayer ();
      }), d.on ('dragEnd', function (e) {
        d.selectedIndex !== u && ('left' === h ? l.next () : l.previous ());
      }), $ (s.selectors.container).on ('mouseenter', function () {
        d.stopPlayer (), l.stopPlayer (), c.stopPlayer ();
      }), d.on ('scroll', function () {
        d.slides.forEach (function (e, t) {
          var i = n[t], s = 0;
          i &&
            ((s = 0 === t
              ? Math.abs (d.x) > d.slidesWidth
                  ? d.slidesWidth +
                      d.x +
                      d.slides[d.slides.length - 1].outerWidth +
                      e.target
                  : e.target + d.x
              : t === d.slides.length - 1 &&
                  Math.abs (d.x) + d.slides[t].outerWidth < d.slidesWidth
                  ? e.target - d.slidesWidth + d.x - d.slides[t].outerWidth
                  : e.target + d.x), void 0 === window.mobileCheck ||
              window.mobileCheck () ||
              theme.settings.rtl ||
              (i.style.transform = 'translateX(' + -0.5 * s + 'px)'));
        });
      });
    },
    getSwipeDirection: function (e) {
      return 0 < e.x ? 'right' : 'left';
    },
    onSelect: function () {
      void 0 !== theme.roarAdminJs && theme.roarAdminJs.refresh ();
    },
    onLoad: function () {},
    onUnload: function (e) {},
  })), e;
}) ());
var roarLookbook = {
  getSizedImageUrl: function (e, t) {
    if (
      (((s = document.createElement ('a')).href = e), 'cdn.shopify.com' !=
        s.hostname)
    )
      return e;
    if (null == t) return e;
    if ('master' == t) return roarLookbook.removeProtocol (e);
    var i = e.match (/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
    if (null == i) return null;
    var s = e.split (i[0]), o = i[0];
    return roarLookbook.removeProtocol (s[0] + '_' + t + o);
  },
  removeProtocol: function (e) {
    return e.replace (/http(s)?:/, '');
  },
  isProductUrl: function (e) {
    var t = window.location.hostname, i = document.createElement ('a');
    return (i.href = e), i.hostname == t;
  },
  isImageUrl: function (s) {
    return new Promise (function (e, t) {
      var i = new Image ();
      $ (i)
        .load (function () {
          e (!0);
        })
        .error (function () {
          e (!1);
        })
        .attr ('src', s);
    });
  },
  buildLookbook: function () {
    $ ('.roarlookbook').each (function (e) {
      var t, i = $ (this);
      i.hasClass ('roarlookbook_init') ||
        ((t = i.find ('.image-preview')), roarLookbook
          .isImageUrl (t.attr ('src'))
          .then (function () {
            var e = i.find ('.media__blank-preview');
            i.addClass ('roarlookbook_init'), e.addClass ('sfx-fadeIn');
          }));
    });
  },
  resetHotspots: function (s) {
    var e = $ ('.hotspot', s), o = s.attr ('data-lookbook');
    e.each (function () {
      var e = $ (this), t = e.attr ('data-id'), i = $ ('#' + o + '-' + t, s);
      i.fadeOut ('fast', function () {
        i.remove (), e.removeClass ('hotspot_init');
      });
    });
  },
  hotspotPopup: function () {
    $ ('.roarlookbook').on ('click', '.hotspot', function (e) {
      var c = $ (this);
      if (c.hasClass ('hotspot_init')) {
        l = c.closest ('.roarlookbook');
        roarLookbook.resetHotspots (l);
      } else {
        var t,
          i,
          l = c.closest ('.roarlookbook'),
          s = c.attr ('data-id'),
          o = c.closest ('.roarlookbook').attr ('data-lookbook') + '-' + s,
          d =
            '#' + c.closest ('.roarlookbook').attr ('data-lookbook') + '-' + s,
          a = c.attr ('data-title'),
          n = c.attr ('data-image'),
          r = c.attr ('data-price'),
          u = c.attr ('data-url'),
          h = '';
        if ('' == a && '' == u) return !1;
        c.addClass ('hotspot_loading'), roarLookbook.resetHotspots (l), (h +=
          '<div id="' + o + '" class="hotspot-widget hotspot-loading">'), (h +=
          '<div class="hotspot-content">'), (h +=
          '<span class="hotspot-close">×</span>'), (h +=
          '<div class="hotspot-inner">'), '' != n &&
          ((t =
            '<img src="' +
            roarLookbook.getSizedImageUrl (n, '80x') +
            '" src="' +
            roarLookbook.getSizedImageUrl (n, '300x') +
            '" data-srcset="' +
            roarLookbook.getSizedImageUrl (n, '300x') +
            ' 1x, ' +
            roarLookbook.getSizedImageUrl (n, '600x') +
            ' 2x" alt="" />'), (h += '' != u
            ? '<a href="' + u + '">' + t + '</a>'
            : t)), '' != a &&
          ((h += '<h3>'), (h += '' != u
            ? '<a href="' + u + '">' + a + '</a>'
            : a), (h += '</h3>')), '' != r &&
          ((h +=
            '<div class="price"><span class="money">' +
            r +
            '</span></div>'), roarLookbook.isProductUrl (u) &&
            ((h += '<div class="hotspot-btns">'), (h +=
              '<div class="hotspot-btn"><a href="' +
              u +
              '">' +
              theme.apps.details +
              '</a></div>'), (h +=
              '<div class="hotspot-btn"><a class="roar_add_to_cart" href="' +
              u +
              '?add-to-cart=true">' +
              theme.apps.buyNow +
              '</a></div>'), (h += '</div>'))), (h += '</div>'), (h +=
          '</div>'), (h += '</div>'), $ (d).length || l.append (h), $ (d).find (
          'img'
        ).length &&
          (i = $ (d).find ('img'))
            .attr ('src', i.attr ('data-src'))
            .removeAttr ('data-src')
            .attr ('srcset', i.attr ('data-srcset'))
            .removeAttr ('data-srcset'), roarLookbook
          .isImageUrl (n)
          .then (function () {
            setTimeout (function () {
              var e = $ (d),
                t = c.offset ().left,
                i = c.offset ().top,
                s = e.outerWidth (),
                o = e.outerHeight (),
                a = l.offset ().left,
                n = l.offset ().top,
                r = (l.outerWidth (), 'hotspot-right');
              s + 5 < t
                ? ((t = t - s - 5), (r = 'hotspot-left'))
                : (t =
                    t +
                    c.outerWidth () +
                    5), (i = i + c.outerHeight () / 2 - o / 2), e.css ({left: t - a, top: i - n}).removeClass ('hotspot-left').removeClass ('hotspot-right').addClass (r), c.removeClass ('hotspot_loading').addClass ('hotspot_init'), e.removeClass ('hotspot-loading').fadeIn ('fast');
            }, 600);
          });
      }
    }), $ (document).on ('click', '.hotspot-close', function (e) {
      var t = $ (this).closest ('.hotspot-widget'),
        i = t.attr ('id').split ('-')[1];
      $ ('.roarlookbook .hotspot[data-id="' + i + '"]').removeClass (
        'hotspot_init'
      ), t.fadeOut ('fast', function () {
        t.remove ();
      });
    }), $ ('.roarlookbook').on ('click', '.image-preview', function (e) {
      var t = $ (this).closest ('.roarlookbook');
      roarLookbook.resetHotspots (t);
    }), $ (window).resize (function (e) {
      $ ('.roarlookbook .hotspot_init').length &&
        $ ('.roarlookbook .hotspot_init').each (function () {
          $ (this).removeClass ('hotspot_init').trigger ('click');
        });
    });
  },
  addToCart: function () {
    $ (document).on ('click', '.roar_add_to_cart', function (e) {
      e.preventDefault ();
      var t = $ (this), i = t.closest ('.roarlookbook'), s = t.attr ('href');
      $.ajax ({
        type: 'GET',
        url: s,
        beforeSend: function () {},
        success: function (e) {
          $ (e)
            .find ('form[action="/cart/add"]')
            .appendTo (i)
            .submit ()
            .remove ();
        },
        dataType: 'html',
      });
    });
  },
  init: function () {
    $ ('.roarlookbook').length &&
      (roarLookbook.buildLookbook (), roarLookbook.hotspotPopup (), roarLookbook.addToCart ());
  },
};
(theme.roarJs = (function () {
  function d () {
    (function (e) {
      try {
        for (
          var t = e + '=', i = document.cookie.split (';'), s = 0;
          s < i.length;
          s++
        ) {
          for (var o = i[s]; ' ' == o.charAt (0); )
            o = o.substring (1, o.length);
          if (0 == o.indexOf (t)) return o.substring (t.length, o.length);
        }
        return null;
      } catch (e) {
        return null;
      }
    }) ('roarStorage_isAnAdult')
      ? $ ('#age__check').remove ()
      : $ ('#age__check').addClass ('active'), $ (document).off (
      'click',
      '#age__check .btn-birthdate'
    ), $ (document).on ('click', '#age__check .btn-birthdate', function () {
      var e = new Date ();
      e.setTime (e.getTime () + 12096e5);
      var t = '; expires=' + e.toGMTString ();
      (document.cookie =
        'roarStorage_isAnAdult=true;' +
        t +
        '; path=/'), $ ('#age__check').remove ();
    });
  }
  function u () {
    $ (document).off (
      'click',
      '.sidebar__btn, .sidebar__close, .sidebar__overlay'
    ), $ (
      document
    ).on (
      'click',
      '.sidebar__btn, .sidebar__close, .sidebar__overlay',
      function () {
        var e, t, i;
        $ ('body').hasClass ('sidebar-open')
          ? $ ('body').removeClass ('sidebar-open')
          : ($ ('body').addClass (
              'sidebar-open'
            ), (e = new TimelineLite ()), (t = $ (
              '.site-sidebar .widget-area'
            )), (i = $ ('.site-sidebar .site-widget')), theme.settings.rtl
              ? (e.fromTo (
                  t,
                  1,
                  {autoAlpha: 0},
                  {autoAlpha: 1, ease: Power0.easeInOut},
                  0.1
                ), e.staggerFromTo (
                  i,
                  0.5,
                  {opacity: 0, skewX: -10, x: 40},
                  {opacity: 1, skewX: 0, x: 0},
                  0.1,
                  0.2
                ))
              : (e.fromTo (
                  t,
                  1,
                  {autoAlpha: 0},
                  {autoAlpha: 1, ease: Power0.easeInOut},
                  0.1
                ), e.staggerFromTo (
                  i,
                  0.5,
                  {opacity: 0, skewX: 10, x: -40},
                  {opacity: 1, skewX: 0, x: 0},
                  0.1,
                  0.2
                )));
      }
    ), $ (document).off ('click', '.filters__btn'), $ (
      document
    ).on ('click', '.filters__btn', function () {
      $ ('.shop__filtering').slideToggle ();
    });
  }
  function p (e, t, i) {
    void 0 === i && (i = !1), $ ('.alert-message').remove ();
    var s = 1 == i
      ? '<div class="alert alert-message cart_message"><div class="alert__background" style="background-image:url(' +
          e +
          ');"></div><div class="alert__description">' +
          t +
          '</div></div>'
      : '<div class="alert alert-' +
          ('check' == e ? 'success' : 'error') +
          ' alert-message"><div class="alert__icon"><i class="ris ri-' +
          e +
          '"></i></div><div class="alert__content">' +
          t +
          '</div></div>';
    $ ('body').append (s);
  }
  function h (e) {
    $ ('body').addClass ('compare-opened');
    var t = $ ('.compare__modal');
    t.removeClass ('opened'), e &&
      e.length &&
      t.find ('.compare__content').empty ().html (e), t.addClass ('opened'), $ (
      '.compare__list tr'
    ).each (function () {
      $ (this).css ('height', $ (this).outerHeight ());
    }), $ ('.compare__list').clone ().appendTo ('.compare__left'), $ (
      '.compare__left td'
    ).remove ();
  }
  function m () {
    $ ('body').removeClass ('compare-opened'), $ (
      '.compare__modal'
    ).removeClass ('opened');
  }
  function f () {
    var t = 'roarStorage_compare', i = localStorage.getItem (t) || '[]';
    try {
      i = JSON.parse (i);
    } catch (e) {
      localStorage.removeItem (t), (i = JSON.parse ('[]'));
    }
    var e = i.filter (function (e) {
      return null != e;
    });
    return 10 < e.length ? e.slice (0, 10) : e;
  }
  function g (e) {
    var t = 10 < e.length ? e.slice (0, 10) : e;
    try {
      localStorage.setItem ('roarStorage_compare', JSON.stringify (t));
    } catch (e) {}
    return t;
  }
  function v () {
    var e, t = f (), i = $ ('.compare__link'), s = $ ('.compare__count');
    0 < s.length &&
      ((e = t.length), s.text (e), 0 < e
        ? (s.removeClass ('hide'), i.removeClass ('deactive'))
        : (s.addClass ('hide'), i.addClass ('deactive')));
  }
  function _ () {
    var o = ['/cart?', '/search?', '/collections/'];
    $ (document).ajaxComplete (function (e, t, i) {
      var s;
      !(function (e, t) {
        for (var i = 0; i < t.length; i++)
          if (e.match (('.*' + t[i].trim () + '.*').replace (' ', '.*')))
            return 1;
      }) (i.url, o) ||
        (theme.roarJs.initReviews (), theme.roarJs.splitText (), theme.roarJs.animationProduct (), theme.roarJs.fixtooltipHover (), (s = new theme.Sections ()).register (
          'line_item',
          theme.LineItem
        ), s.register ('countdown-timer', theme.CountdownTimer));
    });
  }
  function e () {
    function o (e) {
      var a = this,
        n = $ (window),
        r = n.scrollTop (),
        c = !0,
        l = n.width (),
        d = n.height (),
        u = null,
        h = null,
        p = null,
        t = !1;
      function m (e) {
        (r = n.scrollTop ()), (a.allowScrollUpdate = !0);
      }
      function f (e) {
        return e && '[object Function]' === {}.toString.call (e);
      }
      (a.init = function (e) {
        return (a.options = $.extend (
          {
            target: null,
            tween: null,
            ease: Linear.easeNone,
            min: 0,
            max: 1,
            minSize: 0,
            speed: 0.3,
            defaultProgress: 1,
            debug: !1,
            onMin: null,
            onMax: null,
            onOutside: null,
            onInside: null,
            onUpdate: null,
          },
          e
        )), null === a.options.target || a.options.target.length < 1
          ? (console.warn ('Extra Scroll Animator: no target specified'), !1)
          : null === a.options.tween
              ? (console.warn ('Extra Scroll Animator: no tween specified'), !1)
              : ((a.allowScrollUpdate = !0), a.update (), void a.repaint ());
      }), (a.updatePosition = function (e) {
        var t, i, s, o;
        c &&
          ((t = void 0 !== e && e
            ? 0
            : a.options.speed), (i = a.options.target.data ('coords')) &&
            ((o = 1 - (r - i.max) / (i.min - i.max)) <= 0 && !0 !== u
              ? ((u = !0), f (a.options.onMin) &&
                  a.options.onMin (), a.options.target.trigger (
                  'extra:scrollanimator:min'
                ))
              : 0 < o && !1 !== u && (u = !1), 1 <= o && !0 !== h
              ? ((h = !0), f (a.options.onMax) &&
                  a.options.onMax (), a.options.target.trigger (
                  'extra:scrollanimator:max'
                ))
              : o <= 1 && !1 !== h && (h = !1), (!0 !== u && !0 !== h) ||
              !1 === p
              ? o <= 1 &&
                  0 <= o &&
                  !0 !== p &&
                  ((p = !0), f (a.options.onInside) &&
                    a.options.onInside (), a.options.target.trigger (
                    'extra:scrollanimator:inside'
                  ))
              : ((p = !1), f (a.options.onOutside) &&
                  a.options.onOutside (), a.options.target.trigger (
                  'extra:scrollanimator:outside'
                )), !1 === p && (o = h ? 1 : 0), (o = Math.max (
              0,
              Math.min (o)
            )), (s = o), !0 === a.options.debug &&
              console.log (s), TweenLite.to (a.options.tween, t, {
              progress: o,
              ease: a.options.ease,
            })));
      }), (a.update = function () {
        (l = n.width ()), (d = n.height ());
        var e = {},
          t = a.options.target.offset ().top,
          i = a.options.target.height (),
          s = a.options.min,
          o = a.options.max;
        (e.min = t - d + d * s), (e.max =
          t - d + i + d * o), a.options.target.data (
          'coords',
          e
        ), a.options.tween.paused (!0), a.options.tween.progress (
          a.options.defaultProgress
        ), l < a.options.minSize
          ? n.off ('scroll', m)
          : (n.on ('scroll', m), a.updatePosition (!0)), f (
          a.options.onUpdate
        ) &&
          a.options.onUpdate (
            e
          ), a.options.target.trigger ('extra:scrollanimator:update', [e]);
      }), n.on ('extra:resize', a.update), n.on (
        'extra:scrollanimator:resize',
        a.update
      ), n.on (
        'extra:scrollanimator:tick',
        a.updatePosition
      ), (a.repaint = function () {
        c &&
          (a.allowScrollUpdate &&
            (a.updatePosition (), (a.allowScrollUpdate = !1)), window.requestAnimationFrame (
            a.repaint
          ));
      }), a.init (e), (a.updateTween = function (e) {
        a.options.tween &&
          a.options.tween.kill (), (a.options.tween = e), a.options.tween.paused (
          !0
        ), a.options.tween.progress (
          a.options.defaultProgress
        ), (a.allowScrollUpdate = !0), a.update ();
      }), (a.pause = function () {
        t ||
          (n.off ('scroll', m), n.off (
            'extra:resize',
            a.update
          ), (t = !(c = !1)));
      }), (a.resume = function () {
        t &&
          (l < a.options.minSize
            ? n.off ('scroll', m)
            : n.on ('scroll', m), n.on (
            'extra:resize',
            a.update
          ), (t = !(c = !0)), a.repaint ());
      }), (a.destroy = function () {
        (c = !1), n.off ('scroll', m), n.off ('extra:resize', a.update), n.off (
          'extra:scrollanimator:tick',
          a.updatePosition
        ), a.options.tween &&
          (a.options.tween.paused (!0), a.options.tween.progress (
            a.options.defaultProgress
          ), a.options.tween.kill ()), (a.allowScrollUpdate = !1);
      });
    }
    (window.initPrllx = function (e) {
      $ ('.site-main .article__image').length &&
        $ ('.site-main').find ('.article__image').each (function () {
          var e = $ (this),
            t = e.children (),
            i = e.find ('.prllx'),
            s = (t.width (), new TimelineLite ({onUpdate: function () {}}));
          s
            .set (i, {y: -1 * i.attr ('data-prllx')})
            .to (
              i,
              1,
              {
                y: i.attr ('data-prllx'),
                overwrite: 'all',
                ease: Power0.easeNone,
              },
              '-=0.5'
            ), new o ({target: e, tween: s, defaultProgress: 0, speed: 0, min: -0.2, max: 1.3}), e.on (
            'extra:scrollanimator:update',
            function (e) {
              e.stopPropagation ();
            }
          );
        });
    }), (window.initSkrollr = function () {
      if (
        0 == $ ('.site-main .skrollable').length ||
        'undefined' == typeof skrollr
      )
        return !1;
      $ ('.section__bground.skrollable')
        .css ('height', '120%')
        .closest ('.container-section')
        .addClass ('overflow-hidden');
      skrollr.init ({
        forceHeight: !1,
        smoothScrolling: !1,
        mobileCheck: function () {
          return !1;
        },
      });
    }), $ (window).on ('load', function () {
      void 0 === window.mobileCheck ||
        window.mobileCheck () ||
        (window.initPrllx (), window.initSkrollr ());
    });
  }
  function t () {
    if (void 0 === window.mobileCheck) return !1;
    992 < $ (window).width () &&
      !window.mobileCheck () &&
      0 < $ ('.products-grid.layout-2').length &&
      $ (
        '.products-grid.layout-2 .category__title:not(.split-text), .products-grid.layout-2 .product__link:not(.split-text), .product-single__notify label:not(.split-text)'
      ).each (function () {
        var e = $ (this);
        new SplitText (e, {type: 'lines'});
        e.addClass ('split-text').find ('div').wrapInner ('<span></span>');
      });
  }
  function i (e) {
    if (0 == theme.settings.animation) return !1;
    var t = new TimelineLite (),
      i = $ ('.product-single__title', e),
      s = $ ('.product-single .product__labels', e),
      o = $ ('.product-single .sidebar-container', e),
      a = $ ('.product-single__top .box-share-master-container', e),
      n = $ ('.product-single__right, .product-single__tools', e),
      r = $ ('.product-single__nav', e),
      c = $ ('.product-single__middle', e),
      l = $ ('.product-single__bottom', e);
    t.fromTo (
      i,
      1.6,
      {y: 100, opacity: 0},
      {ease: Power4.easeInOut, y: 0, opacity: 1},
      0.7
    ), t.fromTo (
      c,
      2,
      {y: 40, opacity: 0},
      {ease: Power4.easeInOut, y: 0, opacity: 1},
      0.8
    ), t.fromTo (
      l,
      2,
      {y: 40, opacity: 0},
      {ease: Power4.easeInOut, y: 0, opacity: 1},
      1
    ), t.fromTo (
      [s, a, n, r, o],
      2,
      {opacity: 0},
      {ease: Power4.easeInOut, opacity: 1},
      0.7
    );
  }
  function s () {
    if ('undefined' == typeof ScrollReveal || 0 == theme.settings.animation)
      return !1;
    (window.sr = ScrollReveal ()), sr.reveal (
      '.products-grid .product:not(.active)',
      {
        opacity: 0,
        viewFactor: 0.2,
        afterReveal: function (e) {
          if (void 0 === window.mobileCheck || 0 == theme.settings.animation)
            return !1;
          e.classList.add ('active');
          var t = $ (e).find (
            '.product__link div span, .category__title div span'
          ),
            i = $ (e).find ('.product__review, .more-products'),
            s = $ (e).find ('.product__price');
          (e.visuelRevealTL = new TimelineLite ()), 992 < $ (window).width () &&
            !window.mobileCheck () &&
            0 < $ ('.products-grid.layout-2').length &&
            (e.visuelRevealTL.fromTo (
              t,
              1,
              {ease: Power4.easeOut, x: 30, y: 100, skewX: 60, opacity: 0},
              {ease: Power4.easeOut, x: 0, y: 0, skewX: 0, opacity: 1},
              0
            ), null !== i &&
              e.visuelRevealTL.fromTo (
                i,
                2,
                {y: 10, opacity: 0},
                {ease: Power4.easeOut, y: 0, opacity: 1},
                0.4
              ), null !== s &&
              e.visuelRevealTL.fromTo (
                s,
                2,
                {y: 10},
                {ease: Power4.easeOut, y: 0, opacity: 1},
                0.2
              ));
        },
        beforeReveal: function (e) {
          e.classList.add ('active');
          var t = $ (e).find ('.product__image, .category__image');
          null !== t &&
            ((e.visuelRevealTL = new TimelineLite ()), e.visuelRevealTL.fromTo (
              t,
              2,
              {scale: 1.1},
              {ease: Power4.easeOut, scale: 1},
              0
            ));
        },
      },
      150
    );
  }
  function y () {
    'undefined' == typeof ParallaxScroll ||
      void 0 === window.mobileCheck ||
      window.mobileCheck () ||
      0 == theme.settings.animation ||
      ParallaxScroll.init (), e (), void 0 !== $.fn.imagesLoaded &&
      0 != theme.settings.animation &&
      $ ('.page-header-bg').imagesLoaded ({background: !0}, function () {
        $ ('.page-header-bg-wrapper').addClass ('loaded');
        var e = new TimelineLite (),
          t = $ ('.site-header__main'),
          i = $ ('.site-header__top'),
          s = $ ('.page-title'),
          o = $ ('.term-description'),
          a = $ ('.breadcrumbs'),
          n = $ ('.page-categories, .page-meta_list'),
          r = $ ('.page-delimiter'),
          c = $ ('.back-btn svg'),
          l = $ ('.content-area'),
          d = $ ('.site-pagination'),
          u = $ ('#site-footer'),
          h = $ ('body');
        h.addClass (
          'run-anim'
        ), e.fromTo ([t, i], 1, {autoAlpha: 0, opacity: 0}, {ease: Power4.easeInOut, autoAlpha: 1, opacity: 1}, 0.2).call (function (e) {
          h.removeClass ('run-anim');
        }), e.fromTo (
          s,
          1.2,
          {y: 100, opacity: 0},
          {ease: Power4.easeInOut, y: 0, opacity: 1},
          0.3
        ), e.fromTo (o, 1.4, {scale: 1.4, opacity: 0}, {ease: Power4.easeInOut, scale: 1, opacity: 1}, 0.2), e.fromTo (c, 1, {x: 20, opacity: 0}, {ease: Power4.easeInOut, x: 0, opacity: 1}, 0.5), !$ ('body').hasClass ('template-collection') && $ ('body').hasClass ('template-product') ? e.fromTo (a, 1.2, {y: 40, opacity: 0}, {ease: Power4.easeInOut, y: 0, opacity: 1}, 0.6) : e.fromTo (a, 1.2, {y: 40, opacity: 0}, {ease: Power4.easeInOut, y: 0, opacity: 1}, 0.25), e.fromTo (n, 1.4, {y: -40, opacity: 0}, {ease: Power4.easeInOut, y: 0, opacity: 1}, 0.25), e.fromTo (r, 1, {opacity: 0, width: 0}, {opacity: 1, width: 70}, 0.8), e.fromTo ([l, d], 1, {opacity: 0}, {opacity: 1}, 0.8), e.fromTo (u, 1, {opacity: 0}, {opacity: 1}, 1.5);
      }), i ($ ('.product-template__container')), 0 !=
      $ ('.blog-main .article__listing').length &&
      'undefined' != typeof ScrollReveal &&
      0 != theme.settings.animation &&
      ((window.sr = ScrollReveal ()), sr.reveal (
        '.blog-main .article__listing',
        {opacity: 0, duration: 1600, mobile: !0, viewFactor: 0}
      )), t (), s ();
  }
  function w () {
    $ ('.products .product .product__item').hover (
      function () {
        setTimeout (
          function () {
            $ (this).addClass ('phover');
          }.bind (this),
          200
        );
      },
      function () {
        setTimeout (
          function () {
            $ (this).removeClass ('phover');
          }.bind (this),
          200
        );
      }
    );
  }
  return {
    init: function () {
      var i, s, o, t, a, n, e, r, c;
      function l () {
        var e = $ ('.page-header').outerHeight (),
          t = $ (window).height (),
          i = $ ('#site-footer').height ();
        0 < t - e - i &&
          $ ('#site-content').css ({'min-height': t - e - i - 1}), $ (
          '#site-container'
        ).css ({'margin-bottom': i - 1});
      }
      $ ('#site-loader').length &&
        (NProgress.configure ({
          template: '<div class="bar" role="bar"></div>',
          parent: '#site-loader',
          showSpinner: !1,
          easing: 'ease',
          minimum: 0.3,
          speed: 500,
        }), NProgress.start (), $ (window).on ('pagehide', function (e) {
          e.persisted &&
            ($ ('#site-container')
              .addClass ('loading')
              .removeClass ('loaded'), $ ('#site-loader').removeClass (
              'loaded'
            ));
        }), $ (window).load (function (e) {
          $ ('#site-container')
            .addClass ('loaded')
            .removeClass (
              'loading'
            ), $ ('#site-loader').addClass ('loaded'), NProgress.done ();
        })), d (), 0 != $ ('.social-sharing').length &&
        void 0 !== $.fn.socialShare &&
        $ ('.social-sharing').each (function () {
          var e = $ (this);
          e.socialShare ({
            name: e.data ('name'),
            title: e.data ('title'),
            mediaUrl: e.data ('share_img'),
            social: e.data ('share_elem'),
            animation: 'launchpadReverse',
            blur: !0,
          });
        }), y (), $ (
        'body'
      ).on ('click', '.barberry-show-categories', function (e) {
        e.preventDefault ();
        var t, i, s, o = $ (this), a = o.closest ('.page-categories-wrapper');
        o.hasClass ('opened')
          ? ((t = new TimelineLite ()), (i = a.find (
              '.barberry-categories'
            )), (s = a.find ('.barberry-categories .category_item')), t.fromTo (
              i,
              1,
              {'max-height': 1e3, autoAlpha: 1},
              {autoAlpha: 0, 'max-height': 0, ease: Power3.easeInOut},
              0
            ), setTimeout (function () {
              o.removeClass ('opened'), i.removeClass ('opened');
            }, 700))
          : ((t = new TimelineLite ()), (i = a.find (
              '.barberry-categories'
            )), (s = a.find ('.barberry-categories .category_item')), t.fromTo (
              i,
              1,
              {'max-height': 0, autoAlpha: 0},
              {'max-height': 1e3, autoAlpha: 1, ease: Power4.easeIn},
              0
            ), t.staggerFromTo (
              s,
              1,
              {opacity: 0, scale: 2, skewX: 30},
              {opacity: 1, scale: 1, skewX: 0, ease: Power4.easeOut},
              0.1,
              0.3
            ), setTimeout (function () {
              i.addClass ('opened'), o.addClass ('opened');
            }, 500));
      }), roarLookbook.init (), $ (
        '.lookbook-section.is-slick_slider .lookbook-listing'
      ).length &&
        $ (
          '.lookbook-section.is-slick_slider .lookbook-listing'
        ).each (function () {
          var t = $ (this),
            i = {
              rtl: theme.settings.rtl,
              centerMode: !0,
              centerPadding: '20%',
              slidesToShow: 1,
              appendArrows: $ ('.slick-arrows', t.parent ()),
              prevArrow: '<button class="slick-prev" type="button"><svg class="svg-icon"><use xlink:href="#global__symbols-prev"></use></svg></button>',
              nextArrow: '<button class="slick-next" type="button"><svg class="svg-icon"><use xlink:href="#global__symbols-next"></use></svg></button>',
            },
            s = t.find ('.lookbook__item').length,
            o = setInterval (function () {
              var e = t.find ('img.image-preview').length;
              s <= e &&
                (t.imagesLoaded (function () {
                  setTimeout (function () {
                    t.slick (i);
                  }, 500);
                }), clearInterval (o));
            }, 300);
        }), $ ('[data-roarslider]').each (function () {
        var t = $ (this), e = 'revapi' + t.data ('roarslider');
        document.addEventListener (
          e,
          function (e) {
            t.addClass ('loaded');
          },
          !1
        );
      }), $ (document).off ('click', '.section__anchor'), $ (
        document
      ).on ('click', '.section__anchor', function (e) {
        e.preventDefault ();
        var t = $ (this).closest ('.container-section'),
          i = t.offset ().top + t.outerHeight ();
        $ ('.header-sticky__placeholder').length &&
          !$ ('.header-sticky__placeholder').hasClass ('hide') &&
          (i -= $ (
            '.header-sticky__placeholder'
          ).outerHeight ()), $ ('html, body').animate ({scrollTop: i}, 500, 'swing');
      }), (s = [
        {},
        {
          movement: {
            imgWrapper: {
              translation: {x: 10, y: 10, z: 30},
              rotation: {x: 0, y: -10, z: 0},
              reverseAnimation: {duration: 200, easing: 'easeOutQuad'},
            },
            lines: {
              translation: {x: 10, y: 10, z: [0, 70]},
              rotation: {x: 0, y: 0, z: -2},
              reverseAnimation: {duration: 2e3, easing: 'easeOutExpo'},
            },
            caption: {
              rotation: {x: 0, y: 0, z: 2},
              reverseAnimation: {duration: 200, easing: 'easeOutQuad'},
            },
            overlay: {
              translation: {x: 10, y: -10, z: 0},
              rotation: {x: 0, y: 0, z: 2},
              reverseAnimation: {duration: 2e3, easing: 'easeOutExpo'},
            },
            shine: {
              translation: {x: 100, y: 100, z: 0},
              reverseAnimation: {duration: 200, easing: 'easeOutQuad'},
            },
          },
        },
        {
          movement: {
            imgWrapper: {
              rotation: {x: -5, y: 10, z: 0},
              reverseAnimation: {duration: 900, easing: 'easeOutCubic'},
            },
            caption: {
              translation: {x: 30, y: 30, z: [0, 40]},
              rotation: {x: [0, 15], y: 0, z: 0},
              reverseAnimation: {duration: 1200, easing: 'easeOutExpo'},
            },
            overlay: {
              translation: {x: 10, y: 10, z: [0, 20]},
              reverseAnimation: {duration: 1e3, easing: 'easeOutExpo'},
            },
            shine: {
              translation: {x: 100, y: 100, z: 0},
              reverseAnimation: {duration: 900, easing: 'easeOutCubic'},
            },
          },
        },
        {
          movement: {
            imgWrapper: {
              rotation: {x: -5, y: 10, z: 0},
              reverseAnimation: {duration: 50, easing: 'easeOutQuad'},
            },
            caption: {
              translation: {x: 20, y: 20, z: 0},
              reverseAnimation: {duration: 200, easing: 'easeOutQuad'},
            },
            overlay: {
              translation: {x: 5, y: -5, z: 0},
              rotation: {x: 0, y: 0, z: 6},
              reverseAnimation: {duration: 1e3, easing: 'easeOutQuad'},
            },
            shine: {
              translation: {x: 50, y: 50, z: 0},
              reverseAnimation: {duration: 50, easing: 'easeOutQuad'},
            },
          },
        },
        {
          movement: {
            imgWrapper: {
              translation: {x: 0, y: -8, z: 0},
              rotation: {x: 3, y: 3, z: 0},
              reverseAnimation: {duration: 1200, easing: 'easeOutExpo'},
            },
            lines: {
              translation: {x: 15, y: 15, z: [0, 15]},
              reverseAnimation: {duration: 1200, easing: 'easeOutExpo'},
            },
            overlay: {
              translation: {x: 0, y: 8, z: 0},
              reverseAnimation: {duration: 600, easing: 'easeOutExpo'},
            },
            caption: {
              translation: {x: 10, y: -15, z: 0},
              reverseAnimation: {duration: 900, easing: 'easeOutExpo'},
            },
            shine: {
              translation: {x: 50, y: 50, z: 0},
              reverseAnimation: {duration: 1200, easing: 'easeOutExpo'},
            },
          },
        },
        {
          movement: {
            lines: {
              translation: {x: -5, y: 5, z: 0},
              reverseAnimation: {duration: 1e3, easing: 'easeOutExpo'},
            },
            caption: {
              translation: {x: 15, y: 15, z: 0},
              rotation: {x: 0, y: 0, z: 3},
              reverseAnimation: {
                duration: 1500,
                easing: 'easeOutElastic',
                elasticity: 700,
              },
            },
            overlay: {
              translation: {x: 15, y: -15, z: 0},
              reverseAnimation: {duration: 500, easing: 'easeOutExpo'},
            },
            shine: {
              translation: {x: 50, y: 50, z: 0},
              reverseAnimation: {duration: 500, easing: 'easeOutExpo'},
            },
          },
        },
        {
          movement: {
            imgWrapper: {
              translation: {x: 5, y: 5, z: 0},
              reverseAnimation: {duration: 800, easing: 'easeOutQuart'},
            },
            caption: {
              translation: {x: 10, y: 10, z: [0, 50]},
              reverseAnimation: {duration: 1e3, easing: 'easeOutQuart'},
            },
            shine: {
              translation: {x: 50, y: 50, z: 0},
              reverseAnimation: {duration: 800, easing: 'easeOutQuart'},
            },
          },
        },
        {
          movement: {
            lines: {
              translation: {x: 40, y: 40, z: 0},
              reverseAnimation: {duration: 1500, easing: 'easeOutElastic'},
            },
            caption: {
              translation: {x: 20, y: 20, z: 0},
              rotation: {x: 0, y: 0, z: -5},
              reverseAnimation: {duration: 1e3, easing: 'easeOutExpo'},
            },
            overlay: {
              translation: {x: -30, y: -30, z: 0},
              rotation: {x: 0, y: 0, z: 3},
              reverseAnimation: {duration: 750, easing: 'easeOutExpo'},
            },
            shine: {
              translation: {x: 100, y: 100, z: 0},
              reverseAnimation: {duration: 750, easing: 'easeOutExpo'},
            },
          },
        },
      ]), (i = 0), [].slice
        .call (document.querySelectorAll ('.tilter'))
        .forEach (function (e, t) {
          (i = t % 30 == 0 ? i + 1 : i), new TiltFx (e, s[i - 1]);
        }), $ ('.slick__gallery').each (function () {
        $ (this).slick ({
          rtl: theme.settings.rtl,
          prevArrow: '<button class="slick-prev" type="button"><svg class="svg-icon"><use xlink:href="#global__symbols-prev"></use></svg></button>',
          nextArrow: '<button class="slick-next" type="button"><svg class="svg-icon"><use xlink:href="#global__symbols-next"></use></svg></button>',
        });
      }), $ ('.soundcloud__audio').each (function () {
        var t = $ (this),
          e = {
            async: !0,
            crossDomain: !0,
            url: 'https://soundcloud.com/oembed',
            method: 'GET',
            headers: {},
            data: {format: 'json', url: t.data ('video')},
          };
        $.ajax (e).done (function (e) {
          t.replaceWith (e.html);
        });
      }), u (), $ (document).off ('click', '.header__toggle'), $ (
        document
      ).on ('click', '.header__toggle', function () {
        $ (this).toggleClass (
          'active'
        ), $ ('.collection-header ul').slideToggle ();
      }), $ ('.quickview_btn').length &&
        ($ (document).off ('click', '.quickview_btn'), $ (
          document
        ).on ('click', '.quickview_btn', function (e) {
          e.preventDefault ();
          var t = $ (this),
            i = t.data ('collection_handle'),
            s = t.data ('product_handle');
          t
            .closest ('.product__item')
            .find ('.product__image')
            .css ('background-image')
            .replace (/^url\(['"](.+)['"]\)/, '$1');
          $.ajax ({
            url: '/collections/' +
              i +
              '/products/' +
              s +
              '?view=quickview&cache=false',
            beforeSend: function () {
              t.addClass ('adding');
            },
            complete: function () {
              t.removeClass ('adding');
            },
            success: function (e) {
              $ ('.cd-quick-view .cd-content')
                .empty ()
                .html (e), setTimeout (function () {
                $ ('.cd-quick-view').addClass ('opened');
              }, 300), setTimeout (function () {
                $ ('body').addClass ('blurred').addClass ('quickview-opened');
              }, 500), theme.roarJs.productInfoAnimation (
                $ ('.cd-quick-view')
              ), new theme.Sections ().register (
                'product-quickview',
                theme.Product
              ), Shopify.PaymentButton.init ();
            },
          });
        }), $ (document).off ('click', '.cd-close, .cd-overlay'), $ (
          document
        ).on ('click', '.cd-close, .cd-overlay', function () {
          $ ('body')
            .removeClass ('blurred')
            .removeClass (
              'quickview-opened'
            ), $ ('.cd-quick-view').removeClass ('opened'), theme.ProductVideo.removeSectionVideos ('product-quickview-template'), theme.ProductModel.removeSectionModels ('product-quickview-template');
        }), $ (document).keyup (function (e) {
          '27' == e.which &&
            $ ('.cd-quick-view').hasClass ('opened') &&
            $ ('.cd-close').trigger ('click');
        })), $ ('.product__colors .swatch-item').length &&
        ($ (document).off ('click', '.product__colors .swatch-item'), $ (
          document
        ).on ('click', '.product__colors .swatch-item', function (e) {
          e.preventDefault ();
          var t, i, s = $ (this);
          s.hasClass ('active') ||
            ((t = s
              .closest ('.product__item')
              .find ('.product__image-featured')), (i = s.data (
              'bgset'
            )), t
              .attr ('data-bgset', i)
              .removeClass ('lazyloaded')
              .addClass ('lazyload'), s
              .closest ('.product__colors')
              .find ('.swatch-item')
              .removeClass ('active'), s.addClass ('active'));
        })), $ (document).off (
        'click',
        '.addcart_btn:not(.added), .product-form__cart-submit'
      ), $ (
        document
      ).on (
        'click',
        '.addcart_btn:not(.added), .product-form__cart-submit',
        function (e) {
          e.preventDefault ();
          var i = $ (this), t = i.closest ('form'), a = $ ('body');
          return 1 != theme.settings.cartAjax
            ? t.submit ()
            : $.ajax ({
                type: 'POST',
                url: '/cart/add.js',
                async: !0,
                cache: !1,
                data: t.serialize (),
                dataType: 'json',
                beforeSend: function () {
                  i.addClass ('adding');
                },
                success: function (o) {
                  if ('redirect' == theme.settings.afterAddition)
                    return !(window.location = '/cart');
                  theme.MiniCart.update ().promise ().done (function () {
                    var e = 0;
                    i.hasClass ('progress-btn') &&
                      (e = 500), i.addClass ('active'), setTimeout (function () {
                      i
                        .removeClass ('adding')
                        .text (i.data ('added'))
                        .addClass ('added'), e &&
                        setTimeout (function () {
                          i.removeClass ('active').removeClass ('added');
                        }, 2e3);
                    }, e);
                    var s = theme.settings.afterAddition, t = e ? e + 800 : 0;
                    (a.hasClass ('compare-opened') ||
                      a.hasClass ('quickview-opened')) &&
                      ((t = 0), (s = 'message')), setTimeout (function () {
                      switch (s) {
                        case 'minicart':
                          theme.MiniCart.open ();
                          break;
                        case 'message':
                          var e, t, i = o;
                          void 0 !== i.id
                            ? ((e = theme.Images.getSizedImageUrl (
                                i.image,
                                '200x'
                              )), (t = i.title), p (
                                e,
                                theme.strings.productAdded.replace (
                                  '{{ product_name }}',
                                  t
                                ),
                                !0
                              ))
                            : p ('alert', i.message + ': ' + i.description);
                      }
                    }, t);
                  });
                },
              }), !1;
        }
      ), $ (document).off ('click', '.product-form__cart-submit--grouped'), $ (
        document
      ).on ('click', '.product-form__cart-submit--grouped', function (e) {
        e.preventDefault ();
        var t = $ (this),
          i = t
            .closest ('.product-single__content')
            .find ('.product-single__grouped .product-form__input');
        return i.length &&
          ((Shopify.queue = []), i.each (function () {
            0 < parseInt ($ (this).val ()) &&
              Shopify.queue.push ({
                variantId: $ (this).data ('variant_id'),
                quantity: parseInt ($ (this).val ()),
              });
          }), (Shopify.moveAlong = function () {
            var e;
            Shopify.queue.length
              ? ((e = Shopify.queue.shift ()), Shopify.addItem (
                  e.variantId,
                  e.quantity,
                  e.properties,
                  Shopify.moveAlong
                ))
              : (t.removeClass (
                  'adding'
                ), theme.MiniCart.update (), 'redirect' ==
                  theme.settings.afterAddition
                  ? (location.href = '/cart')
                  : 'minicart' == theme.settings.afterAddition &&
                      theme.MiniCart.open ());
          }), (Shopify.addItem = function (e, t, i, s) {
            var o = {quantity: t, id: e};
            0 != i && (o.properties = i), $.ajax ({
              type: 'POST',
              url: '/cart/add.js',
              dataType: 'json',
              data: o,
              success: function () {
                'function' == typeof s && s ();
              },
              error: function () {},
            });
          }), Shopify.queue.length &&
            (t.addClass ('adding'), Shopify.moveAlong ())), !1;
      }), $ (document).off (
        'click',
        '.products-grid .product .options_btn'
      ), $ (
        document
      ).on ('click', '.products-grid .product .options_btn', function (e) {
        e.preventDefault (), $ (this).closest ('.product').addClass ('opened');
      }), $ (document).off ('click', '.products-grid .product .close_btn'), $ (
        document
      ).on ('click', '.products-grid .product .close_btn', function (e) {
        e.preventDefault (), $ (this).closest ('.product').removeClass ('opened');
      }), $ ('.addwishlist_btn').length &&
        ($ (document).off ('click', '.addwishlist_btn:not(.added)'), $ (
          document
        ).on ('click', '.addwishlist_btn:not(.added)', function (e) {
          e.preventDefault ();
          var t,
            i,
            s,
            o,
            a,
            n,
            r,
            c,
            l,
            d,
            u = $ (this),
            h = parseInt (u.data ('customer_id'));
          0 < h
            ? ((t = u.data ('shop_domain')), (i = parseInt (
                u.data ('product_id')
              )), (s = u.data ('product_handle').toString ()), t.length &&
                s.length &&
                i &&
                ((o = document.createElement ('form')).setAttribute (
                  'action',
                  '/contact'
                ), o.setAttribute ('method', 'POST'), o.setAttribute (
                  'style',
                  'display:none'
                ), (a = document.createElement ('input')).setAttribute (
                  'type',
                  'hidden'
                ), a.setAttribute ('name', 'customer'), a.setAttribute (
                  'value',
                  h
                ), (n = document.createElement ('input')).setAttribute (
                  'type',
                  'hidden'
                ), n.setAttribute ('name', 'shop'), n.setAttribute (
                  'value',
                  t
                ), (r = document.createElement ('input')).setAttribute (
                  'type',
                  'hidden'
                ), r.setAttribute ('name', 'id'), r.setAttribute (
                  'value',
                  i
                ), (c = document.createElement ('input')).setAttribute (
                  'type',
                  'hidden'
                ), c.setAttribute ('name', 'handle'), c.setAttribute (
                  'value',
                  s
                ), (l = document.createElement ('input')).setAttribute (
                  'type',
                  'hidden'
                ), l.setAttribute ('name', 'action'), l.setAttribute (
                  'value',
                  'add_wishlist'
                ), o.appendChild (a), o.appendChild (n), o.appendChild (
                  r
                ), o.appendChild (c), o.appendChild (l), $ ('body').append (
                  o
                ), (d = $ (o).serialize ()), $.ajax ({
                  type: 'POST',
                  url: '/a/wishlist',
                  async: !0,
                  cache: !1,
                  data: d,
                  dataType: 'json',
                  beforeSend: function () {
                    u.addClass ('adding');
                  },
                  complete: function () {
                    u.removeClass ('adding');
                  },
                  success: function (e) {
                    var t;
                    p ('check', theme.strings.wishlistAdded), u
                      .addClass ('added')
                      .find ('.tooltip')
                      .text (u.data ('added')), $ (o).remove (), 1 == e.code &&
                      ((t = parseInt (e.json))
                        ? $ ('.wishlist__count').removeClass ('hide').text (t)
                        : $ ('.wishlist__count').addClass ('hide').text (0));
                  },
                })))
            : (window.location = '/account/login');
        })), $ ('.removewishlist_btn').length &&
        ($ (document).off ('click', '.removewishlist_btn'), $ (
          document
        ).on ('click', '.removewishlist_btn', function () {
          var e,
            t,
            i,
            s,
            o,
            a,
            n,
            r,
            c = $ (this),
            l = parseInt (c.data ('customer_id'));
          0 < l
            ? ((e = c.data ('shop_domain')), (t = parseInt (
                c.data ('product_id')
              )), e.length &&
                t &&
                ((i = document.createElement ('form')).setAttribute (
                  'action',
                  '/contact'
                ), i.setAttribute ('method', 'POST'), i.setAttribute (
                  'style',
                  'display:none'
                ), (s = document.createElement ('input')).setAttribute (
                  'type',
                  'hidden'
                ), s.setAttribute ('name', 'customer'), s.setAttribute (
                  'value',
                  l
                ), (o = document.createElement ('input')).setAttribute (
                  'type',
                  'hidden'
                ), o.setAttribute ('name', 'shop'), o.setAttribute (
                  'value',
                  e
                ), (a = document.createElement ('input')).setAttribute (
                  'type',
                  'hidden'
                ), a.setAttribute ('name', 'product'), a.setAttribute (
                  'value',
                  t
                ), (n = document.createElement ('input')).setAttribute (
                  'type',
                  'hidden'
                ), n.setAttribute ('name', 'action'), n.setAttribute (
                  'value',
                  'remove_wishlist'
                ), i.appendChild (s), i.appendChild (o), i.appendChild (
                  a
                ), i.appendChild (n), $ ('body').append (i), (r = $ (
                  i
                ).serialize ()), $.ajax ({
                  type: 'POST',
                  url: '/a/wishlist',
                  async: !0,
                  cache: !1,
                  data: r,
                  dataType: 'json',
                  beforeSend: function () {
                    $ ('.wishlist__table').addClass ('loading');
                  },
                  complete: function () {
                    $ ('.wishlist__table').removeClass ('loading');
                  },
                  success: function (e) {
                    var t;
                    $ (i).remove (), 1 == e.code &&
                      ((t = parseInt (e.json))
                        ? c.closest ('tr').slideUp ('fast', function () {
                            $ (
                              this
                            ).remove (), p ('check', theme.strings.wishlistRemoved), $ ('.wishlist__count').removeClass ('hide').text (t);
                          })
                        : location.reload ());
                  },
                })))
            : (window.location = '/account/login');
        })), $ ('.page-wishlist .ajax_load_button .loadmore').length &&
        ($ (document).off (
          'click',
          '.page-wishlist .ajax_load_button .loadmore'
        ), $ (
          document
        ).on (
          'click',
          '.page-wishlist .ajax_load_button .loadmore',
          function () {
            var e,
              t,
              i = '.page-wishlist .ajax_load_button .loadmore',
              s = '.page-wishlist .ajax_load_button',
              o = '.page-wishlist .wishlist__item',
              a = '.page-wishlist .pagination';
            $ (a).find ('a.next').length
              ? ($ (i).attr ('data-processing', 1), (e = $ (a)
                  .find ('a.next')
                  .attr ('href')), (t = $ (i).data ('no_more')), $ (
                  s
                ).addClass ('loading'), $.get (e, function (e) {
                  $ (a)
                    .empty ()
                    .html (
                      $ (e).find (a).html ()
                    ), $ (e).find (o).each (function () {
                    $ (o).last ().after ($ (this));
                  }), $ (s).removeClass (
                    'loading'
                  ), $ (i).attr ('data-processing', 0), 0 == $ (a).find ('a.next').length && ($ (s).addClass ('ajax_load_finished').removeClass ('ajax_load_hidden'), $ (i).show ().html (t).addClass ('disabled').prop ('disabled', !0));
                }))
              : ((t = $ (i).attr ('data-no-more')), $ (s)
                  .addClass ('ajax_load_finished')
                  .removeClass ('ajax_load_hidden'), $ (i)
                  .show ()
                  .html (t)
                  .addClass ('disabled')
                  .prop ('disabled', !0));
          }
        )), (o = f ()).length &&
        $ ('.addcompare_btn').each (function () {
          var e = $ (this), t = e.data ('product_id');
          o.includes (t) &&
            e.addClass ('added').find ('.tooltip').text (e.data ('added'));
        }), v (), $ (document).off ('click', '.compare__close'), $ (
        document
      ).on ('click', '.compare__close', function () {
        m ();
      }), $ (document).keyup (function (e) {
        '27' == e.which && $ ('.compare__modal').hasClass ('opened') && m ();
      }), $ (document).off ('click', '.compare__link'), $ (
        document
      ).on ('click', '.compare__link', function () {
        var e = $ (this),
          t = f ()
            .map (function (e) {
              return 'id:' + e;
            })
            .join (' OR ');
        $.ajax ({
          url: '/search',
          data: {view: 'compare', type: 'product', q: t},
          dataType: 'html',
          type: 'GET',
          beforeSend: function () {
            e.addClass ('loading');
          },
          complete: function () {
            e.removeClass ('loading');
          },
          success: function (e) {
            h (e), v ();
          },
        });
      }), $ (document).off ('click', '.addcompare_btn'), $ (
        document
      ).on ('click', '.addcompare_btn', function (e) {
        e.preventDefault ();
        var t = $ (this), i = f (), s = t.data ('product_id');
        i.includes (s) ||
          i.unshift (
            s
          ), 10 <= i.length && p ('alert', theme.strings.compareLimit);
        var o = g (i)
          .map (function (e) {
            return 'id:' + e;
          })
          .join (' OR ');
        $.ajax ({
          url: '/search',
          data: {view: 'compare', type: 'product', q: o},
          dataType: 'html',
          type: 'GET',
          beforeSend: function () {
            t.removeClass ('added').addClass ('adding');
          },
          complete: function () {
            t.removeClass ('adding');
          },
          success: function (e) {
            h (e), t
              .addClass ('added')
              .find ('.tooltip')
              .text (t.data ('added')), v ();
          },
        });
      }), $ (document).off ('click', '.removecompare_btn'), $ (
        document
      ).on ('click', '.removecompare_btn', function (e) {
        e.preventDefault ();
        var t = $ (this),
          i = t.data ('product_id'),
          s = '.product__' + i,
          o = f ();
        o.includes (i) &&
          o.splice (
            o.indexOf (i),
            1
          ), g (o).length ? $ ('.compare__list ' + s).remove () : m (), (t = $ (s + ' .addcompare_btn')).removeClass ('added').find ('.tooltip').text (t.data ('tooltip')), v ();
      }), $ (document).off ('click', '.alert-message'), $ (
        document
      ).on ('click', '.alert-message', function () {
        $ (this).hide ();
        var e = 0, t = theme.settings.afterAddition;
        $ ('body').hasClass ('quickview-opened') &&
          ((t = 'message'), (e = 300), $ ('.cd-quick-view .cd-close').trigger (
            'click'
          )), $ (this).hasClass ('cart_message') &&
          'message' == t &&
          setTimeout (function () {
            theme.MiniCart.open ();
          }, e);
      }), $ (document).off ('click', '.password-login'), $ (
        document
      ).on ('click', '.password-login', function (e) {
        e.preventDefault (), $ ('body').addClass ('password-opened'), setTimeout (function () {
          $ ('.password-modal input').focus ();
        }, 250);
      }), $ (document).off (
        'click',
        '.password-modal .modal__close, .password__overlay'
      ), $ (
        document
      ).on (
        'click',
        '.password-modal .modal__close, .password__overlay',
        function () {
          $ ('body').removeClass ('password-opened');
        }
      ), $ (document).keyup (function (e) {
        27 == e.keyCode && $ ('body').removeClass ('password-opened');
      }), $ ('.password-modal').find ('.errors').length &&
        ($ ('body').addClass ('password-opened'), setTimeout (function () {
          $ ('.password-modal input').focus ();
        }, 250)), _ (), $ ('#site-footer').hasClass ('is-reveal') &&
        (l (), $ (window).resize (function () {
          l ();
        })), (r = $ ('.progress-section')), (c = $ ('.progress-page')).length &&
        r.length &&
        (r.append (c), $ ('.scrolltotop').on ('click', function () {
          return $ ('html, body').animate ({scrollTop: 0}, 800), !1;
        }), $ (window).scroll (function () {
          300 <= $ (window).scrollTop ()
            ? c.addClass ('is-active')
            : c.removeClass ('is-active');
        }), (t = 0), $ (window).scroll (function () {
          var e = $ (window).scrollTop ();
          t < e
            ? c.addClass ('is-visible')
            : e < t && c.removeClass ('is-visible'), (t = e);
        }), (a = document.querySelector (
          '.progress-page path'
        )), (n = a.getTotalLength ()), (a.style.transition = a.style.WebkitTransition =
          'none'), (a.style.strokeDasharray =
          n +
          ' ' +
          n), (a.style.strokeDashoffset = n), a.getBoundingClientRect (), (a.style.transition = a.style.WebkitTransition =
          'stroke-dashoffset 10ms linear'), (e = function () {
          var e = $ (window).scrollTop (),
            t = $ (document).height () - $ (window).height (),
            i = n - e * n / t;
          a.style.strokeDashoffset = i;
        }) (), $ (window).scroll (e)), w ();
    },
    bgSet: function (t) {
      if (t) {
        var i = t.width / t.height, s = '';
        return [
          180,
          360,
          540,
          720,
          900,
          1080,
          1296,
          1512,
          1728,
          1950,
          2048,
        ].forEach (function (e) {
          t.width > e &&
            (s +=
              theme.Images.getSizedImageUrl (t.src, e + 'x') +
              ' ' +
              e +
              'w ' +
              Math.round (e / i) +
              'h,');
        }), (s +=
          theme.Images.getSizedImageUrl (t.src, 'master') +
          ' ' +
          t.width +
          'w ' +
          t.height +
          'h');
      }
    },
    backHistory: function () {
      history.go (-1);
    },
    initReviews: function () {
      'undefined' != typeof jQuery &&
        'undefined' != typeof SPR &&
        (SPR.registerCallbacks (), SPR.initRatingHandler (), SPR.initDomEls (), SPR.loadProducts (), SPR.loadBadges ());
    },
    splitText: t,
    animationProduct: s,
    productInfoAnimation: i,
    fixtooltipHover: w,
  };
}) ()), $ (document).ready (function () {
  var e = new theme.Sections ();
  e.register (
    'cart-template',
    theme.Cart
  ), e.register ('cart-gift', theme.CartGift), e.register ('shipping-calculator', theme.ShippingCalculator), e.register ('collection-template', theme.Filters), e.register ('sidebar-sticky', theme.SidebarSticky), e.register ('product-template', theme.Product), e.register ('header-mobile', theme.HeaderMobile), e.register ('header-section', theme.HeaderSection), e.register ('map', theme.Maps), e.register ('slideshow-section', theme.SlideshowSection), e.register ('line_item', theme.LineItem), e.register ('instagram', theme.Instagram), e.register ('countdown-timer', theme.CountdownTimer), e.register ('products-slider', theme.ProductsSlider), e.register ('product-tabs', theme.ProductTabs), e.register ('newsletter-popup', theme.NewsletterPopup), e.register ('lookbook-section', theme.LookbookSection), e.register ('rich-banner', theme.RichBanner), e.register ('collections-slider', theme.CollectionsSlider);
}), (theme.init = function () {
  theme.roarJs.init (), theme.customerTemplates.init (), $ (
    'a[href="#"]'
  ).on ('click', function (e) {
    e.preventDefault ();
  }), $ (document).one ('touchstart', function () {
    theme.Helpers.setTouch ();
  });
}), $ (theme.init), $ (
  '#shopify-product-reviews'
).on ('DOMSubtreeModified', function () {
  var e = $ (this);
  !e.hasClass ('customized') &&
    e.find ('.spr-reviews').length &&
    (e.addClass ('customized'), setTimeout (function () {
      e.find ('.spr-header').append (e.find ('.spr-reviews'));
    }, 300));
});
